/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 40);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

(function (window, undefined) {
  'use strict';
  angular.module('cbl.telepass.wa').constant('TLPS_CONSTANTS', {
    BASE_ROOT: '/CBL-TELEPASS-WA/app/',
    REST_ROOT: '/CBL-TELEPASS-MF/services/api-',
    REST_CLIENTI_ROOT: '/MSF-PROSPECTMANAGER-MF/api/',
    COMPONENTS_PATH: 'components/',
    SSOREADY_BROADCAST_CODE: 'brio3-run-telepass',
    REST: {
      GENERAL: {
        LABEL: 'generale/label',
        TAB: 'generale/tab',
        USER: 'generale/utente',
        LOG: 'generale/log',
        FIELDCONFIGURATOR: 'generale/fieldConfigurator',
      },
      ANAGRAFICA: {
        RECUPERA: 'anagrafica/anagrafica',
      },
      CONTOCORRENTE: {
        RICERCA_CONTICORRENTE: 'contocorrente/conti',
      },
      PRODOTTO: {
        DETTAGLIO_PRODOTTO: 'prodotti/prodotto/',
        CODICE: 'TLPS',
      },
      PRATICA: {
        CREA_PRATICA: 'pratica/pratica',
        SALVA_PRATICA: 'pratica/pratica/',
        PROSEGUI: 'pratica/{idPratica}/avanti',
        INDIETRO: 'pratica/{idPratica}/indietro',
        DETTAGLIO_PRATICA: 'pratica/',
        ANNULLA_PRATICA: 'pratica/pratica/{idPratica}/annulla',
        COMPLETA_PRATICA: 'pratica/completaPratica',
        RIFIUTA_PRATICA: 'pratica/pratica/{idPratica}/rifiuta',
        RISOTTOMETTI_PRATICA: 'pratica/pratica/{idPratica}/risottometti',
      },
      DOMINI: 'dominio/domini/',
      QUESTIONARI: {
        RECUPERA_QUESTIONARI: 'questionari/questionari',
      },
      CONFIGURAZIONI: {
        DOMINI: 'configurazioni/domini/',
        RECUPERA_MODALITA_RITIRO: 'configurazioni/modalitaRitiro',
        VERIFICA_PROMOZIONI: 'configurazioni/verificaPromozioni',
        RECUPERA_OPZIONI_TELEPASS: 'configurazioni/opzione',
      },
      APPROVVIGIONAMENTO: {
        SOGLIE: 'approvvigionamento/soglie',
        AGGIORNA_APPARATO: 'approvvigionamento/ordine/{idOrdine}/riscontro/{codApparato}',
        ORDINI: 'approvvigionamento/ordini',
        ORDINE: 'approvvigionamento/ordine/{idOrdine}',
        APPARATO_PRESA_CARICO: 'approvvigionamento/apparato/presacarico',
        APPARATO_QUANTITA: 'approvvigionamento/apparato/quantita',
        FLUSSO_FILIALE: 'approvvigionamento/apparato/quantita/filiale',
        CHIUDI_FLUSSO: 'approvvigionamento/ordine/{idOrdine}/chiudi',
      },
      POST_VENDITA: {
        RECUPERA_CONTRATTI_CLIENTE: 'postvendita/contratti/',
        REVOCA: 'postvendita/revoca',
        RECUPERA_CARTE_VIACARD: 'postvendita/carteViacard/',
        RESTITUISCI_CARTE: 'postvendita/restituzione',
        AGGIUNGI_CARTE: 'postvendita/aggiunta',
        MODIFICA_CONTO: 'postvendita/modificaIban',
      },
    },
    STATO_PRATICA: {
      IN_CORSO: 'INCORSO',
      CONSOLIDATA: 'CONSOLIDATA',
      PRESENTATA: 'PRESENTATA',
      DAREVISIONARE: 'DAREVISIONARE',
      RIFIUTATA: 'RIFIUTATA',
      VALUTAZIONE: 'VALUTAZIONE',
      ACCETTATA: 'ACCETTATA',
    },
    SPECIALIZZAZIONE_PRATICA: {
      RESTITUZIONE_VIACARD: 'RESTITUZIONE_VIACARD',
      REVOCA_TELEPASS: 'REVOCA_TELEPASS',
      TRASLOCO_TELEPASS: 'TRASLOCO_TELEPASS',
      ALLESTIMENTO_VIACARD: 'PRATICAVIACARD',
      ALLESTIMENTO_TELEPASS: 'PRATICATELEPASS',
      AGGIUNTA_VIACARD: 'AGGIUNTA_VIACARD',
      MODIFICA_CONTO_TELEPASS: 'MODIFICA_CONTO_TELEPASS',
    },
  });
})(window);


/***/ }),
/* 1 */
/***/ (function(module, exports) {

/**
 * @ngdoc overview
 * @name cbl.telepass.wa
 * @description Modulo funzionale dell'applicazione Credito Assicurativo PMI
 */
(function () {
  'use strict';
  angular.module('cbl.telepass.wa', [
    '$scope',
    'ui.router',
    'ui.bootstrap',
    'ui.grid',
    'ui.grid.autoResize',
    'ui.grid.cellNav',
    'ui.grid.edit',
    'ui.grid.exporter',
    'ui.grid.grouping',
    'ui.grid.pagination',
    'ui.grid.resizeColumns',
    'ui.grid.rowEdit',
    'ui.grid.selection',
    'ui.grid.treeView',
    'cbl.telepass.wa.directives',
    'cbl.common',
    'ngSanitize',
  ]);
})();


/***/ }),
/* 2 */
/***/ (function(module, exports) {

/**
 *
 */

(function(window, undefined) {
  'use strict';
  var Route = function($stateProvider, $urlRouterProvider) {
    var onEnter = [
      'CblMessageSrvc',
      function(messaggiSrvc) {
        messaggiSrvc.reset();
      }
    ];

    $stateProvider
      .state('tlps-proposta', {
        url: '/propostaProdottiTelepass/:ndg/:idProdotto/:idPratica',
        template: '<tlps-proposta ' + 'class="wrapper"></tlps-proposta>',
        onEnter: onEnter,
        ncyBreadcrumb: {
          label: 'Proposta Prodotti Telepass',
          parent: 'schedaCliente'
        }
      })
      .state('tlps-configurazione-soglie', {
        url: '/configurazioneSoglieTelepass/',
        template:
          '<configurazione-soglie ' +
          'class="wrapper"></configurazione-soglie>',
        onEnter: onEnter,
        ncyBreadcrumb: {
          label: 'Configurazione Soglie',
          parent: 'home'
        }
      })
      .state('tlps-visualizzazione-apparati', {
        url: '/visualizzazioneApparatiTelepass/',
        template:
          '<visualizzazione-apparati ' +
          'class="wrapper"></visualizzazione-apparati>',
        onEnter: onEnter,
        ncyBreadcrumb: {
          label: 'Visualizzazione Apparati',
          parent: 'home'
        }
      })
      .state('tlps-presa-carico', {
        url: '/presaInCaricoTelepass/',
        template: '<presa-in-carico ' + 'class="wrapper"></presa-in-carico>',
        onEnter: onEnter,
        ncyBreadcrumb: {
          label: 'Presa in Carico Apparati',
          parent: 'home'
        }
      })
      .state('tlps-post-vendita', {
        url: '/postVenditaTelepass/:ndg/:idPratica',
        template: '<tlps-post-vendita class="wrapper"></tlps-post-vendita>',
        onEnter: onEnter,
        ncyBreadcrumb: {
          label: 'Post Vendita Telepass',
          parent: 'schedaCliente'
        }
      })
      .state('tlps-post-vendita-trasloco', {
        url: '/postVenditaTelepassTrasloco/:ndg/:idPratica',
        template:
          '<tlps-trasloco-telepass class="wrapper"></tlps-trasloco-telepass>',
        onEnter: onEnter,
        ncyBreadcrumb: {
          label: 'Post Vendita Telepass',
          parent: 'schedaCliente'
        }
      });
  };

  Route.$inject = ['$stateProvider', '$urlRouterProvider'];

  angular.module('cbl.telepass.wa').config(Route);
})(window);


/***/ }),
/* 3 */
/***/ (function(module, exports) {

(function (window, undefined) {
  'use strict';
  var Run = function (
    $rootScope,
    $http,
    $q,
    userSrvc,
    messaggiFctr,
    labelSrvc,
    loggerSrvc,
    CONSTANTS,
    ssocoreServices
  ) {
    var userSrvcDefer = $q.defer();
    var labelSrvcDefer = $q.defer();
    userSrvc.abilitazioniPronte = userSrvcDefer.promise;
    labelSrvc.labelsPronte = labelSrvcDefer.promise;

    // Mi metto in ascolto dell'evento run-telepass che viene emesso quando
    // il token è stato arricchito con le informazioni necessarie per i
    // filtri delle API. Una volta che il token è stato aggiornato lancio le
    // chiamate per l'avvio dell'applicazione.
    $rootScope.$on('brio3-run-telepass', function (event, error) {
      startApplication();
    });

    var startApplication = function () {
      ssocoreServices.caricaContesto(
        function (response) {
          if (
            ssocoreServices.caricaFunzionalita(response, 'presaInCaricoBanca')
          ) {
            userSrvc.presaInCaricoBanca = true;
          }
          if (
            ssocoreServices.caricaFunzionalita(response, 'presaInCaricoFiliale')
          ) {
            userSrvc.presaInCaricoFiliale = true;
          }
          if (
            ssocoreServices.caricaFunzionalita(response, 'configurazioneSoglie')
          ) {
            userSrvc.configurazioneSoglie = true;
          }
          if (
            ssocoreServices.caricaFunzionalita(
              response,
              'visualizzazioneApparati'
            )
          ) {
            userSrvc.visualizzazioneApparati = true;
          }

          startAbilitazioniPromise();
          startLabelsPromise();
          startLoggerPromise();
        },
        function (reason) {}
      );
    };

    var startAbilitazioniPromise = function () {
      $http({
        method: 'GET',
        url: CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.USER,
      }).then(
        function (response) {
          if (messaggiFctr.processaResponse(response)) {
            userSrvcDefer.reject(response);
            return;
          }
          userSrvc.user = response.data.result.profile;
          userSrvc.abilitazioni = response.data.abilitazioni;
          userSrvcDefer.resolve(true);
        },
        function (reason) {
          messaggiFctr.processaResponse(reason);
          userSrvcDefer.reject(reason);
        }
      );
    };

    var startLabelsPromise = function () {
      $http({
        method: 'GET',
        url: CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.LABEL,
      }).then(
        function (response) {
          if (messaggiFctr.processaResponse(response)) {
            labelSrvcDefer.reject(response);
            return;
          }
          labelSrvc.labels = response.data.result;
          labelSrvcDefer.resolve(true);
        },
        function (reason) {
          messaggiFctr.processaResponse(reason);
          labelSrvcDefer.reject(reason);
        }
      );
    };

    var startLoggerPromise = function () {
      $http({
        method: 'GET',
        url: CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.LOG,
      }).then(
        function (response) {
          if (messaggiFctr.processaResponse(response)) {
            return;
          }
          loggerSrvc.setupLogger(response.data.result);
          // FIXME: riabilitare per gestire correttamente i permessi
          labelSrvc.develop = loggerSrvc.levelEnabled(loggerSrvc.FINE);
        },
        function (reason) {
          messaggiFctr.processaResponse(reason);
        }
      );
    };
  };

  Run.$inject = [
    '$rootScope',
    '$http',
    '$q',
    'TlpsUserSrvc',
    'TlpsMessaggiFctr',
    'TlpsLabelSrvc',
    'TlpsLoggerSrvc',
    'TLPS_CONSTANTS',
    'ssocoreServices',
  ];
  angular.module('cbl.telepass.wa').run(Run);
})(window);


/***/ }),
/* 4 */
/***/ (function(module, exports) {

/**
 *
 */
(function() {
  'use strict';
  angular.module('cbl.telepass.wa').service('TlpsDomainSrvc', [
    '$http',
    '$q',
    'TlpsMessaggiFctr',
    'TLPS_CONSTANTS',
    function($http, $q, messaggiFctr, CONSTANTS) {
      this.domains = {};

      this.getDomain = function(domain, skipBlank, filter) {
        if (this.domains === undefined) {
          this.domains = {};
        }
        if (
          this.domains[domain] === undefined ||
          this.domains[domain].length === 0
        ) {
          // chiamata Rest al servizio di recupero dominio in caso non sia
          // gia' memorizzato
          var self = this;
          $http({
            method: 'GET',
            url: CONSTANTS.REST_ROOT + CONSTANTS.REST.DOMINI,
            params: {
              codiceDominio: domain.toUpperCase(),
              params: filter
            }
          }).then(
            function(response) {
              if (messaggiFctr.processaResponse(response)) {
                return;
              }
              self.domains[domain] = [];
              if (!skipBlank) {
                self.domains[domain].push({
                  key: '',
                  value: 'Seleziona...'
                });
              }
              for (var i in response.data.result) {
                self.domains[domain].push(response.data.result[i]);
              }
            },
            function(reason) {
              messaggiFctr.processaResponse(reason);
            }
          );
        }
        return this.domains[domain];
      };

      this.promiseDomain = function(domain, filtro, filtroAggiuntivo) {
        var deferred = $q.defer();

        var self = this;
        $http({
          method: 'GET',
          url:
            CONSTANTS.REST_ROOT + CONSTANTS.REST.CONFIGURAZIONI.DOMINI + domain,
          params: {
            filtro: filtro,
            filtroAggiuntivo: filtroAggiuntivo
          }
        }).then(
          function(response) {
            if (messaggiFctr.processaResponse(response)) {
              return;
            }
            self.domains[domain] = [];

            for (var j in response.data.result) {
              self.domains[domain].push(response.data.result[j]);
            }

            deferred.resolve(self.domains[domain]);
          },
          function(reason) {
            deferred.reject(reason);
            messaggiFctr.processaResponse(reason);
          }
        );

        return deferred.promise;
      };

      // this.promiseCascading = function (domain, cascading, skipBlank) {
      // 	var deferred = $q.defer();

      // 	var self = this;
      // 	var cascadingDomain = [];
      // 	$http({
      // 		method: "GET",
      // 		url: CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.DOMAIN,
      // 		cache: true,
      // 		params: {
      // 			table: domain.toUpperCase(),
      // 			params: cascading
      // 		}
      // 	}).then(function (response) {
      // 		if (messaggiFctr.processaResponse(response)) {
      // 			deferred.reject(response);
      // 			return;
      // 		}
      // 		if (!skipBlank) {
      // 			cascadingDomain.push({
      // 				cod: "",
      // 				dsc: "Seleziona..."
      // 			});
      // 		}
      // 		for (var i in response.data.result) {
      // 			cascadingDomain.push(response.data.result[i]);
      // 		}
      // 		deferred.resolve(cascadingDomain);
      // 	}, function (reason) {
      // 		messaggiFctr.processaResponse(reason);
      // 		deferred.reject(reason);
      // 	});

      // 	return deferred.promise;
      // };

      // this.promiseEccezioni = function (domain, cascading, skipBlank) {
      // 	var deferred = $q.defer();

      // 	var self = this;
      // 	var cascadingDomain = [];
      // 	$http({
      // 		method: "GET",
      // 		url: CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.DOMAIN,
      // 		cache: true,
      // 		params: {
      // 			table: domain.toUpperCase(),
      // 			params: cascading
      // 		}
      // 	}).then(function (response) {
      // 		if (messaggiFctr.processaResponse(response)) {
      // 			deferred.reject(response);
      // 			return;
      // 		}
      // 		if (!skipBlank) {
      // 			cascadingDomain.push({
      // 				cod: "",
      // 				dsc: "Seleziona..."
      // 			});
      // 		}
      // 		for (var i in response.data.result) {
      // 			cascadingDomain.push(response.data.result[i]);
      // 		}
      // 		deferred.resolve({
      // 			cod: cascading,
      // 			ecz: cascadingDomain
      // 		});
      // 	}, function (reason) {
      // 		messaggiFctr.processaResponse(reason);
      // 		deferred.reject(reason);
      // 	});

      // 	return deferred.promise;
      // };

      this.getLabel = function(domain, key) {
        if (!this.domains) {
          return '';
        }
        var array = this.domains[domain];
        if (!array) {
          return '';
        }
        for (var i in array) {
          if (array[i].cod === key) {
            return array[i].dsc;
          }
        }
        return '';
      };
    }
  ]);
})();


/***/ }),
/* 5 */
/***/ (function(module, exports) {

/**
 *
 */
(function() {
  angular.module('cbl.telepass.wa').service('TlpsLabelSrvc', [
    function() {
      this.labels = [];
      var self = this;
      this.develop = true;
      this.loading = true;
      this.labelsPronte;

      this.getLabel = function(label) {
        var res = self.labels[label];
        if (!res) {
          res = '';
          if (self.develop) {
            res += ' [' + label + ']';
          }
        }
        return res;
      };
    }
  ]);
})();


/***/ }),
/* 6 */
/***/ (function(module, exports) {

/**
 *
 */
(function() {
  'use strict';
  angular.module('cbl.telepass.wa').service('TlpsLoggerSrvc', [
    '$http',
    'TLPS_CONSTANTS',
    function($http, CONSTANTS) {
      /**
       * Constants
       */
      this.SEVERE = 'SEVERE';
      this.WARNING = 'WARNING';
      this.INFO = 'INFO';
      this.CONFIG = 'CONFIG';
      this.FINE = 'FINE';
      this.FINER = 'FINER';
      this.FINEST = 'FINEST';
      var LEVELS = [
        this.FINEST,
        this.FINER,
        this.FINE,
        this.CONFIG,
        this.INFO,
        this.WARNING,
        this.SEVERE
      ];

      /**
       * Default value
       */
      this.loggerLevelString = this.FINEST;

      this.loggerLevel = LEVELS.indexOf(this.loggerLevelString);

      this.setupLogger = function(baseLevel) {
        if (LEVELS.indexOf(baseLevel) !== -1) {
          this.loggerLevelString = baseLevel;
        }
        this.loggerLevel = LEVELS.indexOf(this.loggerLevelString);
      };

      this.levelEnabled = function(level) {
        return this.loggerLevel <= LEVELS.indexOf(level);
      };

      this.formattaMessaggio = function(logPayload) {
        var message = '';
        if (typeof logPayload !== 'string') {
          if (Object.prototype.toString.call(logPayload) === '[object Array]') {
            for (var idx in logPayload) {
              if (typeof logPayload[idx] === 'string') {
                message += ' ' + logPayload[idx];
              } else {
                message += ' ' + JSON.stringify(logPayload[idx]);
              }
            }
          } else {
            message += JSON.stringify(logPayload);
          }
          return message;
        } else {
          return logPayload;
        }
      };

      this.log = function(controller, type, message) {
        message = this.formattaMessaggio(message);

        var level = LEVELS.indexOf(type);

        if (level < this.loggerLevel) {
          return;
        }

        $http({
          method: 'POST',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.LOG,
          data: {
            level: type,
            msg: message,
            ctrl: controller
          }
        });
      };
    }
  ]);
})();


/***/ }),
/* 7 */
/***/ (function(module, exports) {

/**
 *
 */
(function () {
  'use strict';
  angular.module('cbl.telepass.wa').factory('TlpsMessaggiFctr', [
    'CblMessageSrvc',
    'TlpsLabelSrvc',
    'TlpsLoggerSrvc',
    function (messaggiSrvc, labelSrvc, loggerSrvc) {
      var processaResponse = function (response) {
        if (response.length > 0) {
          var respError;
          for (var index in response) {
            respError = this.processaResponse(response[index]);
            if (respError) {
              return true;
            }
          }
          return false;
        }

        if (
          response.data.errors &&
          response.data.errors.length === 0 &&
          (response.data.result === null || response.data.result === undefined)
        ) {
          var message = {
            message: 'Nessuna risposta ricevuta dal servizio'
          };
          messaggiSrvc.pushErrorMessage(message.message);
          return true;
        }
        var hasError = false;

        if (response.data && response.data.errors) {
          if (response.data.errors.length > 0) {
            for (var i in response.data.errors) {
              messaggiSrvc.pushErrorMessage(response.data.errors[i].message);
              console.error(response.data.errors[i].message);
            }
            hasError = response.data.errors.length > 0;
          }
          if (response.data.warnings.length > 0) {
            for (var k in response.data.warnings) {
              messaggiSrvc.pushWarningMessage(response.data.warnings[k].message);
            }
          }
          if (response.data.info.length > 0) {
            for (var z in response.data.info) {
              messaggiSrvc.pushInfoMessage(response.data.info[z].message);
            }
          }
        }
        if (response.status === 504) {
          messaggiSrvc.pushErrorMessage(labelSrvc.getLabel('errors.gatewaytimeout'));
          return true;
        }
        if (response.status === 400) {
          messaggiSrvc.pushErrorMessage(response.data.messageList.messages[0].message);
        }
        return hasError;
      };

      var addMessage = function (message) {
        if (message.type === 'E' || message.type === 'F') {
          messaggiSrvc.pushErrorMessage(message.message);
        } else if (message.type === 'W') {
          messaggiSrvc.pushWarningMessage(message.message);
        } else {
          messaggiSrvc.pushInfoMessage(message.message);
        }
      };

      var resetMessages = function () {
        messaggiSrvc.reset();
      };

      return {
        processaResponse: processaResponse,
        addMessage: addMessage,
        resetMessages: resetMessages
      };
    }
  ]);
})();


/***/ }),
/* 8 */
/***/ (function(module, exports) {

/**
 *
 */
(function(window, undefined) {
  'use strict';
  var TlpsUserSrvc = function() {
    this.user;
    this.abilitazioni;
    this.abilitazioniPronte;
    this.labelsPronte;
    this.presaInCaricoBanca;
    this.presaInCaricoFiliale;
    this.configurazioneSoglie;
    this.visualizzazioneApparati;
  };

  TlpsUserSrvc.$inject = [];

  angular.module('cbl.telepass.wa').service('TlpsUserSrvc', TlpsUserSrvc);
})(window);


/***/ }),
/* 9 */
/***/ (function(module, exports) {

/**
 * @ngdoc directive
 * @name cbl.telepass.wa.directive:tlpsDefinizioneProdotto
 * @restrict E
 * @description Componente che gestisce le configurazione Soglie del'Approvvigionamento Telepass
 */
(function() {
  'use strict';
  var ConfigurazioneSoglieCtrl = function(
    $scope,
    $stateParams,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    propostaTelepassSrvc,
    userSrvc,
    uiGridConstants,
    configurazioneSoglieSrvc
    // propostaDefinizioneSrvc
  ) {
    this.$stateParams = $stateParams;
    this.messaggiFctr = messaggiFctr;
    this.CONSTANTS = CONSTANTS;
    this.userSrvc = userSrvc;
    $scope.msg = labelSrvc.getLabel;
    this.uiGridConstants = uiGridConstants;
    this.configurazioneSoglieSrvc = configurazioneSoglieSrvc;

    this.propostaTelepassSrvc = propostaTelepassSrvc;
    // this.propostaDefinizioneSrvc = propostaDefinizioneSrvc;

    // Spinner
    this.spinner = this.propostaTelepassSrvc.spinner;

    this.gridOptions = {};
    this.gridOptions2 = {};

    this.stiliTabella = {
      height: '0px',
      width: '0px'
    };

    this.tableHeight = 0;
    this.tableWidth = 0;

    this.filiali = [];

    var self = this;

    /*
     * -------------------------------------
     *          GESTIONE INTERFACCIA
     * -------------------------------------
     */

    /*
     * -------------------------------------
     * METODI INIZIALIZZAZIONE
     * -------------------------------------
     */

    this.init = function() {
      labelSrvc.labelsPronte.then(function() {
        self.labelsPronte = true;
        self.spinner.showSpinner = true;
        self.configurazioneSoglieSrvc
          .promiseRecuperaSoglie()
          .then(
            function(response) {
              if (self.messaggiFctr.processaResponse(response)) {
                self.spinner.showSpinner = false;
                return;
              }
              self.filiali = response.data.result;

              self.gridOptions2 = {
                enableSorting: true,
                enableVerticalScrollbar: self.uiGridConstants.scrollbars.NEVER,
                enableHorizontalScrollbar:
                  self.uiGridConstants.scrollbars.NEVER,
                columnDefs: [
                  { name: 'filiale', field: 'filiale' },
                  { name: 'descrizione', field: 'descrizione' },
                  {
                    name: 'soglia',
                    field: 'value',
                    enableCellEdit: false,
                    cellTemplate:
                      '<div style="margin:2px;height:100px;">\
                    <form name="inputForm">\
                    <input type="text" ng-model="MODEL_COL_FIELD" style="height: 25px;padding: 2px" cc-numeric>\
                    </form></div>'
                  }
                ],
                data: self.filiali.sogliaList
              };

              self.tableHeight = self.filiali.sogliaList.length * 30 + 40;

              self.stiliTabella = {
                height: self.tableHeight + 'px',
                width: '50%'
              };

              // Configurazione tabella
              self.gridOptions = {
                enableSorting: true,
                enableColumnMenus: false,
                enableGrouping: false,
                multiSelect: false,
                showHeader: true,
                enableRowHeaderSelection: false,
                enableRowSelection: true,
                // enableRowSelection: !self.propostaTelepassSrvc.isPraticaNavigabile(),
                showGridFooter: false,
                enableVerticalScrollbar: self.uiGridConstants.scrollbars.NEVER,
                enableHorizontalScrollbar:
                  self.uiGridConstants.scrollbars.NEVER,
                enableColumnResizing: true,
                enableCellEditing: false,
                columnDefs: [
                  {
                    displayName: 'Filiale',
                    field: 'filiale',
                    width: '25%',
                    name: 'filiale',
                    enableCellEdit: false
                  },
                  {
                    displayName: 'Descrizione',
                    field: 'descrizione',
                    width: '50%',
                    name: 'descrizione',
                    enableCellEdit: false
                  },
                  {
                    displayName: 'Soglia',
                    field: 'value',
                    width: '25%',
                    name: 'soglia',
                    enableCellEdit: true,
                    enableCellEditOnFocus: true
                    // cellTemplate: '<input> {{row.entity.value}}</input>'
                  }
                ],
                data: self.filiali.sogliaList,
                onRegisterApi: function(gridApi) {
                  //   self.gridApi = gridApi;
                  //   self.gridApi.grid.modifyRows(self.gridOptions.data);
                  //   // Se era già stato salvato il conto corrente lo recupero e lo seleziono
                  //   if (
                  //     self.propostaTelepassSrvc.datiPratica &&
                  //     self.propostaTelepassSrvc.datiPratica.numeroRapporto
                  //   ) {
                  //     angular.forEach(self.contiCorrenti, function(conto, index) {
                  //       if (
                  //         conto.numeroRapporto ===
                  //         self.propostaTelepassSrvc.datiPratica.numeroRapporto
                  //       ) {
                  //         self.gridApi.selection.selectRow(self.contiCorrenti[index]);
                  //         self.contoSelezionato = self.contiCorrenti[index];
                  //       }
                  //     });
                  //   }
                  //   gridApi.selection.on.rowSelectionChanged($scope, function(row) {
                  //     self.selezionaConto(row);
                  //   });
                }
              };
            },
            function(reason) {
              if (self.messaggiFctr.processaResponse(reason)) {
                self.spinner.showSpinner = false;
              }
            }
          )
          .finally(function() {
            self.spinner.showSpinner = false;
          });
      });
    };

    /**
     * @ngdoc method
     * @name salvaSoglie
     * @methodOf cbl.telepass.wa:TlpsConfigurazioneSoglieCmpt
     * @description Esegue le chiamate per salvare le soglie.
     */
    this.salvaSoglie = function(soglie) {
      self.spinner.showSpinner = true;

      self.configurazioneSoglieSrvc
        .promiseSalvaSoglie(soglie)
        .then(
          function(response) {
            if (self.messaggiFctr.processaResponse(response)) {
              self.spinner.showSpinner = false;
              return;
            }

            if (response.data.result) {
              // Sostituisco i dati della pratica con quelli aggiornati che mi ritornano i servizi
              self.filiali = response.data.result;
              self.init();
            }
          },
          function(error) {
            if (self.messaggiFctr.processaResponse(error)) {
              self.spinner.showSpinner = false;
            }
          }
        )
        .finally(function() {
          self.spinner.showSpinner = false;
        });
    };

    /*
     * -------------------------------------
     *        INIZIALIZZAZIONE
     * -------------------------------------
     */
    self.init();
  };

  ConfigurazioneSoglieCtrl.$inject = [
    '$scope',
    '$stateParams',
    'TLPS_CONSTANTS',
    'TlpsLabelSrvc',
    'TlpsMessaggiFctr',
    'TlpsPropostaSrvc',
    'TlpsUserSrvc',
    'uiGridConstants',
    'TlpsConfigurazioneSoglieSrvc'
    // 'TlpsDefinizioneSrvc'
  ];

  var TemplateUrl = function(CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'tlpsApprovvigionamento/configurazioneSoglie/configurazioneSoglie.html'
    );
  };

  TemplateUrl.$inject = ['TLPS_CONSTANTS'];

  var configurazioneSoglieComponent = {
    bindings: {
      steps: '<',
      currentStep: '<'
    },
    controller: ConfigurazioneSoglieCtrl,
    controllerAs: 'configurazioneSoglieCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.telepass.wa')
    .component('configurazioneSoglie', configurazioneSoglieComponent);
})();


/***/ }),
/* 10 */
/***/ (function(module, exports) {

/**
 * @ngdoc service
 * @name cbl.telepass.wa.directive:tlpsProposta
 * @restrict E
 * @scope
 * @description Servizio che gestisce le configurazione delle soglie
 */
(function() {
  angular.module('cbl.telepass.wa').service('TlpsConfigurazioneSoglieSrvc', [
    '$http',
    'TlpsMessaggiFctr',
    'TLPS_CONSTANTS',
    'TlpsLabelSrvc',
    function($http, messaggiFctr, CONSTANTS, labelSrvc) {
      this.$http = $http;
      this.messaggiFctr = messaggiFctr;
      this.labelSrvc = labelSrvc;

      var self = this;

      /*
       * -------------------------------------
       *           PROMISE SERVIZI REST
       * -------------------------------------
       */

      /**
       * @ngdoc method
       * @name recuperaSoglie
       * @methodOf cbl.telepass.wa:configurazioneSoglieSrvc
       * @description Recupera la lista di filiale e le corrispondenti soglie
       */
      this.promiseRecuperaSoglie = function() {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.APPROVVIGIONAMENTO.SOGLIE
        });
      };

      /**
       * @ngdoc method
       * @name promiseSalvaSoglie
       * @methodOf cbl.telepass.wa:TlpsConfigurazioneSoglieSrvc
       * @description Effettua una chiamata http per aggiornare le soglie
       * @return {Promise} - Ritorna una promise contenente il dettaglio delle soglie
       */
      this.promiseSalvaSoglie = function(soglie) {
        return this.$http({
          method: 'PUT',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.APPROVVIGIONAMENTO.SOGLIE,
          data: soglie
        });
      };
    }
  ]);
})();


/***/ }),
/* 11 */
/***/ (function(module, exports) {

/**
 * @ngdoc directive
 * @name cbl.telepass.wa.directive:tlpsDefinizioneProdotto
 * @restrict E
 * @description Componente che gestisce le configurazione Soglie del'Approvvigionamento Telepass
 */
(function() {
  'use strict';
  var PresaInCaricoCtrl = function(
    $scope,
    $stateParams,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    propostaTelepassSrvc,
    userSrvc,
    uiGridConstants,
    presaInCaricoSrvc
    // propostaDefinizioneSrvc
  ) {
    this.$stateParams = $stateParams;
    this.messaggiFctr = messaggiFctr;
    this.CONSTANTS = CONSTANTS;
    this.userSrvc = userSrvc;
    $scope.msg = labelSrvc.getLabel;
    this.uiGridConstants = uiGridConstants;
    this.presaInCaricoSrvc = presaInCaricoSrvc;

    this.propostaTelepassSrvc = propostaTelepassSrvc;
    // this.propostaDefinizioneSrvc = propostaDefinizioneSrvc;

    // Spinner
    this.spinner = this.propostaTelepassSrvc.spinner;

    this.gridOptions = {};

    this.stiliTabella = {
      height: '0px',
      width: '0px'
    };

    this.tableHeight = 0;
    this.tableWidth = 0;

    this.templatePresaInCarico = null;

    this.ricerca = {
      stato: '',
      dataDal: '',
      dataAl: ''
    };

    this.minDate = null;
    this.maxDate = null;

    this.flusso = {};

    this.gestioneApparatiFl = false;

    var self = this;

    /*
     * -------------------------------------
     *          GESTIONE INTERFACCIA
     * -------------------------------------
     */

    /*
     * -------------------------------------
     * METODI INIZIALIZZAZIONE
     * -------------------------------------
     */

    this.init = function() {
      labelSrvc.labelsPronte.then(function() {
        self.labelsPronte = true;
        // self.templatePresaInCarico = 'presaInCaricoBanca.tmpl.html';
        // self.templatePresaInCarico = 'presaInCaricoFiliale.tmpl.html';

        self.userSrvc.presaInCaricoBanca;

        if (
          self.userSrvc.presaInCaricoFiliale &&
          !self.userSrvc.presaInCaricoBanca
        ) {
          self.templatePresaInCarico = 'presaInCaricoFiliale.tmpl.html';
        } else if (
          !self.userSrvc.presaInCaricoFiliale &&
          self.userSrvc.presaInCaricoBanca
        ) {
          self.templatePresaInCarico = 'presaInCaricoBanca.tmpl.html';
        } else {
          self.templatePresaInCarico = 'presaInCaricoFiliale.tmpl.html';
        }

        // self.userSrvc.abilitazioniPronte.then(function(result) {
        //   if (!result) {
        //     self.templatePresaInCarico = 'presaInCaricoFiliale.tmpl.html';
        //     return;
        //   }
        //   if (self.userSrvc.user.ruolo !== 'DF') {
        //     self.templatePresaInCarico = 'presaInCaricoFiliale.tmpl.html';
        //   } else {
        //     self.templatePresaInCarico = 'presaInCaricoBanca.tmpl.html';
        //   }
        // });
      });
    };

    /*
     * -------------------------------------
     *        INIZIALIZZAZIONE
     * -------------------------------------
     */
    self.init();
  };

  PresaInCaricoCtrl.$inject = [
    '$scope',
    '$stateParams',
    'TLPS_CONSTANTS',
    'TlpsLabelSrvc',
    'TlpsMessaggiFctr',
    'TlpsPropostaSrvc',
    'TlpsUserSrvc',
    'uiGridConstants',
    'TlpsPresaInCaricoSrvc'
    // 'TlpsDefinizioneSrvc'
  ];

  var TemplateUrl = function(CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'tlpsApprovvigionamento/presaInCarico/presaInCarico.html'
    );
  };

  TemplateUrl.$inject = ['TLPS_CONSTANTS'];

  var presaInCaricoComponent = {
    bindings: {
      steps: '<',
      currentStep: '<'
    },
    controller: PresaInCaricoCtrl,
    controllerAs: 'presaInCaricoCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.telepass.wa')
    .component('presaInCarico', presaInCaricoComponent);
})();


/***/ }),
/* 12 */
/***/ (function(module, exports) {

/**
 * @ngdoc directive
 * @name cbl.telepass.wa.directive:tlpsDefinizioneProdotto
 * @restrict E
 * @description Componente che gestisce le configurazione Soglie del'Approvvigionamento Telepass
 */
(function() {
  'use strict';
  var PresaInCaricoBancaCtrl = function(
    $scope,
    $stateParams,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    propostaTelepassSrvc,
    userSrvc,
    uiGridConstants,
    presaInCaricoBancaSrvc,
    $q,
    domainSrvc,
    $state
    // propostaDefinizioneSrvc
  ) {
    this.$stateParams = $stateParams;
    this.messaggiFctr = messaggiFctr;
    this.CONSTANTS = CONSTANTS;
    this.userSrvc = userSrvc;
    $scope.msg = labelSrvc.getLabel;
    this.uiGridConstants = uiGridConstants;
    this.presaInCaricoBancaSrvc = presaInCaricoBancaSrvc;
    this.$q = $q;
    this.domainSrvc = domainSrvc;
    this.$state = $state;

    this.propostaTelepassSrvc = propostaTelepassSrvc;
    // this.propostaDefinizioneSrvc = propostaDefinizioneSrvc;

    // Spinner
    this.spinner = this.propostaTelepassSrvc.spinner;

    this.gridOptions = {};

    this.stiliTabella = {
      height: '0px',
      width: '0px'
    };

    this.datepicker = {
      isOpen: false,
      dateOptions: {
        formatDay: 'dd',
        formatMonth: 'MM',
        formatYear: 'yyyy',
        startingDay: 1
      }
    };

    this.datepickerD = {
      isOpen: false,
      dateOptions: {
        formatDay: 'dd',
        formatMonth: 'MM',
        formatYear: 'yyyy',
        startingDay: 1
      }
    };

    this.tableHeight = 0;
    this.tableWidth = 0;

    this.ricerca = {
      stato: '',
      dataDal: '',
      dataAl: ''
    };

    this.minDate = null;
    this.maxDate = null;

    this.flusso = {};

    this.gestioneApparatiFl = false;

    this.flussi = [];

    /**
     * Riferimento alle API della griglia di ricerca
     */
    this.gridApi = null;

    var self = this;

    /*
     * -------------------------------------
     *          GESTIONE INTERFACCIA
     * -------------------------------------
     */

    /**
     * @ngdoc method
     * @name controllaApparatoInFlusso
     * @methodOf cbl.telepass.wa:presaInCaricoBancaCtrl
     * @description Controlla se il codice del apparato appartiene al flusso selezionato
     */
    this.controllaApparatoInFlusso = function(apparato) {
      for (var i in self.flusso.apparati) {
        if (self.flusso.apparati[i].codice === apparato.codice) {
          return true;
        }
      }
      var message = {};
      message.type = 'E';
      message.message =
        'Il codice apparato non appartiene al flusso selezionato'; //chiedere messaggio corretto
      messaggiFctr.addMessage(message);
      return false;
    };

    /**
     * @ngdoc method
     * @name controllaDatiValidi
     * @methodOf cbl.telepass.wa:presaInCaricoBancaCtrl
     * @description Controlla se il codice del apparato appartiene al flusso selezionato
     */
    this.controllaDatiValidi = function(apparato) {
      if (!apparato) {
        var message = {};
        message.type = 'E';
        message.message = 'Codice apparato e stato apparato non valorizzati'; //chiedere messaggio corretto
        messaggiFctr.addMessage(message);
        return false;
      }
      if (apparato && !apparato.codice) {
        var message = {};
        message.type = 'E';
        message.message = 'Codice apparato non valorizzato'; //chiedere messaggio corretto
        messaggiFctr.addMessage(message);
        return false;
      }
      if (apparato && !apparato.stato) {
        var message = {};
        message.type = 'E';
        message.message = 'Stato apparato non valorizzato'; //chiedere messaggio corretto
        messaggiFctr.addMessage(message);
        return false;
      }
      return true;
    };

    /**
     * @ngdoc method
     * @name salva
     * @methodOf cbl.telepass.wa:presaInCaricoBancaCtrl
     * @description Aggiorna lo stato del apparato
     */
    this.salva = function(apparato) {
      self.messaggiFctr.resetMessages();

      if (!self.controllaDatiValidi(apparato)) {
        return;
      }

      if (!self.controllaApparatoInFlusso(apparato)) {
        return;
      }

      self.spinner.showSpinner = true;

      self.presaInCaricoBancaSrvc
        .promiseAggiornaStatoApparato(self.flusso.id, apparato)
        .then(
          function(response) {
            self.spinner.showSpinner = false;

            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }

            if (response.data.result) {
              self.apparato = {};
              self.gestioneApparatiFl = true;
              self.selezionaFlusso(self.flusso, true);
            }
          },
          function(error) {
            self.spinner.showSpinner = false;
            self.messaggiFctr.processaResponse(error);
          }
        );
    };

    this.chiudi = function(apparato) {
      self.messaggiFctr.resetMessages();
      self.spinner.showSpinner = true;

      self.presaInCaricoBancaSrvc.promiseChiudiFlusso(self.flusso).then(
        function(response) {
          self.spinner.showSpinner = false;

          if (self.messaggiFctr.processaResponse(response)) {
            return;
          }

          if (response.data.result) {
            var message = {};
            message.type = 'I';
            message.message = 'Ordine chiuso correttamente';
            self.messaggiFctr.addMessage(message);

            self.dettaglioFlusso = {};
            self.gestioneApparatiFl = false;

            // Aggiorno i flussi
            self.ricercaPresaInCaricoBanca(self.ricerca, self.flusso);
          }
        },
        function(error) {
          self.spinner.showSpinner = false;
          self.messaggiFctr.processaResponse(error);
        }
      );
    };

    /**
     * @ngdoc method
     * @name selezionaFlusso
     * @methodOf cbl.telepass.wa:tlpsDefinizioneProdotto
     * @description Seleziona o deseleziona il conto corrente su cui aprire la pratica
     */
    this.selezionaFlusso = function(flusso, flSalva) {
      if (!flSalva) {
        self.messaggiFctr.resetMessages();
        self.gestioneApparatiFl = false;

        if (
          !Object.keys(self.flusso).length ||
          flusso.entity.id !== self.flusso.id
        ) {
          self.flusso = flusso.entity;
        }
      }

      self.spinner.showSpinner = true;

      self.presaInCaricoBancaSrvc
        .promiseRecuperaFlussoDettaglio(self.flusso.id)
        .then(function(response) {
          if (self.messaggiFctr.processaResponse(response)) {
            self.spinner.showSpinner = false;
            return;
          }
          self.dettaglioFlusso = response.data.result;
        })
        .finally(function() {
          self.spinner.showSpinner = false;
        });
    };

    this.gestisci = function(flusso) {
      self.gestioneApparatiFl = true;
    };

    this.ricercaPresaInCaricoBanca = function(ricerca, flussoPreselezionato) {
      self.messaggiFctr.resetMessages();

      self.flusso = {};
      self.dettaglioFlusso = {};
      self.gestioneApparatiFl = false;

      if (!ricerca.stato) {
        ricerca.stato = null;
      }

      var dataDal = null;
      var dataAl = null;
      if (ricerca.dataDal) {
        var dataDalDay = ricerca.dataDal
          .getDate()
          .toString()
          .padStart(2, '0');
        var dataDalMonth = (ricerca.dataDal.getMonth() + 1)
          .toString()
          .padStart(2, '0');
        var dataDalYear = ricerca.dataDal.getFullYear();
        dataDal = dataDalYear + '-' + dataDalMonth + '-' + dataDalDay;
      }

      if (ricerca.dataAl) {
        var dataAlDay = ricerca.dataAl
          .getDate()
          .toString()
          .padStart(2, '0');
        var dataAlMonth = (ricerca.dataAl.getMonth() + 1)
          .toString()
          .padStart(2, '0');
        var dataAlYear = ricerca.dataAl.getFullYear();
        dataAl = dataAlYear + '-' + dataAlMonth + '-' + dataAlDay;
      }

      self.spinner.showSpinner = true;
      self.presaInCaricoBancaSrvc
        .promiseRecuperaFlussi(ricerca.stato, dataDal, dataAl)
        .then(
          function(response) {
            self.spinner.showSpinner = false;

            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }

            self.flussi = response.data.result;
            self.tableHeight = self.flussi.length * 30 + 40;

            self.stiliTabella = {
              height: self.tableHeight + 'px'
              // width: '800px'
            };

            // Configurazione tabella
            self.gridOptions = {
              enableSorting: true,
              enableColumnMenus: false,
              enableGrouping: false,
              multiSelect: false,
              // showHeader: true,
              enableRowHeaderSelection: false,
              enableRowSelection: true,
              // enableRowSelection: !self.propostaTelepassSrvc.isPraticaNavigabile(),
              // showGridFooter: false,
              enableVerticalScrollbar: self.uiGridConstants.scrollbars.NEVER,
              enableHorizontalScrollbar: self.uiGridConstants.scrollbars.NEVER,
              enableColumnResizing: false,
              // enableCellEditing: false,
              columnDefs: [
                {
                  displayName: 'Data',
                  field: 'data',
                  width: '25%',
                  name: 'data'
                },
                {
                  displayName: 'Flusso',
                  field: 'id',
                  width: '25%',
                  name: 'flusso'
                },
                {
                  displayName: 'Stato',
                  field: 'stato.descrizione',
                  width: '25%',
                  name: 'stato'
                },
                {
                  displayName: 'Quantità',
                  field: 'quantita',
                  width: '25%',
                  name: 'quantita'
                }
              ],
              data: self.flussi,
              onRegisterApi: function(gridApi) {
                self.gridApi = gridApi;
                self.gridApi.selection.on.rowSelectionChanged($scope, function(
                  row
                ) {
                  self.selezionaFlusso(row);
                });
              }
            };

            // Se ho preselezionato un flusso, lo riseleziono
            if (
              flussoPreselezionato &&
              self.gridApi &&
              self.gridOptions.data &&
              self.gridOptions.data.length > 0
            ) {
              for (var i = 0; i < self.gridOptions.data.length; i++) {
                if (self.gridOptions.data[i].id === flussoPreselezionato.id) {
                  self.gridApi.grid.modifyRows(self.gridOptions.data);
                  self.gridApi.selection.selectRow(self.gridOptions.data[i]);
                }
              }
            }
          },
          function(reason) {
            self.spinner.showSpinner = false;
            self.messaggiFctr.processaResponse(reason);
          }
        );
    };

    /*
     * -------------------------------------
     * METODI INIZIALIZZAZIONE
     * -------------------------------------
     */

    this.init = function() {
      document.body.style.overflowY = 'scroll';
      labelSrvc.labelsPronte.then(function() {
        self.spinner.showSpinner = true;
        self.labelsPronte = true;
        $q.all([
          self.domainSrvc.promiseDomain('APPARATO'),
          self.domainSrvc.promiseDomain('ORDINE'),
          self.domainSrvc.promiseDomain('MAGAZZINO')
        ])
          .then(function(responses) {
            self.statiFlussi = responses[1];
            self.statiApparato = responses[0];
          })
          .finally(function() {
            self.spinner.showSpinner = false;
          });
      });
    };

    /*
     * -------------------------------------
     *        INIZIALIZZAZIONE
     * -------------------------------------
     */
    self.init();
  };

  PresaInCaricoBancaCtrl.$inject = [
    '$scope',
    '$stateParams',
    'TLPS_CONSTANTS',
    'TlpsLabelSrvc',
    'TlpsMessaggiFctr',
    'TlpsPropostaSrvc',
    'TlpsUserSrvc',
    'uiGridConstants',
    'TlpsPresaInCaricoBancaSrvc',
    '$q',
    'TlpsDomainSrvc',
    '$state'
    // 'TlpsDefinizioneSrvc'
  ];

  var TemplateUrl = function(CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'tlpsApprovvigionamento/presaInCarico/presaInCaricoBanca/presaInCaricoBanca.html'
    );
  };

  TemplateUrl.$inject = ['TLPS_CONSTANTS'];

  var presaInCaricoBancaComponent = {
    bindings: {
      steps: '<',
      currentStep: '<'
    },
    controller: PresaInCaricoBancaCtrl,
    controllerAs: 'presaInCaricoBancaCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.telepass.wa')
    .component('presaInCaricoBanca', presaInCaricoBancaComponent);
})();


/***/ }),
/* 13 */
/***/ (function(module, exports) {

/**
 * @ngdoc service
 * @name cbl.telepass.wa.directive:tlpsProposta
 * @restrict E
 * @scope
 * @description Servizio che gestisce le configurazione la presa in carico degli apparati
 */
(function() {
  angular.module('cbl.telepass.wa').service('TlpsPresaInCaricoBancaSrvc', [
    '$http',
    'TlpsMessaggiFctr',
    'TLPS_CONSTANTS',
    'TlpsLabelSrvc',
    function($http, messaggiFctr, CONSTANTS, labelSrvc) {
      this.$http = $http;
      this.messaggiFctr = messaggiFctr;
      this.labelSrvc = labelSrvc;

      var self = this;

      /*
       * -------------------------------------
       *           PROMISE SERVIZI REST
       * -------------------------------------
       */

      /**
       * @ngdoc method
       * @name promiseRecuperaFlussi
       * @methodOf cbl.telepass.wa:presaInCaricoBancaSrvc
       * @description Recupera la lista dei flussi
       */
      this.promiseRecuperaFlussi = function(stato, dataInizio, dataFine) {
        var qryParams = {
          stato: stato,
          dataInizio: dataInizio,
          dataFine: dataFine
        };

        return this.$http({
          method: 'GET',
          // url: CONSTANTS.REST_ROOT + CONSTANTS.REST.APPROVVIGIONAMENTO.SOGLIE
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.APPROVVIGIONAMENTO.ORDINI,
          params: qryParams
        });
      };

      /**
       * @ngdoc method
       * @name promiseRecuperaFlussoDettaglio
       * @methodOf cbl.telepass.wa:presaInCaricoBancaSrvc
       * @description Recupera la il dettaglio del flusso
       */
      this.promiseRecuperaFlussoDettaglio = function(idOrdine) {
        return this.$http({
          method: 'GET',
          url:
            CONSTANTS.REST_ROOT +
            CONSTANTS.REST.APPROVVIGIONAMENTO.ORDINE.replace(
              '{idOrdine}',
              idOrdine
            )
        });
      };

      /**
       * @ngdoc method
       * @name promiseRecuperaStatoFlusso
       * @methodOf cbl.telepass.wa:presaInCaricoBancaSrvc
       * @description Recupera gli stati dei flussi (aperto o chiuso)
       */
      this.promiseRecuperaStatoFlusso = function() {
        // return this.$http({
        //   method: 'PUT',
        //   url:
        //     CONSTANTS.REST_ROOT +
        //     CONSTANTS.REST.CONFIGURAZIONI.RECUPERA_MODALITA_RITIRO
        // });
        //manca servizio
      };

      /**
       * @ngdoc method
       * @name promiseRecuperaStatoApparato
       * @methodOf cbl.telepass.wa:presaInCaricoBancaSrvc
       * @description Recupera gli stati degli apparati (presi in carico o danneggiati)
       */
      this.promiseRecuperaStatoApparato = function() {
        // return this.$http({
        //   method: 'PUT',
        //   url:
        //     CONSTANTS.REST_ROOT +
        //     CONSTANTS.REST.CONFIGURAZIONI.RECUPERA_MODALITA_RITIRO
        // });
        //manca servizio
      };

      /**
       * @ngdoc method
       * @name promiseAggiornaStatoApparato
       * @methodOf cbl.telepass.wa:presaInCaricoBancaSrvc
       * @description Aggiorna il stato del'apparato (preso in carico o danneggiato)
       */
      this.promiseAggiornaStatoApparato = function(idOrdine, apparato) {
        apparato.stato = JSON.parse(apparato.stato);

        var url = CONSTANTS.REST.APPROVVIGIONAMENTO.AGGIORNA_APPARATO.replace(
          '{idOrdine}',
          idOrdine
        );
        url = url.replace('{codApparato}', apparato.codice);

        return this.$http({
          method: 'PUT',
          url: CONSTANTS.REST_ROOT + url,
          data: apparato
          // params: qryParams
        });
      };

      /**
       * @ngdoc method
       * @name promiseChiudiFlusso
       * @methodOf cbl.telepass.wa:presaInCaricoBancaSrvc
       * @description Aggiorna il stato del'apparato (preso in carico o danneggiato)
       */
      this.promiseChiudiFlusso = function(flusso) {
        var url = CONSTANTS.REST.APPROVVIGIONAMENTO.CHIUDI_FLUSSO.replace(
          '{idOrdine}',
          flusso.id
        );

        return this.$http({
          method: 'PUT',
          url: CONSTANTS.REST_ROOT + url,
          data: flusso
        });
      };

      /**
       * @ngdoc method
       * @name promisePrendeInCaricoBancaApparato
       * @methodOf cbl.telepass.wa:presaInCaricoBancaSrvc
       * @description Prende in carico l'apparato (in stato preso in carico)
       */
      this.promisePrendeInCaricoBancaApparato = function(apparato) {
        apparato.stato = JSON.parse(apparato.stato);
        return this.$http({
          method: 'PUT',
          url:
            CONSTANTS.REST_ROOT +
            CONSTANTS.REST.APPROVVIGIONAMENTO.APPARATO_PRESA_CARICO,
          data: apparato
        });
      };

      /**
       * @ngdoc method
       * @name salvaSoglie
       * @methodOf cbl.telepass.wa:TlpsConfigurazioneSoglieSrvc
       * @description Esegue le chiamate per salvare le soglie.
       */
      this.salvaSoglie = function(soglie) {
        // self.spinner.showSpinner = true;

        self
          .promiseSalvaSoglie(soglie)
          .then(
            function(response) {
              if (self.messaggiFctr.processaResponse(response)) {
                // self.spinner.showSpinner = false;
                return;
              }
              if (response.data.result) {
                // Sostituisco i dati della pratica con quelli aggiornati che mi ritornano i servizi
                self.filiali = response.data.result;
              }
            },
            function(error) {
              if (self.messaggiFctr.processaResponse(error)) {
                // self.spinner.showSpinner = false;
                return;
              }
            }
          )
          .finally(function() {
            // self.spinner.showSpinner = false;
          });
      };

      /**
       * @ngdoc method
       * @name promiseSalvaSoglie
       * @methodOf cbl.telepass.wa:TlpsConfigurazioneSoglieSrvc
       * @description Effettua una chiamata http per aggiornare le soglie
       * @return {Promise} - Ritorna una promise contenente il dettaglio delle soglie
       */
      this.promiseSalvaSoglie = function(soglie) {
        return this.$http({
          method: 'PUT',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.APPROVVIGIONAMENTO.SOGLIE,
          data: soglie
        });
      };
    }
  ]);
})();


/***/ }),
/* 14 */
/***/ (function(module, exports) {

/**
 * @ngdoc directive
 * @name cbl.telepass.wa.directive:tlpsDefinizioneProdotto
 * @restrict E
 * @description Componente che gestisce le configurazione Soglie del'Approvvigionamento Telepass
 */
(function() {
  'use strict';
  var PresaInCaricoFilialeCtrl = function(
    $scope,
    $stateParams,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    propostaTelepassSrvc,
    userSrvc,
    uiGridConstants,
    presaInCaricoFilialeSrvc,
    $q,
    domainSrvc,
    $state
    // propostaDefinizioneSrvc
  ) {
    this.$stateParams = $stateParams;
    this.messaggiFctr = messaggiFctr;
    this.CONSTANTS = CONSTANTS;
    this.userSrvc = userSrvc;
    $scope.msg = labelSrvc.getLabel;
    this.uiGridConstants = uiGridConstants;
    this.presaInCaricoFilialeSrvc = presaInCaricoFilialeSrvc;
    this.$q = $q;
    this.domainSrvc = domainSrvc;
    this.$state = $state;

    this.propostaTelepassSrvc = propostaTelepassSrvc;
    // this.propostaDefinizioneSrvc = propostaDefinizioneSrvc;

    // Spinner
    this.spinner = this.propostaTelepassSrvc.spinner;

    this.gridOptions = {};

    this.stiliTabella = {
      height: '0px',
      width: '0px'
    };

    this.tableHeight = 0;
    this.tableWidth = 0;

    this.ricerca = {
      stato: '',
      dataDal: '',
      dataAl: ''
    };

    this.gestioneApparatiFl = false;

    var self = this;

    /*
     * -------------------------------------
     *          GESTIONE INTERFACCIA
     * -------------------------------------
     */

    this.salva = function(apparato) {
      self.messaggiFctr.resetMessages();
      self.spinner.showSpinner = true;

      self.presaInCaricoFilialeSrvc
        .promisePrendeInCaricoBancaApparato(apparato)
        .then(
          function(response) {
            if (self.messaggiFctr.processaResponse(response)) {
              self.spinner.showSpinner = false;
              return;
            }
            if (response.data.result) {
              //controlla se il stato del apparato è preso in carico e chiama al servizio
              // self.prendeInCaricoFilialeApparato(response.data.result);
              var message = {};
              message.type = 'I';
              message.message = 'Apparato caricato in magazzino';
              self.messaggiFctr.addMessage(message);
              self.recuperaDettaglioFlusso();
            }
          },
          function(error) {
            if (self.messaggiFctr.processaResponse(error)) {
              self.spinner.showSpinner = false;
              return;
            }
          }
        )
        .finally(function() {
          self.spinner.showSpinner = false;
        });
    };

    this.gestisci = function(dettaglioFlusso) {
      if (!dettaglioFlusso) {
        return;
      }
      self.gestioneApparatiFl = true;
    };

    this.recuperaDettaglioFlusso = function() {
      self.presaInCaricoFilialeSrvc
        .promiseRecuperaDettaglioFlusso()
        .then(function(response) {
          if (self.messaggiFctr.processaResponse(response)) {
            self.spinner.showSpinner = false;
            return;
          }
          self.dettaglioFlusso = response.data.result.quantitaSoglie[0];
        });
    };

    /*
     * -------------------------------------
     * METODI INIZIALIZZAZIONE
     * -------------------------------------
     */

    this.init = function() {
      self.messaggiFctr.resetMessages();
      self.spinner.showSpinner = true;

      labelSrvc.labelsPronte.then(function() {
        self.labelsPronte = true;

        self.recuperaDettaglioFlusso();

        $q.all([
          self.domainSrvc.promiseDomain('APPARATO'),
          self.domainSrvc.promiseDomain('ORDINE'),
          self.domainSrvc.promiseDomain('MAGAZZINO')
        ])
          .then(function(responses) {
            self.statiFlussi = responses[1];
            self.statiApparato = responses[0];
          })
          .finally(function() {
            self.spinner.showSpinner = false;
          });
      });
    };

    /*
     * -------------------------------------
     *        INIZIALIZZAZIONE
     * -------------------------------------
     */
    self.init();
  };

  PresaInCaricoFilialeCtrl.$inject = [
    '$scope',
    '$stateParams',
    'TLPS_CONSTANTS',
    'TlpsLabelSrvc',
    'TlpsMessaggiFctr',
    'TlpsPropostaSrvc',
    'TlpsUserSrvc',
    'uiGridConstants',
    'TlpsPresaInCaricoFilialeSrvc',
    '$q',
    'TlpsDomainSrvc',
    '$state'
    // 'TlpsDefinizioneSrvc'
  ];

  var TemplateUrl = function(CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'tlpsApprovvigionamento/presaInCarico/presaInCaricoFiliale/presaInCaricoFiliale.html'
    );
  };

  TemplateUrl.$inject = ['TLPS_CONSTANTS'];

  var presaInCaricoFilialeComponent = {
    bindings: {
      steps: '<',
      currentStep: '<'
    },
    controller: PresaInCaricoFilialeCtrl,
    controllerAs: 'presaInCaricoFilialeCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.telepass.wa')
    .component('presaInCaricoFiliale', presaInCaricoFilialeComponent);
})();


/***/ }),
/* 15 */
/***/ (function(module, exports) {

/**
 * @ngdoc service
 * @name cbl.telepass.wa.directive:tlpsProposta
 * @restrict E
 * @scope
 * @description Servizio che gestisce le configurazione la presa in carico degli apparati
 */
(function() {
  angular.module('cbl.telepass.wa').service('TlpsPresaInCaricoFilialeSrvc', [
    '$http',
    'TlpsMessaggiFctr',
    'TLPS_CONSTANTS',
    'TlpsLabelSrvc',
    function($http, messaggiFctr, CONSTANTS, labelSrvc) {
      this.$http = $http;
      this.messaggiFctr = messaggiFctr;
      this.labelSrvc = labelSrvc;

      var self = this;

      /*
       * -------------------------------------
       *           PROMISE SERVIZI REST
       * -------------------------------------
       */

      /**
       * @ngdoc method
       * @name promiseRecuperaFlussi
       * @methodOf cbl.telepass.wa:presaInCaricoFilialeSrvc
       * @description Recupera la lista dei flussi
       */
      this.promiseRecuperaDettaglioFlusso = function() {
        return this.$http({
          method: 'GET',
          // url: CONSTANTS.REST_ROOT + CONSTANTS.REST.APPROVVIGIONAMENTO.SOGLIE
          url:
            CONSTANTS.REST_ROOT +
            CONSTANTS.REST.APPROVVIGIONAMENTO.FLUSSO_FILIALE
          // params: qryParams
        });
      };

      /**
       * @ngdoc method
       * @name promisePrendeInCaricoBancaApparato
       * @methodOf cbl.telepass.wa:presaInCaricoBancaSrvc
       * @description Prende in carico l'apparato (in stato preso in carico)
       */
      this.promisePrendeInCaricoBancaApparato = function(apparato) {
        apparato.stato = JSON.parse(apparato.stato);
        return this.$http({
          method: 'PUT',
          url:
            CONSTANTS.REST_ROOT +
            CONSTANTS.REST.APPROVVIGIONAMENTO.APPARATO_PRESA_CARICO,
          data: apparato
        });
      };
    }
  ]);
})();


/***/ }),
/* 16 */
/***/ (function(module, exports) {

/**
 * @ngdoc service
 * @name cbl.telepass.wa.directive:tlpsProposta
 * @restrict E
 * @scope
 * @description Servizio che gestisce le configurazione la presa in carico degli apparati
 */
(function() {
  angular.module('cbl.telepass.wa').service('TlpsPresaInCaricoSrvc', [
    '$http',
    'TlpsMessaggiFctr',
    'TLPS_CONSTANTS',
    'TlpsLabelSrvc',
    function($http, messaggiFctr, CONSTANTS, labelSrvc) {
      this.$http = $http;
      this.messaggiFctr = messaggiFctr;
      this.labelSrvc = labelSrvc;

      var self = this;

      /*
       * -------------------------------------
       *           PROMISE SERVIZI REST
       * -------------------------------------
       */
    }
  ]);
})();


/***/ }),
/* 17 */
/***/ (function(module, exports) {

/**
 * @ngdoc directive
 * @name cbl.telepass.wa.directive:tlpsDefinizioneProdotto
 * @restrict E
 * @description Componente che gestisce la visualizzazione degli apparati per filiale
 */
(function() {
  'use strict';
  var VisualizzazioneApparatiCtrl = function(
    $scope,
    $stateParams,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    propostaTelepassSrvc,
    userSrvc,
    uiGridConstants,
    visualizzazioneApparatiSrvc
    // propostaDefinizioneSrvc
  ) {
    this.$stateParams = $stateParams;
    this.messaggiFctr = messaggiFctr;
    this.CONSTANTS = CONSTANTS;
    this.userSrvc = userSrvc;
    $scope.msg = labelSrvc.getLabel;
    this.uiGridConstants = uiGridConstants;
    this.visualizzazioneApparatiSrvc = visualizzazioneApparatiSrvc;

    this.propostaTelepassSrvc = propostaTelepassSrvc;
    // this.propostaDefinizioneSrvc = propostaDefinizioneSrvc;

    // Spinner
    this.spinner = this.propostaTelepassSrvc.spinner;

    this.gridOptions = {};

    this.stiliTabella = {
      height: '0px',
      width: '0px'
    };

    this.tableHeight = 0;
    this.tableWidth = 0;

    this.ricerca = {
      codice: '',
      descrizione: ''
    };

    this.filialiDaMostrare = [];

    var self = this;

    /*
     * -------------------------------------
     *          GESTIONE INTERFACCIA
     * -------------------------------------
     */

    /**
     * @ngdoc method
     * @name filtraFiliali
     * @methodOf cbl.telepass.wa:propostaTelepassSrvc
     * @description Filtra le filiali per codice e/o descrizione indicati
     */
    this.filtraFiliali = function(filiali, ricerca) {
      self.filialiDaMostrare = [];
      for (var i in filiali) {
        if (
          (filiali[i].soglia.filiale.search(new RegExp(ricerca.codice, 'i')) >
            -1 &&
            ricerca.codice) ||
          (filiali[i].soglia.descrizione.search(
            new RegExp(ricerca.descrizione, 'i')
          ) > -1 &&
            ricerca.descrizione)
        ) {
          self.filialiDaMostrare.push(filiali[i]);
        }
      }

      if (!self.filialiDaMostrare.length) {
        self.filialiDaMostrare = filiali;
      }
    };

    /**
     * @ngdoc method
     * @name filtraFiliali
     * @methodOf cbl.telepass.wa:propostaTelepassSrvc
     * @description Chiama al servizio che restituisce le filiali
     */
    this.ricercaVisualizzazioneApparati = function(ricerca) {
      self.flusso = {};
      self.dettaglioFlusso = {};
      self.gestioneApparatiFl = false;
      self.spinner.showSpinner = true;
      self.visualizzazioneApparatiSrvc
        .promiseRecuperaFiliali()
        .then(
          function(response) {
            if (self.messaggiFctr.processaResponse(response)) {
              self.spinner.showSpinner = false;
              return;
            }

            self.spinner.showSpinner = false;

            self.filiali = response.data.result;

            self.filtraFiliali(self.filiali.quantitaSoglie, ricerca);

            self.tableHeight = self.filialiDaMostrare.length * 30 + 40;

            self.stiliTabella = {
              height: self.tableHeight + 'px',
              width: '100%'
            };

            // Configurazione tabella
            self.gridOptions = {
              enableSorting: true,
              enableColumnMenus: false,
              enableGrouping: false,
              multiSelect: false,
              showHeader: true,
              enableRowHeaderSelection: false,
              enableRowSelection: true,
              // enableRowSelection: !self.propostaTelepassSrvc.isPraticaNavigabile(),
              showGridFooter: false,
              enableVerticalScrollbar: self.uiGridConstants.scrollbars.NEVER,
              enableHorizontalScrollbar: self.uiGridConstants.scrollbars.NEVER,
              enableColumnResizing: true,
              enableCellEditing: false,
              columnDefs: [
                {
                  displayName: 'Filiale',
                  field: 'soglia.filiale',
                  width: '25%',
                  name: 'filiale',
                  enableCellEdit: false
                },
                {
                  displayName: 'Descrizione',
                  field: 'soglia.descrizione',
                  width: '25%',
                  name: 'descrizione',
                  enableCellEdit: false
                },
                {
                  displayName: 'Quantità Disponibile',
                  field: 'quantita',
                  width: '25%',
                  name: 'quantita',
                  enableCellEdit: false
                },
                {
                  displayName: 'Soglia',
                  field: 'soglia.value',
                  width: '25%',
                  name: 'soglia',
                  enableCellEdit: false
                }
              ],
              data: self.filialiDaMostrare,
              onRegisterApi: function(gridApi) {
                gridApi.selection.on.rowSelectionChanged($scope, function(row) {
                  self.selezionaFlusso(row);
                });
              }
            };
          },
          function(reason) {
            if (self.messaggiFctr.processaResponse(reason)) {
              self.spinner.showSpinner = false;
            }
          }
        )
        .finally(function() {
          self.spinner.showSpinner = false;
        });
    };

    /*
     * -------------------------------------
     * METODI INIZIALIZZAZIONE
     * -------------------------------------
     */

    this.init = function() {
      labelSrvc.labelsPronte.then(function() {
        self.labelsPronte = true;
      });
    };

    /*
     * -------------------------------------
     *        INIZIALIZZAZIONE
     * -------------------------------------
     */
    self.init();
  };

  VisualizzazioneApparatiCtrl.$inject = [
    '$scope',
    '$stateParams',
    'TLPS_CONSTANTS',
    'TlpsLabelSrvc',
    'TlpsMessaggiFctr',
    'TlpsPropostaSrvc',
    'TlpsUserSrvc',
    'uiGridConstants',
    'TlpsVisualizzazioneApparatiSrvc'
    // 'TlpsDefinizioneSrvc'
  ];

  var TemplateUrl = function(CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'tlpsApprovvigionamento/visualizzazioneApparati/visualizzazioneApparati.html'
    );
  };

  TemplateUrl.$inject = ['TLPS_CONSTANTS'];

  var visualizzazioneApparatiComponent = {
    bindings: {
      steps: '<',
      currentStep: '<'
    },
    controller: VisualizzazioneApparatiCtrl,
    controllerAs: 'visualizzazioneApparatiCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.telepass.wa')
    .component('visualizzazioneApparati', visualizzazioneApparatiComponent);
})();


/***/ }),
/* 18 */
/***/ (function(module, exports) {

/**
 * @ngdoc service
 * @name cbl.telepass.wa.directive:tlpsProposta
 * @restrict E
 * @scope
 * @description Servizio che gestisce le configurazione la presa in carico degli apparati
 */
(function() {
  angular.module('cbl.telepass.wa').service('TlpsVisualizzazioneApparatiSrvc', [
    '$http',
    'TlpsMessaggiFctr',
    'TLPS_CONSTANTS',
    'TlpsLabelSrvc',
    function($http, messaggiFctr, CONSTANTS, labelSrvc) {
      this.$http = $http;
      this.messaggiFctr = messaggiFctr;
      this.labelSrvc = labelSrvc;

      var self = this;

      /*
       * -------------------------------------
       *           PROMISE SERVIZI REST
       * -------------------------------------
       */

      /**
       * @ngdoc method
       * @name promiseRecuperaFlussi
       * @methodOf cbl.telepass.wa:presaInCaricoSrvc
       * @description Recupera la lista dei flussi
       */
      this.promiseRecuperaFiliali = function() {
        return this.$http({
          method: 'GET',
          url:
            CONSTANTS.REST_ROOT +
            CONSTANTS.REST.APPROVVIGIONAMENTO.APPARATO_QUANTITA
        });
      };
    }
  ]);
})();


/***/ }),
/* 19 */
/***/ (function(module, exports) {

/**
 * @ngdoc directive
 * @name cbl.telepass.wa.directive:tlpsProposta
 * @restrict E
 * @description Componente per la visualizzazione di una pratica di telepass
 */
(function () {
  'use strict';
  var TlpsPostVenditaCtrl = function (
    $scope,
    $state,
    $stateParams,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    postVenditaTelepassSrvc,
    $uibModal
  ) {
    this.$stateParams = $stateParams;
    this.messaggiFctr = messaggiFctr;
    this.postVenditaTelepassSrvc = postVenditaTelepassSrvc;
    this.CONSTANTS = CONSTANTS;
    this.$state = $state;
    $scope.msg = labelSrvc.getLabel;
    this.$uibModal = $uibModal;
    this.isTableReady = false;

    // Variabili della pagina
    this.ndg;

    this.templateSelezionato = false;

    var self = this;

    /*
     * -------------------------------------
     *         GESTIONE NAVIGAZIONE
     * -------------------------------------
     */

    this.risottomettiRifiutaVisibile = function () {
      return (
        self.postVenditaTelepassSrvc.datiPratica &&
        self.postVenditaTelepassSrvc.datiPratica.stato === self.CONSTANTS.STATO_PRATICA.DAREVISIONARE
      );
    };

    this.trasloco = function () {
      self.$state.go('tlps-post-vendita-trasloco', {
        ndg: self.ndg
      });
    };

    this.recuperaPratica = function () {
      self.postVenditaTelepassSrvc.spinner.callStack++;

      self.postVenditaTelepassSrvc.promiseRecuperaPratica(self.idPratica).then(function (response) {
        if (self.messaggiFctr.processaResponse(response)) {
          self.postVenditaTelepassSrvc.spinner.callStack--;
          return;
        }

        self.postVenditaTelepassSrvc.datiPratica = response.data.result;

        if (self.postVenditaTelepassSrvc.datiPratica.settore === 'TELEPASS') {
          self.postVenditaTelepassSrvc.datiPratica.class = 'PraticaTelepassDto';
        } else if (self.postVenditaTelepassSrvc.datiPratica.settore === 'VIACARD') {
          self.postVenditaTelepassSrvc.datiPratica.class = 'PraticaViacardDto';
        }

        self.selezionaSpecializzazione();
        self.isTableReady = true;
        self.postVenditaTelepassSrvc.spinner.callStack--;
      });
    };

    this.selezionaSpecializzazione = function () {
      switch (self.postVenditaTelepassSrvc.datiPratica.specializzazione) {
        case self.CONSTANTS.SPECIALIZZAZIONE_PRATICA.REVOCA_TELEPASS:
        case self.CONSTANTS.SPECIALIZZAZIONE_PRATICA.AGGIUNTA_VIACARD:
        case self.CONSTANTS.SPECIALIZZAZIONE_PRATICA.RESTITUZIONE_VIACARD:
        case self.CONSTANTS.SPECIALIZZAZIONE_PRATICA.MODIFICA_CONTO_TELEPASS:
          self.currentOperationUrl = 'postVendita.tmpl.html';
          self.templateSelezionato = true;
          // Recupero i dati dell'anagrafica per popolare l'intestazione
          self.postVenditaTelepassSrvc.promiseRecuperaAnagrafica(self.ndg).then(
            function (response) {
              if (self.messaggiFctr.processaResponse(response)) {
                self.postVenditaTelepassSrvc.spinner.callStack--;
                return;
              }
              self.postVenditaTelepassSrvc.datiCliente = response.data.result;

              self.templateSelezionato = true;
              self.postVenditaTelepassSrvc.spinner.callStack--;
            },
            function (error) {
              self.messaggiFctr.processaResponse(error);
              self.postVenditaTelepassSrvc.spinner.callStack--;
              return;
            }
          );
          return;
        case self.CONSTANTS.SPECIALIZZAZIONE_PRATICA.TRASLOCO_TELEPASS:
          $state.go('tlps-post-vendita-trasloco', {
            ndg: self.ndg,
            idPratica: self.idPratica
          });
          return;
      }
    };

    this.risottomettiPratica = function () {
      self.$uibModal
        .open({
          animation: true,
          templateUrl: CONSTANTS.BASE_ROOT + 'components/tlpsProposta/tlpsModale/tlpsRisottometti.html',
          controller: 'TlpsModalController',
          controllerAs: 'modalCtrl',
          keyboard: false,
          backdrop: 'static',
          size: 'modal-lg'
        })
        .result.then(function (res) {});
    };

    this.rifiutaPratica = function () {
      self.$uibModal
        .open({
          animation: true,
          templateUrl: CONSTANTS.BASE_ROOT + 'components/tlpsProposta/tlpsModale/tlpsRifiuta.html',
          controller: 'TlpsModalController',
          controllerAs: 'modalCtrl',
          keyboard: false,
          backdrop: 'static',
          size: 'modal-lg'
        })
        .result.then(function (res) {});
    };

    /*:

     * -------------------------------------
     *         METODI INIZIALIZZAZIONE
     * -------------------------------------
     */

    this.init = function () {
      self.postVenditaTelepassSrvc.datiPratica = null;
      self.postVenditaTelepassSrvc.datiCliente = null;
      self.postVenditaTelepassSrvc.contrattoDaRevocare = null;
      self.postVenditaTelepassSrvc.ndgContrattoDaRevocare = null;
      self.postVenditaTelepassSrvc.contrattiCliente = null;

      self.templateSelezionato = false;

      // Forzatura per lo spegnimento dello spinner generale dell'applicazione per poter gestire
      // correttamente quello locale.
      var overlay = document.getElementById('overlay');
      if (!!overlay) {
        overlay.setAttribute('style', 'display:none;');
      }

      labelSrvc.labelsPronte.then(function () {
        self.ndg = self.$stateParams.ndg;
        self.idPratica = self.$stateParams.idPratica;

        self.postVenditaTelepassSrvc.spinner.callStack++;

        if (self.idPratica) {
          self.recuperaPratica();
        } else {
          self.currentOperationUrl = 'postVendita.tmpl.html';
          self.templateSelezionato = true;

          // Recupero i dati dell'anagrafica per popolare l'intestazione
          self.postVenditaTelepassSrvc.promiseRecuperaAnagrafica(self.ndg).then(
            function (response) {
              if (self.messaggiFctr.processaResponse(response)) {
                self.postVenditaTelepassSrvc.spinner.callStack--;
                return;
              }
              self.postVenditaTelepassSrvc.datiCliente = response.data.result;
              self.isTableReady = true;
              self.postVenditaTelepassSrvc.spinner.callStack--;
            },
            function (error) {
              self.messaggiFctr.processaResponse(error);
              self.postVenditaTelepassSrvc.spinner.callStack--;
              return;
            }
          );
        }
      });
    };

    // INIZIALIZZAZIONE

    self.init();
  };

  TlpsPostVenditaCtrl.$inject = [
    '$scope',
    '$state',
    '$stateParams',
    'TLPS_CONSTANTS',
    'TlpsLabelSrvc',
    'TlpsMessaggiFctr',
    'TlpsPostVenditaSrvc',
    '$uibModal'
  ];

  var TemplateUrl = function (CONSTANTS) {
    return CONSTANTS.BASE_ROOT + CONSTANTS.COMPONENTS_PATH + 'tlpsPostVendita/tlpsPostVendita.html';
  };

  TemplateUrl.$inject = ['TLPS_CONSTANTS'];

  var TlpsPostVenditaComponent = {
    controller: TlpsPostVenditaCtrl,
    controllerAs: 'tlpsPostVenditaCtrl',
    templateUrl: TemplateUrl
  };

  angular.module('cbl.telepass.wa').component('tlpsPostVendita', TlpsPostVenditaComponent);
})();


/***/ }),
/* 20 */
/***/ (function(module, exports) {

/**
 * @ngdoc service
 * @name cbl.telepass.wa.directive:tlpsProposta
 * @restrict E
 * @scope
 * @description Servizio che gestisce il processo di creazione nuova pratica e
 *              visualizzazione pratica esistente
 */
(function () {
  angular.module('cbl.telepass.wa').service('TlpsPostVenditaSrvc', [
    '$http',
    'TlpsMessaggiFctr',
    'TLPS_CONSTANTS',
    'TlpsLabelSrvc',
    '$state',
    '$stateParams',
    function ($http, messaggiFctr, CONSTANTS, labelSrvc, $state, $stateParams) {
      this.$http = $http;
      this.messaggiFctr = messaggiFctr;
      this.labelSrvc = labelSrvc;
      this.$state = $state;
      this.$stateParams = $stateParams;

      // Variabili generali pratica
      this.datiCliente = null;
      this.datiPratica = null;

      this.contrattoDaRevocare = null;
      this.ndgContrattoDaRevocare = null;
      this.contrattiCliente = null;

      // Spinner
      this.spinner = { showSpinner: false, callStack: 0 };

      var self = this;

      /*
       * -------------------------------------
       *           PROMISE SERVIZI REST
       * -------------------------------------
       */

      /**
       * @ngdoc method
       * @name promiseRecuperaContiCorrenti
       * @methodOf cbl.telepass.wa.directive:TlpsPropostaSrvc
       * @description Effettua una chiamata http per recuperare i conti correnti dell'ndg
       * @return {Promise} - Ritorna una promise contenente la lista dei conti correnti
       */
      this.promiseRecuperaContiCorrenti = function (ndg) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.CONTOCORRENTE.RICERCA_CONTICORRENTE,
          params: { ndg: ndg }
        });
      };

      /**
       * @ngdoc method
       * @name promiseRecuperaAnagrafica
       * @methodOf cbl.telepass.wa.directive:TlpsPropostaSrvc
       * @description Effettua una chiamata http per recuperare i dettagli dell'anagrafica
       * @return {Promise} - Ritorna una promise contenente l'anagrafica
       */
      this.promiseRecuperaAnagrafica = function (ndg) {
        // this.spinner.pratica = true;
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.ANAGRAFICA.RECUPERA,
          params: { ndg: ndg }
        });
      };

      /**
       * @ngdoc method
       * @name promiseDettaglioPratica
       * @methodOf cbl.telepass.wa.directive:TlpsPropostaSrvc
       * @description Effettua una chiamata http per recuperare i dettagli della pratica
       * @return {Promise} - Ritorna una promise contenente i dettagli della pratica
       */
      this.promiseRecuperaPratica = function (idPratica) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.DETTAGLIO_PRATICA + 'pratica/' + idPratica
        });
      };

      /**
       * SERVIZI REVOCA
       */

      this.promiseRecuperaContrattiCliente = function (ndg) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.POST_VENDITA.RECUPERA_CONTRATTI_CLIENTE + ndg
        });
      };

      this.promiseRevocaTelepass = function (ndg, contratto) {
        var req = {
          ndg: ndg,
          codiciContratto: contratto
        };

        return this.$http({
          method: 'POST',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.POST_VENDITA.REVOCA,
          data: req
        });
      };

      this.promiseModificaConto = function (rapporto, ndg, contratto) {
        var req = {
          numeroRapporto: rapporto,
          ndg: ndg,
          codiceContratto: contratto
        };

        return this.$http({
          method: 'POST',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.POST_VENDITA.MODIFICA_CONTO,
          data: req
        });
      };

      /**
       * SERVIZI RESTITUZIONE
       */

      this.promiseRecuperaCarteViacardPerContratto = function (contratto, ndg) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.POST_VENDITA.RECUPERA_CARTE_VIACARD + contratto,
          params: { ndg: ndg }
        });
      };

      this.promiseRecuperaCarteViacard = function (ndg) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.POST_VENDITA.RECUPERA_CARTE_VIACARD + ndg
        });
      };

      this.promiseRestituisciCarte = function (ndg, listaCarte, codiceContratto) {
        var req = {
          ndg: ndg,
          carteViacard: listaCarte,
          codiceContratto: codiceContratto
        };

        return this.$http({
          method: 'POST',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.POST_VENDITA.RESTITUISCI_CARTE,
          data: req
        });
      };

      this.promiseAggiungiCarte = function (ndg, numeroCarte, codiceContratto) {
        var req = {
          ndg: ndg,
          numeroCarte: numeroCarte,
          codiceContratto: codiceContratto
        };

        return this.$http({
          method: 'POST',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.POST_VENDITA.AGGIUNGI_CARTE,
          data: req
        });
      };

      /**
       * @ngdoc method
       * @name promiseRisottomettiPratica
       * @methodOf cbl.telepass.wa:TlpsPropostaSrvc
       * @description Effettua una chiamata http per rifiutare la pratica che si sta allestendo
       * @return {Promise} - Ritorna una promise contenente un booleano con la risposta alla cancellazione
       */
      this.promiseRisottomettiPratica = function () {
        var pratica = self.datiPratica;

        return this.$http({
          method: 'PUT',
          url:
            CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.RISOTTOMETTI_PRATICA.replace('{idPratica}', pratica.idPratica),
          data: pratica
        });
      };

      /**
       * @ngdoc method
       * @name promiseRifiutaPratica
       * @methodOf cbl.telepass.wa:TlpsPropostaSrvc
       * @description Effettua una chiamata http per rifiutare la pratica che si sta allestendo
       * @return {Promise} - Ritorna una promise contenente un booleano con la risposta alla cancellazione
       */
      this.promiseRifiutaPratica = function (pratica) {
        return this.$http({
          method: 'PUT',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.RIFIUTA_PRATICA.replace('{idPratica}', pratica.idPratica),
          data: pratica
        });
      };

      /**
       * @ngdoc method
       * @name formattazioneData
       * @methodOf cbl.telepass.wa:CcpropostaTelepassSrvc
       * @description Formatta la data per visualizzarla
       */
      this.formattazioneData = function (data) {
        if (!data) {
          return '';
        }

        var giorno = data.dayOfMonth;
        var mese = data.monthValue;
        var anno = data.year;

        return giorno + '/' + mese + '/' + anno;
      };

      /**
       * @ngdoc method
       * @name goToSchedaCliente
       * @methodOf cbl.telepass.wa.directive:tlpsProposta
       * @description Ridireziona verso la scheda del cliente
       */
      this.goToSchedaCliente = function () {
        self.datiPratica = null;
        self.datiCliente = null;
        self.datiProdotto = null;
        self.$state.go('schedaCliente', { ndg: self.$stateParams.ndg });
      };

      this.recuperaContratti = function () {
        self.messaggiFctr.resetMessages();
        self.ndg = self.$stateParams.ndg;
        self.numeroRapportoDaModificare = null;

        self.spinner.callStack++;
        // Recupero il codice cliente per farlo visualizzare
        self.promiseRecuperaContrattiCliente(self.ndg).then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }

            self.contrattiCliente = response.data.result;

            // Se ho i dati della pratica e il codiceContratto della pratica vuol dire che la devo
            // risottomettere
            if (self.datiPratica && self.datiPratica.codiceContratto) {
              // self.datiPratica.stato ===
              //   self.CONSTANTS.STATO_PRATICA.DAREVISIONARE
              self.contrattiCliente = self.contrattiCliente.filter(function (item) {
                return item.codiceContratto === self.datiPratica.codiceContratto;
              });

              self.selectedButtonsCellTemplate = self.risottomettiButtonCellTemplate;
            }

            self.tableHeight = response.data.result.length * 35 + 40;
            self.spinner.callStack--;

            // // Configurazione tabella
            var _defaultRowheight = 35;
            self.gridOptions = {
              enableSorting: true,
              enableColumnMenus: false,
              enableGrouping: false,
              // multiSelect: true,
              showHeader: true,
              enableRowHeaderSelection: false,
              // enableRowSelection: true,
              showGridFooter: false,
              enableVerticalScrollbar: self.uiGridConstants.scrollbars.NEVER,
              enableHorizontalScrollbar: self.uiGridConstants.scrollbars.NEVER,
              enableColumnResizing: true,
              rowHeight: _defaultRowheight,
              columnDefs: [
                {
                  displayName: 'Codice Contratto',
                  field: 'codiceContratto',
                  width: '8%',
                  name: 'codiceContratto'
                },
                {
                  displayName: 'Settore',
                  field: 'settore',
                  width: '8%',
                  name: 'settore'
                },
                {
                  displayName: 'Data Apertura',
                  field: 'dataAperturaContratto',
                  width: '10%',
                  name: 'dataAperturaContratto'
                },
                {
                  displayName: 'Numero modulo apertura',
                  field: 'numeroModulo',
                  width: '5%',
                  name: 'numeroModulo'
                },
                {
                  displayName: 'Numero rapporto TLP',
                  field: 'numeroRapportoTLP',
                  width: '10%',
                  name: 'numeroRapportoTLP'
                },
                {
                  displayName: 'IBAN',
                  field: 'iban',
                  width: '10%',
                  name: 'iban'
                },
                {
                  displayName: 'Apparati',
                  field: 'numeroApparati',
                  width: '5%',
                  name: 'numeroApparati'
                },
                {
                  displayName: 'Carte',
                  field: 'numeroCarte',
                  width: '8%',
                  name: 'numeroCarte'
                },
                {
                  displayName: 'Azioni',
                  field: 'numeroCarte',
                  width: '36%',
                  name: 'azioni',
                  cellTemplate:
                    '<span>' +
                    '<span style="margin: 5px;">' +
                    '<button class="btn btn-primary" ng-click="grid.appScope.postVenditaTelepassCtrl.openModaleRevocaContratto(row.entity.codiceContratto)">Revoca</button>' +
                    '</span>' +
                    '<span style="margin: 5px;" ng-if="row.entity.settore===grid.appScope.postVenditaTelepassCtrl.labelViacard">' +
                    '<button class="btn btn-primary" ng-click="grid.appScope.postVenditaTelepassCtrl.avviaRestituzioneCarte(row)">Restituisci</button>' +
                    '</span>' +
                    '<span style="margin: 5px;" ng-if="row.entity.settore===grid.appScope.postVenditaTelepassCtrl.labelViacard">' +
                    '<button class="btn btn-primary" ng-click="grid.appScope.postVenditaTelepassCtrl.avviaAggiuntaCarte(row)">Aggiungi</button>' +
                    '</span>' +
                    '<span>' +
                    '<button class="btn btn-primary" ng-click="grid.appScope.postVenditaTelepassCtrl.avviaModificaConto(row)">Modifica Conto</button>' +
                    '</span>' +
                    '</span>'
                }
              ],
              data: self.contrattiCliente,
              onRegisterApi: function (gridApi) {
                self.gridApi = gridApi;
                self.gridApi.grid.modifyRows(self.gridOptions.data);
              }
            };
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);
            self.spinner.callStack--;
          }
        );
      };

      this.pulisciDati = function () {};
    }
  ]);
})();


/***/ }),
/* 21 */
/***/ (function(module, exports) {

/**
 * @ngdoc directive
 * @name cbl.telepass.wa.directive:ccQuestionari
 * @restrict E
 * @description Componente che gestisce il terzo step "Valutazione" del dettaglio pratica
 */
(function () {
  'use strict';
  var TlpsPostVenditaTelepassCtrl = function (
    $scope,
    $stateParams,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    postVenditaSrvc,
    uiGridConstants,
    $state,
    $uibModal
  ) {
    this.$stateParams = $stateParams;
    this.$state = $state;
    this.messaggiFctr = messaggiFctr;
    this.CONSTANTS = CONSTANTS;
    $scope.msg = labelSrvc.getLabel;
    this.postVenditaSrvc = postVenditaSrvc;
    this.$uibModal = $uibModal;

    this.uiGridConstants = uiGridConstants;

    this.ndg;
    this.contrattiSelezionati = [];
    this.ragioneSociale;

    this.tableHeight = 0;
    this.labelViacard = 'VIACARD';
    this.labelTelepass = 'TELEPASS';
    this.carteSelezionate = [];
    this.codiceContrattoSelezionato = null;
    this.idContrattoSelezionato = null;

    this.isRestituzioneCarte = false;
    this.isAggiuntaCarte = false;
    this.isModificaConto = false;

    this.numeroCarteDaAggiungere = null;
    this.numeroRapportoDaModificare = null;
    var self = this;

    /*
     * ------------------------------------------------
     *           GESTIONE INTERFACCIA
     * ------------------------------------------------
     */

    this.avviaRestituzioneCarte = function (row) {
      self.codiceContrattoSelezionato = row.entity.codiceContratto;
      self.idContrattoSelezionato = row.entity.id;
      self.isRestituzioneCarte = true;
      self.isAggiuntaCarte = false;
      self.isModificaConto = false;
      self.carteSelezionate = [];
      self.recuperaCarte(row.entity.id, self.ndg);
    };

    this.recuperaConti = function (ndg) {
      self.postVenditaSrvc.spinner.callStack++;

      self.postVenditaSrvc
        .promiseRecuperaContiCorrenti(ndg)
        .then(function (response) {
          if (self.messaggiFctr.processaResponse(response)) {
            self.postVenditaSrvc.spinner.callStack--;
            return;
          }

          self.listaContiCorrenti = response.data.result;

          for (var i in self.listaContiCorrenti) {
            self.listaContiCorrenti[i].dataApertura = self.postVenditaSrvc.formattazioneData(
              self.listaContiCorrenti[i].dataApertura
            );
          }

          self.tableHeightConti = response.data.result.length * 30 + 40;

          // // Configurazione tabella
          self.gridOptionsContiCorrenti = {
            enableSorting: true,
            enableColumnMenus: false,
            enableGrouping: false,
            multiSelect: false,
            showHeader: true,
            enableRowHeaderSelection: false,
            enableRowSelection: true,
            showGridFooter: false,
            enableVerticalScrollbar: self.uiGridConstants.scrollbars.NEVER,
            enableHorizontalScrollbar: self.uiGridConstants.scrollbars.NEVER,
            enableColumnResizing: true,
            columnDefs: [
              {
                displayName: 'Numero Rapporto',
                field: 'numeroRapporto',
                width: '10%',
                name: 'numeroRapporto'
              },
              {
                displayName: 'Iban',
                field: 'iban',
                width: '25%',
                name: 'iban'
              },
              {
                displayName: 'Descrizione',
                field: 'descrizione',
                width: '15%',
                name: 'descrizione'
              },
              {
                displayName: 'Saldo Contabile',
                cellFilter: 'number : 2',
                cellClass: 'right',
                field: 'saldoContabile',
                width: '10%',
                name: 'saldoContabile'
              },
              {
                displayName: 'Intestatario',
                cellClass: 'right',
                field: 'intestazione',
                width: '20%',
                name: 'intestazione'
              },
              {
                displayName: 'Stato',
                field: 'stato',
                width: '10%',
                name: 'stato'
              },
              {
                displayName: 'Data Apertura',
                field: 'dataApertura',
                cellFilter: 'date: "dd/MM/yyyy"',
                width: '10%',
                name: 'dataApertura'
              }
            ],
            data: self.listaContiCorrenti,
            onRegisterApi: function (gridApi) {
              self.gridApi = gridApi;
              self.gridApi.grid.modifyRows(self.gridOptions.data);

              gridApi.selection.on.rowSelectionChanged($scope, function (row) {
                self.selezionaConto(row);
              });
            }
          };
        })
        .finally(function () {
          self.postVenditaSrvc.spinner.callStack--;
        });
    };

    this.datiValidi = function () {
      var errori = false;

      //Controlla che un conto sia stato selezionato
      if (!self.numeroRapportoDaModificare) {
        var message = {};
        message.type = 'E';
        message.message = 'Si deve selezionare un conto';
        messaggiFctr.addMessage(message);
        errori = true;
      }
      if (errori) {
        return false;
      }

      return true;
    };

    this.modificaConto = function () {
      //Controlla che un conto sia stato selezionato
      if (!self.datiValidi()) {
        return;
      }

      self.postVenditaSrvc.spinner.callStack++;

      self.postVenditaSrvc
        .promiseModificaConto(self.numeroRapportoDaModificare, self.ndg, self.codiceContrattoSelezionato)
        .then(function (response) {
          if (self.messaggiFctr.processaResponse(response)) {
            self.postVenditaSrvc.spinner.callStack--;
            return;
          }

          self.messaggiFctr.addMessage({
            type: 'I',
            message: 'Richiesta effettuata correttamente'
          });
          self.isModificaConto = false;
          self.numeroRapportoDaModificare = null;
        })
        .finally(function () {
          self.postVenditaSrvc.spinner.callStack--;
        });
    };

    this.avviaModificaConto = function (row) {
      self.codiceContrattoSelezionato = row.entity.codiceContratto;
      self.idContrattoSelezionato = row.entity.id;
      self.isModificaConto = true;
      self.isAggiuntaCarte = false;
      self.isRestituzioneCarte = false;
      self.numeroCarteDaAggiungere = null;
      self.messaggiFctr.resetMessages();
      self.recuperaConti(self.ndg);
    };

    /**
     * @ngdoc method
     * @name selezionaConto
     * @methodOf cbl.telepass.wa:tlpsDefinizioneProdotto
     * @description Seleziona o deseleziona il conto corrente su cui aprire la pratica
     */
    this.selezionaConto = function (conto) {
      self.numeroRapportoDaModificare = conto.entity.numeroRapporto;
    };

    this.avviaAggiuntaCarte = function (row) {
      self.codiceContrattoSelezionato = row.entity.codiceContratto;
      self.idContrattoSelezionato = row.entity.id;
      self.isAggiuntaCarte = true;
      self.isModificaConto = false;
      self.isRestituzioneCarte = false;
      self.numeroCarteDaAggiungere = null;
    };

    this.trasloco = function () {
      self.$state.go('tlps-post-vendita-trasloco', {
        ndg: self.ndg
      });
    };

    this.selezionaCarta = function (carta) {
      self.messaggiFctr.resetMessages();
      var index = self.carteSelezionate.indexOf(carta.entity);

      if (index >= 0) {
        self.carteSelezionate.splice(index, 1);
      } else {
        self.carteSelezionate.push(carta.entity);
      }
    };

    this.risottomettiPratica = function () {
      self.postVenditaSrvc.spinner.callStack++;

      self.postVenditaSrvc
        .promiseRisottomettiPratica()
        .then(function (response) {
          if (self.messaggiFctr.processaResponse(response)) {
            self.postVenditaSrvc.spinner.callStack--;
            return;
          }

          self.messaggiFctr.addMessage({
            type: 'I',
            message: 'Richiesta effettuata correttamente'
          });
        })
        .finally(function () {
          self.postVenditaSrvc.spinner.callStack--;
        });
    };

    /*
     * --------------------------------------------
     *           GESTIONE OPERAZIONI
     * -------------------------------------------
     */

    this.aggiungiCarte = function () {
      self.messaggiFctr.resetMessages();
      self.postVenditaSrvc.spinner.callStack++;
      self.postVenditaSrvc
        .promiseAggiungiCarte(self.ndg, self.numeroCarteDaAggiungere, self.codiceContrattoSelezionato)
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              self.postVenditaSrvc.spinner.callStack--;
              return;
            }

            if (response.data.result) {
              messaggiFctr.addMessage({
                type: 'I',
                message: 'Richiesta effettuata correttamente'
              });

              self.isAggiuntaCarte = false;
            }
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);
          }
        )
        .finally(function () {
          self.postVenditaSrvc.spinner.callStack--;
        });
    };

    this.openModaleRevocaContratto = function (row) {
      self.postVenditaSrvc.contrattoDaRevocare = row;
      self.postVenditaSrvc.ndgContrattoDaRevocare = self.ndg;
      self.$uibModal
        .open({
          animation: true,
          templateUrl: CONSTANTS.BASE_ROOT + 'components/tlpsProposta/tlpsModale/tlpsRevoca.html',
          controller: 'TlpsModalController',
          controllerAs: 'modalCtrl',
          keyboard: false,
          backdrop: 'static',
          size: 'modal-lg'
        })
        .result.then(function (res) {});
    };

    // this.revocaContratto = function (row) {
    //   self.messaggiFctr.resetMessages();
    //   self.postVenditaSrvc.spinner.callStack++;

    //   self.postVenditaSrvc
    //     .promiseRevocaTelepass(self.ndg, row)
    //     .then(function (response) {
    //       if (self.messaggiFctr.processaResponse(response)) {
    //         self.postVenditaSrvc.spinner.callStack--;
    //         return;
    //       }
    //       messaggiFctr.addMessage({
    //         type: 'I',
    //         message: 'Richiesta effettuata correttamente',
    //       });

    //       self.recuperaContratti();
    //     })
    //     .finally(function () {
    //       self.postVenditaSrvc.spinner.callStack--;
    //     });
    // };

    this.restituisciCarte = function () {
      self.messaggiFctr.resetMessages();
      self.postVenditaSrvc.spinner.callStack++;

      self.postVenditaSrvc
        .promiseRestituisciCarte(self.ndg, self.carteSelezionate, self.codiceContrattoSelezionato)
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              self.postVenditaSrvc.spinner.callStack--;
              return;
            }
            if (response.data.result) {
              messaggiFctr.addMessage({
                type: 'I',
                message: 'Richiesta effettuata correttamente'
              });
              self.isRestituzioneCarte = false;
              self.recuperaCarte(self.idContrattoSelezionato, self.ndg);
            }
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);
          }
        )
        .finally(function () {
          self.postVenditaSrvc.spinner.callStack--;
        });
    };

    this.recuperaContratti = function () {
      self.messaggiFctr.resetMessages();
      self.ndg = self.$stateParams.ndg;
      self.numeroRapportoDaModificare = null;

      self.postVenditaSrvc.spinner.callStack++;
      // Recupero il codice cliente per farlo visualizzare
      self.postVenditaSrvc.promiseRecuperaContrattiCliente(self.ndg).then(
        function (response) {
          if (self.messaggiFctr.processaResponse(response)) {
            return;
          }

          self.postVenditaSrvc.contrattiCliente = response.data.result;

          // Se ho i dati della pratica e il codiceContratto della pratica vuol dire che la devo
          // risottomettere
          if (self.postVenditaSrvc.datiPratica && self.postVenditaSrvc.datiPratica.codiceContratto) {
            // self.postVenditaSrvc.datiPratica.stato ===
            //   self.CONSTANTS.STATO_PRATICA.DAREVISIONARE
            self.postVenditaSrvc.contrattiCliente = self.postVenditaSrvc.contrattiCliente.filter(function (item) {
              return item.codiceContratto === self.postVenditaSrvc.datiPratica.codiceContratto;
            });

            self.selectedButtonsCellTemplate = self.risottomettiButtonCellTemplate;
          }

          self.tableHeight = response.data.result.length * 35 + 40;
          self.postVenditaSrvc.spinner.callStack--;

          // // Configurazione tabella
          var _defaultRowheight = 35;
          self.gridOptions = {
            enableSorting: true,
            enableColumnMenus: false,
            enableGrouping: false,
            // multiSelect: true,
            showHeader: true,
            enableRowHeaderSelection: false,
            // enableRowSelection: true,
            showGridFooter: false,
            enableVerticalScrollbar: self.uiGridConstants.scrollbars.NEVER,
            enableHorizontalScrollbar: self.uiGridConstants.scrollbars.NEVER,
            enableColumnResizing: true,
            rowHeight: _defaultRowheight,
            columnDefs: [
              {
                displayName: 'Codice Contratto',
                field: 'codiceContratto',
                width: '8%',
                name: 'codiceContratto'
              },
              {
                displayName: 'Settore',
                field: 'settore',
                width: '8%',
                name: 'settore'
              },
              {
                displayName: 'Data Apertura',
                field: 'dataAperturaContratto',
                width: '10%',
                name: 'dataAperturaContratto'
              },
              {
                displayName: 'Numero modulo apertura',
                field: 'numeroModulo',
                width: '5%',
                name: 'numeroModulo'
              },
              {
                displayName: 'Numero rapporto TLP',
                field: 'numeroRapportoTLP',
                width: '10%',
                name: 'numeroRapportoTLP'
              },
              {
                displayName: 'IBAN',
                field: 'iban',
                width: '10%',
                name: 'iban'
              },
              {
                displayName: 'Apparati',
                field: 'numeroApparati',
                width: '5%',
                name: 'numeroApparati'
              },
              {
                displayName: 'Carte',
                field: 'numeroCarte',
                width: '8%',
                name: 'numeroCarte'
              },
              {
                displayName: 'Azioni',
                field: 'numeroCarte',
                width: '36%',
                name: 'azioni',
                cellTemplate:
                  '<span>' +
                  '<span style="margin: 5px;">' +
                  '<button class="btn btn-primary" ng-click="grid.appScope.postVenditaTelepassCtrl.openModaleRevocaContratto(row.entity.codiceContratto)">Revoca</button>' +
                  '</span>' +
                  '<span style="margin: 5px;" ng-if="row.entity.settore===grid.appScope.postVenditaTelepassCtrl.labelViacard">' +
                  '<button class="btn btn-primary" ng-click="grid.appScope.postVenditaTelepassCtrl.avviaRestituzioneCarte(row)">Restituisci</button>' +
                  '</span>' +
                  '<span style="margin: 5px;" ng-if="row.entity.settore===grid.appScope.postVenditaTelepassCtrl.labelViacard">' +
                  '<button class="btn btn-primary" ng-click="grid.appScope.postVenditaTelepassCtrl.avviaAggiuntaCarte(row)">Aggiungi</button>' +
                  '</span>' +
                  '<span>' +
                  '<button class="btn btn-primary" ng-click="grid.appScope.postVenditaTelepassCtrl.avviaModificaConto(row)">Modifica Conto</button>' +
                  '</span>' +
                  '</span>'
              }
            ],
            data: self.postVenditaSrvc.contrattiCliente,
            onRegisterApi: function (gridApi) {
              self.gridApi = gridApi;
              self.gridApi.grid.modifyRows(self.gridOptions.data);
            }
          };
        },
        function (reason) {
          self.messaggiFctr.processaResponse(reason);
          self.postVenditaSrvc.spinner.callStack--;
        }
      );
    };

    this.recuperaCarte = function (contratto, ndg) {
      self.messaggiFctr.resetMessages();
      self.carteViacard = [];
      self.postVenditaSrvc.spinner.callStack++;
      self.postVenditaSrvc
        .promiseRecuperaCarteViacardPerContratto(contratto, ndg)
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              self.postVenditaSrvc.spinner.callStack--;
              return;
            }

            self.carteViacard = response.data.result;

            self.tableHeightCarteViacard = response.data.result.length * 30 + 40;

            // // Configurazione tabella
            var _defaultRowheight = 30;
            self.gridOptionsCarteViacard = {
              enableSorting: true,
              enableColumnMenus: false,
              enableGrouping: false,
              multiSelect: true,
              showHeader: true,
              enableRowHeaderSelection: false,
              enableRowSelection: true,
              showGridFooter: false,
              enableVerticalScrollbar: self.uiGridConstants.scrollbars.NEVER,
              enableHorizontalScrollbar: self.uiGridConstants.scrollbars.NEVER,
              enableColumnResizing: true,
              rowHeight: _defaultRowheight,
              columnDefs: [
                {
                  displayName: 'Numero Carta',
                  field: 'numeroCarta',
                  width: '100%',
                  name: 'numeroCarta'
                }
              ],
              data: self.carteViacard,
              onRegisterApi: function (gridApi) {
                self.gridApi = gridApi;
                self.gridApi.grid.modifyRows(self.gridOptions.data);

                gridApi.selection.on.rowSelectionChanged($scope, function (row) {
                  self.selezionaCarta(row);
                });
              }
            };
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);
          }
        )
        .finally(function () {
          self.postVenditaSrvc.spinner.callStack--;
        });
    };
    /*
     * -------------------------------------
     *           INIZIALIZZAZIONE
     * -------------------------------------
     */

    self.recuperaContratti();
  };

  TlpsPostVenditaTelepassCtrl.$inject = [
    '$scope',
    '$stateParams',
    'TLPS_CONSTANTS',
    'TlpsLabelSrvc',
    'TlpsMessaggiFctr',
    'TlpsPostVenditaSrvc',
    'uiGridConstants',
    '$state',
    '$uibModal'
  ];

  var TemplateUrl = function (CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'tlpsPostVendita/tlpsPostVenditaTelepass/tlpsPostVenditaTelepass.html'
    );
  };

  TemplateUrl.$inject = ['TLPS_CONSTANTS'];

  var TlpsPostVenditaTelepassCtrl = {
    bindings: {},
    controller: TlpsPostVenditaTelepassCtrl,
    controllerAs: 'postVenditaTelepassCtrl',
    templateUrl: TemplateUrl
  };

  angular.module('cbl.telepass.wa').component('tlpsPostVenditaAll', TlpsPostVenditaTelepassCtrl);
})();


/***/ }),
/* 22 */
/***/ (function(module, exports) {

/**
 * @ngdoc directive
 * @name cbl.telepass.wa.directive:tlpsDefinizioneProdotto
 * @restrict E
 * @description Componente che gestisce il primo step "Stato Affidamento" del
 *              dettaglio pratica
 */
(function () {
  'use strict';
  var TlpsTraslocoDatiAggiuntiviCtrl = function (
    $scope,
    $stateParams,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    traslocoTelepassSrvc,
    uiGridConstants,
    userSrvc
  ) {
    this.$stateParams = $stateParams;
    this.messaggiFctr = messaggiFctr;
    this.CONSTANTS = CONSTANTS;
    this.uiGridConstants = uiGridConstants;
    this.gridApi = null;
    this.userSrvc = userSrvc;
    $scope.msg = labelSrvc.getLabel;

    this.traslocoTelepassSrvc = traslocoTelepassSrvc;

    // Spinner
    this.spinner = this.traslocoTelepassSrvc.spinner;

    this.idPratica;
    this.idProdotto;

    // Opzioni della tabella dei conti
    this.gridOptions = {};
    this.tableHeight = 0;
    this.contiCorrenti = [];

    var self = this;

    /*
     * -------------------------------------
     *          GESTIONE BOTTONI
     * -------------------------------------
     */

    /**
     * @ngdoc method
     * @name datiValidi
     * @methodOf cbl.telepass.wa:tlpsDefinizioneProdotto
     * @description Verifica che i campi obbligatori siano valorizzati correttamente.
     */
    this.traslocoTelepassSrvc.datiValidi = function () {
      return true;
    };

    this.init = function () {
      self.dataRilascioDocumento = self.traslocoTelepassSrvc.formattazioneData(
        self.traslocoTelepassSrvc.datiCliente.documentoIdentita.dataRilascio
      );

      self.dataScadenzaDocumento = self.traslocoTelepassSrvc.formattazioneData(
        self.traslocoTelepassSrvc.datiCliente.documentoIdentita.dataScadenza
      );

      self.spinner.showSpinner = false;
    };

    this.init();
  };

  TlpsTraslocoDatiAggiuntiviCtrl.$inject = [
    '$scope',
    '$stateParams',
    'TLPS_CONSTANTS',
    'TlpsLabelSrvc',
    'TlpsMessaggiFctr',
    'TlpsTraslocoTelepassSrvc',
    'uiGridConstants',
    'TlpsUserSrvc'
  ];

  var TemplateUrl = function (CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'tlpsPostVendita/tlpsTraslocoTelepass/tlpsTraslocoDefinizione/tlpsTraslocoDatiAggiuntivi/tlpsTraslocoDatiAggiuntivi.html'
    );
  };

  TemplateUrl.$inject = ['TLPS_CONSTANTS'];

  var TlpsTraslocoDatiAggiuntiviComponent = {
    bindings: {},
    controller: TlpsTraslocoDatiAggiuntiviCtrl,
    controllerAs: 'traslocoDatiAggiuntiviCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.telepass.wa')
    .component(
      'tlpsTraslocoDatiAggiuntivi',
      TlpsTraslocoDatiAggiuntiviComponent
    );
})();


/***/ }),
/* 23 */
/***/ (function(module, exports) {

/**
 * @ngdoc directive
 * @name cbl.telepass.wa.directive:tlpsDefinizione
 * @restrict E
 * @description Componente che gestisce il primo step "Stato Affidamento" del
 *              dettaglio pratica
 */
(function() {
  'use strict';
  var tlpsTraslocoDefinizioneCtrl = function(
    $scope,
    $stateParams,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    tlpsTraslocoTelepassSrvc,
    userSrvc
  ) {
    this.$stateParams = $stateParams;
    this.messaggiFctr = messaggiFctr;
    this.CONSTANTS = CONSTANTS;
    this.userSrvc = userSrvc;
    $scope.msg = labelSrvc.getLabel;

    this.tlpsTraslocoTelepassSrvc = tlpsTraslocoTelepassSrvc;
    // this.propostaDefinizioneSrvc = propostaDefinizioneSrvc;

    // Spinner
    this.spinner = this.tlpsTraslocoTelepassSrvc.spinner;

    var self = this;

    /*
     * -------------------------------------
     *          GESTIONE INTERFACCIA
     * -------------------------------------
     */

    /**
     * @ngdoc method
     * @name getStyleTabMicro
     * @methodOf cbl.cartacredito.mf.directive:ccQuestionari
     * @description Imposta lo stile di visualizzazione per gli indicatori dei micro step
     * @param {string} currentStep - Il macro step correntemente visualizzato
     * @param {number} currentTabIndex - L'indice della tab cui applicare lo stile
     * @return {string} - Restituisce lo stile da applicare all'indicatore del micro step
     */
    this.getStyleTabMicro = function(currentTabIndex) {
      if (self.tlpsTraslocoTelepassSrvc.isPraticaNavigabile()) {
        if (self.currentStep && currentTabIndex === self.currentStep.index) {
          return 'ab-step-tabs cliccabile active-read';
        }

        return 'ab-step-tabs cliccabile ab-last-read';
      }

      // Pratica non navigabile
      if (self.currentStep && currentTabIndex < self.currentStep.index) {
        return 'ab-step-tabs';
      }

      if (self.currentStep && currentTabIndex === self.currentStep.index) {
        return 'ab-step-tabs active';
      }

      return 'ab-step-tabs ab-last';
    };

    /**
     * @ngdoc method
     * @name getStyleStepMicro
     * @methodOf cbl.cartacredito.mf.directive:ccQuestionari
     * @description Imposta lo stile di visualizzazione per la barra dell'indicatore del micro step
     * @param {string} currentStep - Il macro step correntemente visualizzato
     * @param {number} currentTabIndex - L'indice della tab cui applicare lo stile
     * @return {string} - Restituisce lo stile da applicare alla barra dell'indicatore del micro step
     */
    this.getStyleStepMicro = function(currentTabIndex) {
      if (self.tlpsTraslocoTelepassSrvc.isPraticaNavigabile()) {
        return 'step read';
      }

      if (self.currentStep && currentTabIndex < self.currentStep.index) {
        return 'step success';
      }

      return 'step';
    };

    /**
     * @ngdoc method
     * @name microTabClicked
     * @methodOf cbl.cartacredito.mf.directive:ccQuestionari
     * @description Apre il micro-tab selezionato solo se tutte le domande sono state compilate
     * @param {Object} tab - il micro-tab selezionato
     */
    this.microTabClicked = function(tab) {
      if (self.tlpsTraslocoTelepassSrvc.isPraticaNavigabile()) {
        self.currentStep = tab;
      }
    };
  };

  tlpsTraslocoDefinizioneCtrl.$inject = [
    '$scope',
    '$stateParams',
    'TLPS_CONSTANTS',
    'TlpsLabelSrvc',
    'TlpsMessaggiFctr',
    'TlpsTraslocoTelepassSrvc',
    'TlpsUserSrvc'
  ];

  var TemplateUrl = function(CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'tlpsPostVendita/tlpsTraslocoTelepass/tlpsTraslocoDefinizione/tlpsTraslocoDefinizione.html'
    );
  };

  TemplateUrl.$inject = ['TLPS_CONSTANTS'];

  var TlpsTraslocoDefinizioneComponent = {
    bindings: {
      steps: '<',
      currentStep: '<'
    },
    controller: tlpsTraslocoDefinizioneCtrl,
    controllerAs: 'traslocoDefinizioneCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.telepass.wa')
    .component('tlpsTraslocoDefinizione', TlpsTraslocoDefinizioneComponent);
})();


/***/ }),
/* 24 */
/***/ (function(module, exports) {

/**
 * @ngdoc directive
 * @name cbl.telepass.wa.directive:tlpsDefinizioneProdotto
 * @restrict E
 * @description Componente che gestisce il primo step "Stato Affidamento" del
 *              dettaglio pratica
 */
(function () {
  'use strict';
  var TlpsTraslocoDefinizioneProdottoCtrl = function (
    $scope,
    $stateParams,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    traslocoTelepassSrvc,
    uiGridConstants,
    userSrvc
    // propostaDefinizioneSrvc
  ) {
    this.$stateParams = $stateParams;
    this.messaggiFctr = messaggiFctr;
    this.CONSTANTS = CONSTANTS;
    this.uiGridConstants = uiGridConstants;
    this.gridApi = null;
    this.userSrvc = userSrvc;
    $scope.msg = labelSrvc.getLabel;

    this.traslocoTelepassSrvc = traslocoTelepassSrvc;

    // Spinner
    this.spinner = this.traslocoTelepassSrvc.spinner;

    this.idPratica;
    this.idProdotto;
    // Conto selezionato dall'utente per proseguire la pratica
    this.contoSelezionato = undefined;

    // Opzioni della tabella dei conti
    this.gridOptions = {};
    this.tableHeight = 0;
    this.contiCorrenti = [];

    this.codiceCliente;
    this.codiceApparato;

    var self = this;

    /*
     * -------------------------------------
     *          GESTIONE INTERFACCIA
     * -------------------------------------
     */

    /**
     * @ngdoc method
     * @name selezionaConto
     * @methodOf cbl.telepass.wa:tlpsDefinizioneProdotto
     * @description Seleziona o deseleziona il conto corrente su cui aprire la pratica
     */
    this.selezionaConto = function (conto) {
      if (
        self.traslocoTelepassSrvc.datiPratica.numeroRapporto !==
        conto.entity.numeroRapporto
      ) {
        self.traslocoTelepassSrvc.datiPratica.numeroRapporto =
          conto.entity.numeroRapporto;
      } else {
        self.traslocoTelepassSrvc.datiPratica.numeroRapporto = null;
      }
    };

    /*
     * -------------------------------------
     *          GESTIONE BOTTONI
     * -------------------------------------
     */

    /**
     * @ngdoc method
     * @name datiValidi
     * @methodOf cbl.telepass.wa:tlpsDefinizioneProdotto
     * @description Verifica che i campi obbligatori siano valorizzati correttamente.
     */
    this.traslocoTelepassSrvc.datiValidi = function () {
      //Controlla che un conto sia stato selezionato
      var valid = true;

      if (!self.traslocoTelepassSrvc.datiPratica.numeroRapporto) {
        valid = false;
        var message = {};
        message.type = 'E';
        message.message = 'Si deve selezionare un conto';
        messaggiFctr.addMessage(message);
      }

      if (!self.traslocoTelepassSrvc.datiPratica.codiceContrattoTrasloco) {
        valid = false;
        var message = {};
        message.type = 'E';
        message.message = 'Si deve selezionare un codice cliente';
        messaggiFctr.addMessage(message);
      }

      if (!self.traslocoTelepassSrvc.datiPratica.codiceApparato) {
        valid = false;
        var message = {};
        message.type = 'E';
        message.message = 'Si deve selezionare un codice apparato';
        messaggiFctr.addMessage(message);
      }

      return valid;
    };

    /*
     * -------------------------------------
     * METODI INIZIALIZZAZIONE
     * -------------------------------------
     */
    this.init = function () {
      self.ndg = self.$stateParams.ndg;
      self.idProdotto = self.$stateParams.idProdotto;
      self.idPratica = self.$stateParams.idPratica;

      self.spinner.showSpinner = true;
      self.traslocoTelepassSrvc
        .promiseRecuperaContiCorrenti(self.ndg)
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              self.spinner.showSpinner = false;
              return;
            }

            self.contiCorrenti = response.data.result;
            self.tableHeight = response.data.result.length * 30 + 40;

            for (var i in self.contiCorrenti) {
              self.contiCorrenti[
                i
              ].dataApertura = self.traslocoTelepassSrvc.formattazioneData(
                self.contiCorrenti[i].dataApertura
              );
            }
            // // Configurazione tabella
            self.gridOptions = {
              enableSorting: true,
              enableColumnMenus: false,
              enableGrouping: false,
              multiSelect: false,
              showHeader: true,
              enableRowHeaderSelection: false,
              enableRowSelection: !self.traslocoTelepassSrvc.isPraticaNavigabile(),
              showGridFooter: false,
              enableVerticalScrollbar: self.uiGridConstants.scrollbars.NEVER,
              enableHorizontalScrollbar: self.uiGridConstants.scrollbars.NEVER,
              enableColumnResizing: true,
              columnDefs: [
                {
                  displayName: 'Numero Rapporto',
                  field: 'numeroRapporto',
                  width: '10%',
                  name: 'numeroRapporto'
                },
                {
                  displayName: 'Iban',
                  field: 'iban',
                  width: '25%',
                  name: 'iban'
                },
                {
                  displayName: 'Descrizione',
                  field: 'descrizione',
                  width: '15%',
                  name: 'descrizione'
                },
                {
                  displayName: 'Saldo Contabile',
                  cellFilter: 'number : 2',
                  cellClass: 'right',
                  field: 'saldoContabile',
                  width: '10%',
                  name: 'saldoContabile'
                },
                {
                  displayName: 'Intestatario',
                  cellClass: 'right',
                  field: 'intestazione',
                  width: '20%',
                  name: 'intestazione'
                },
                {
                  displayName: 'Stato',
                  field: 'stato',
                  width: '10%',
                  name: 'stato'
                },
                {
                  displayName: 'Data Apertura',
                  field: 'dataApertura',
                  cellFilter: 'date: "dd/MM/yyyy"',
                  width: '10%',
                  name: 'dataApertura'
                }
              ],
              data: self.contiCorrenti,
              onRegisterApi: function (gridApi) {
                self.gridApi = gridApi;
                self.gridApi.grid.modifyRows(self.gridOptions.data);

                // Se era già stato salvato il conto corrente lo recupero e lo seleziono
                if (
                  self.traslocoTelepassSrvc.datiPratica &&
                  self.traslocoTelepassSrvc.datiPratica.numeroRapporto
                ) {
                  angular.forEach(self.contiCorrenti, function (conto, index) {
                    if (
                      conto.numeroRapporto ===
                      self.traslocoTelepassSrvc.datiPratica.numeroRapporto
                    ) {
                      self.gridApi.selection.selectRow(
                        self.contiCorrenti[index]
                      );
                      self.contoSelezionato = self.contiCorrenti[index];
                    }
                  });
                }

                gridApi.selection.on.rowSelectionChanged($scope, function (row) {
                  self.selezionaConto(row);
                });
              }
            };
          },
          function (reason) {
            if (self.messaggiFctr.processaResponse(reason)) {
              self.spinner.showSpinner = false;
            }
          }
        )
        .finally(function () {
          self.spinner.showSpinner = false;
        });
    };

    /*
     * -------------------------------------
     *        INIZIALIZZAZIONE
     * -------------------------------------
     */
    self.init();
  };

  TlpsTraslocoDefinizioneProdottoCtrl.$inject = [
    '$scope',
    '$stateParams',
    'TLPS_CONSTANTS',
    'TlpsLabelSrvc',
    'TlpsMessaggiFctr',
    'TlpsTraslocoTelepassSrvc',
    'uiGridConstants',
    'TlpsUserSrvc'
  ];

  var TemplateUrl = function (CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'tlpsPostVendita/tlpsTraslocoTelepass/tlpsTraslocoDefinizione/tlpsTraslocoDettaglioProdotto/tlpsTraslocoDettaglioProdotto.html'
    );
  };

  TemplateUrl.$inject = ['TLPS_CONSTANTS'];

  var TlpsTraslocoDefinizioneProdottoComponent = {
    bindings: {},
    controller: TlpsTraslocoDefinizioneProdottoCtrl,
    controllerAs: 'traslocoDefinizioneProdottoCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.telepass.wa')
    .component(
      'tlpsTraslocoDefinizioneProdotto',
      TlpsTraslocoDefinizioneProdottoComponent
    );
})();


/***/ }),
/* 25 */
/***/ (function(module, exports) {

/**
 * @ngdoc directive
 * @name cbl.telepass.wa.directive:ccQuestionari
 * @restrict E
 * @description Componente che gestisce il terzo step "Valutazione" del dettaglio pratica
 */
(function() {
  'use strict';
  var TlpsTraslocoTelepassCtrl = function(
    $scope,
    $stateParams,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    $state,
    $uibModal,
    postVenditaSrvc,
    traslocoTelepassSrvc,
    propostaSrvc
  ) {
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.messaggiFctr = messaggiFctr;
    this.CONSTANTS = CONSTANTS;
    $scope.msg = labelSrvc.getLabel;
    this.postVenditaSrvc = postVenditaSrvc;
    this.traslocoTelepassSrvc = traslocoTelepassSrvc;
    this.propostaSrvc = propostaSrvc;
    this.$uibModal = $uibModal;

    this.spinner = this.postVenditaSrvc.spinner;

    this.ndg;

    var self = this;

    /*
     * -------------------------------------
     *         GESTIONE NAVIGAZIONE
     * -------------------------------------
     */

    /**
     * @ngdoc method
     * @name generaTabs
     * @methodOf cbl.telepass.wa.directive:tlpsProposta
     * @description Genera le tab necessarie al processo sulla base del cliente
     *              e della pratica ricevuti
     */

    this.traslocoTelepassSrvc.generaTabs = function() {
      // Svuoto le tab
      self.TAB_LIST_MACRO = [];
      self.TAB_LIST_MICRO = {};

      self.tabs = [
        {
          step: 'DEFINIZIONE',
          label: 'label.tab.definizione',
          posizione: '1',
          statoPratica: 'INCORSO',
          stepPratica: null,
          sottoStep: [
            {
              step: 'DETTAGLIO_PRODOTTO',
              label: 'label.tab.dettaglio.prodotto',
              posizione: '1.1',
              statoPratica: 'INCORSO',
              stepPratica: 1,
              sottoStep: null
            },
            {
              step: 'DATI_AGGIUNTIVI',
              label: 'label.tab.dati.aggiuntivi',
              posizione: '1.2',
              statoPratica: 'INCORSO',
              stepPratica: 2,
              sottoStep: null
            }
          ]
        },
        // {
        //   step: 'GESTIONE_CONDIZIONI',
        //   label: 'label.tab.gestione.condizioni',
        //   posizione: '2',
        //   statoPratica: 'INCORSO',
        //   stepPratica: 3,
        //   sottoStep: null
        // },
        {
          step: 'QUESTIONARI',
          label: 'label.tab.questionari',
          posizione: '2',
          statoPratica: 'INCORSO',
          stepPratica: null,
          sottoStep: [
            {
              step: 'QUESTIONARIO_PRIVACY',
              label: 'label.tab.questionario.privacy',
              posizione: '2.1',
              statoPratica: 'INCORSO',
              stepPratica: 4,
              sottoStep: null
            }
          ]
        },
        {
          step: 'DOCUMENTI',
          label: 'label.tab.documenti',
          posizione: '3',
          statoPratica: 'CONSOLIDATA',
          stepPratica: 1,
          sottoStep: null
        }
      ];

      // Ciclo sulle macroTabs
      for (var i in self.tabs) {
        var macroStepIndex = Number(i);

        self.TAB_LIST_MACRO.push({
          index: macroStepIndex,
          title:
            self.tabs[macroStepIndex].posizione +
            ' ' +
            $scope.msg(self.tabs[macroStepIndex].label),
          url: self.getMacroStepUrl(self.tabs[macroStepIndex].step)
        });

        // Per ogni macro tab compongo l'oggetto microTab con i sottoStep
        self.TAB_LIST_MICRO[self.tabs[macroStepIndex].step] = [];

        for (var j in self.tabs[macroStepIndex].sottoStep) {
          var microStepIndex = Number(j);

          self.TAB_LIST_MICRO[self.tabs[macroStepIndex].step].push({
            index: microStepIndex,
            title:
              self.tabs[macroStepIndex].sottoStep[microStepIndex].posizione +
              ' ' +
              $scope.msg(
                self.tabs[macroStepIndex].sottoStep[microStepIndex].label
              ),
            url: self.getMicroStepUrl(
              self.tabs[macroStepIndex].sottoStep[microStepIndex].step
            )
          });
        }
      }

      // Imposto i tab attivi
      var tabMacroIndex;
      var microStepIndex;

      // // Se la pratica è già stata creato imposto lo step corretto
      if (self.traslocoTelepassSrvc.datiPratica) {
        tabMacroIndex = self.getMacroStepIndex(
          self.traslocoTelepassSrvc.datiPratica.stato,
          self.traslocoTelepassSrvc.datiPratica.step
        );
        microStepIndex = self.getMicroStepIndex(
          self.traslocoTelepassSrvc.datiPratica.stato,
          self.traslocoTelepassSrvc.datiPratica.step
        );
      } else {
        // Altrimenti assegno il primo step
        tabMacroIndex = 0;
        microStepIndex = 0;
      }

      self.currentTabMacro = self.TAB_LIST_MACRO[tabMacroIndex];

      self.currentTabMicro = {};

      for (var k in self.tabs) {
        self.currentTabMicro[self.tabs[Number(k)].step] =
          self.TAB_LIST_MICRO[self.tabs[Number(k)].step][microStepIndex];
      }
    };

    /**
     * @ngdoc method
     * @name getMacroStepUrl
     * @methodOf cbl.cartadebito.wa.directive:tlpsProposta
     * @description Ritorna il corretto id del template html a seconda del nome del macroStep
     */
    this.getMacroStepUrl = function(step) {
      switch (step) {
        case 'DEFINIZIONE':
          return 'definizione.tmpl.html';
        case 'GESTIONE_CONDIZIONI':
          return 'gestioneCondizioni.tmpl.html';
        case 'QUESTIONARI':
          return 'questionari.tmpl.html';
        case 'DOCUMENTI':
          return 'documenti.tmpl.html';
        default:
          return '';
      }
    };

    /**
     * @ngdoc method
     * @name getMicroStepUrl
     * @methodOf cbl.cartadebito.wa.directive:tlpsProposta
     * @description Ritorna il corretto id del template html a seconda del nome del microStep
     */
    this.getMicroStepUrl = function(step) {
      switch (step) {
        case 'DETTAGLIO_PRODOTTO':
          return 'dettaglioProdotto.tmpl.html';
        case 'DATI_AGGIUNTIVI':
          return 'datiAggiuntivi.tmpl.html';
        case 'GESTIONE_CONDIZIONI':
          return 'gestioneCondizioni.tmpl.html';
        case 'QUESTIONARIO_PRIVACY':
          return 'questionarioPrivacy.tmpl.html';
        case 'DOCUMENTI':
          return 'documenti.tmpl.html';
        default:
          return '';
      }
    };

    /**
     * @ngdoc method
     * @name getMacroStepIndex
     * @methodOf cbl.cartadebito.wa:tlpsProposta
     * @description Ritorna l'indice della macrotab a seconda dello stato e step
     * della pratica. 0 - Definizione , 1 - Questionari , 2 - Carta e Pin , 3 - Documenti
     */
    this.getMacroStepIndex = function(stato, step) {
      if (stato === CONSTANTS.STATO_PRATICA.IN_CORSO) {
        switch (step) {
          // Definizione
          case 1:
          case 2:
            return 0;
          // Questionari
          case 4:
            return 1;
          default:
            return 0;
        }
      } else if (stato === CONSTANTS.STATO_PRATICA.CONSOLIDATA) {
        // Documenti
        return 2;
      } else {
        return 0;
      }
    };

    /**
     * @ngdoc method
     * @name getMicroStepIndex
     * @methodOf cbl.cartadebito.wa:tlpsProposta
     * @description Ritorna l'indice della microtab a seconda dello stato e step
     * della pratica. I tab con index 0 sono i primi del macro.
     */
    this.getMicroStepIndex = function(stato, step) {
      if (stato === CONSTANTS.STATO_PRATICA.IN_CORSO) {
        switch (step) {
          // Dettaglio Profotto
          case 1:
          // Condizioni
          case 3:
          // Questionari
          case 4:
            return 0;
          // Dati Aggiuntivi
          case 2:
            return 1;
          default:
            return 0;
        }
      } else if (stato === CONSTANTS.STATO_PRATICA.CONSOLIDATA) {
        // Documenti
        return 0;
      } else {
        return 0;
      }
    };

    /**
     * @ngdoc method
     * @name macroTabClicked
     * @methodOf cbl.cartadebito.wa.directive:tlpsProposta
     * @description Gestisce il click sulle macro tab
     * @param {Object} tab: l'oggetto tab selezionato
     */
    this.macroTabClicked = function(tab) {
      if (!self.traslocoTelepassSrvc.isPraticaNavigabile()) {
        return;
      }

      self.currentTabMacro = tab;

      // Riporto ogni step al primo sottoStep
      for (var k in self.tabs) {
        self.currentTabMicro[self.tabs[Number(k)].step] =
          self.TAB_LIST_MICRO[self.tabs[Number(k)].step][0];
      }
    };

    /**
     * @ngdoc method
     * @name getStyleTabMacro
     * @methodOf cbl.telepass.wa.directive:tlpsProposta
     * @description Imposta lo stile di visualizzazione per gli indicatori dei macro step
     * @param {number} currentTabIndex - L'indice della tab cui applicare lo stile
     * @return {string} - Restituisce lo stile da applicare all'indicatore del macro step
     */
    this.getStyleTabMacro = function(currentTabIndex) {
      // Pratica non navigabile
      if (currentTabIndex < this.currentTabMacro.index) {
        return 'progress-pass';
      }

      if (currentTabIndex === this.currentTabMacro.index) {
        return 'progress-current';
      }

      return 'progress-next';
    };

    /**
     * @ngdoc method
     * @name getStyleTabMacroReadOnly
     * @methodOf cbl.telepass.wa.directive:tlpsProposta
     * @description Imposta lo stile di visualizzazione per gli indicatori dei macro step in modalità sola lettura
     * @param {number} currentTabIndex - L'indice della tab cui applicare lo stile
     * @return {string} - Restituisce lo stile da applicare all'indicatore del macro step
     */
    this.getStyleTabMacroReadOnly = function(currentTabIndex) {
      if (currentTabIndex < this.currentTabMacro.index) {
        return 'progress-next-read';
      }

      if (currentTabIndex === this.currentTabMacro.index) {
        return 'progress-current-read';
      }

      return 'progress-next-read';
    };

    this.annullaPratica = function() {
      self.$uibModal
        .open({
          animation: true,
          templateUrl:
            CONSTANTS.BASE_ROOT +
            'components/tlpsProposta/tlpsModale/tlpsAnnulla.html',
          controller: 'TlpsModalController',
          controllerAs: 'modalCtrl',
          keyboard: false,
          backdrop: 'static',
          size: 'modal-lg'
        })
        .result.then(function(res) {});
    };

    this.rifiutaPratica = function() {
      self.$uibModal
        .open({
          animation: true,
          templateUrl:
            CONSTANTS.BASE_ROOT +
            'components/tlpsProposta/tlpsModale/tlpsRifiuta.html',
          controller: 'TlpsModalController',
          controllerAs: 'modalCtrl',
          keyboard: false,
          backdrop: 'static',
          size: 'modal-lg'
        })
        .result.then(function(res) {});
    };

    this.revisionaPratica = function() {
      self.$uibModal
        .open({
          animation: true,
          templateUrl:
            CONSTANTS.BASE_ROOT +
            'components/tlpsProposta/tlpsModale/tlpsRevisiona.html',
          controller: 'TlpsModalController',
          controllerAs: 'modalCtrl',
          keyboard: false,
          backdrop: 'static',
          size: 'modal-lg'
        })
        .result.then(function(res) {});
    };

    this.risottomettiPratica = function() {
      self.$uibModal
        .open({
          animation: true,
          templateUrl:
            CONSTANTS.BASE_ROOT +
            'components/tlpsProposta/tlpsModale/tlpsRisottometti.html',
          controller: 'TlpsModalController',
          controllerAs: 'modalCtrl',
          keyboard: false,
          backdrop: 'static',
          size: 'modal-lg'
        })
        .result.then(function(res) {});
    };

    /*
     * -------------------------------------
     *         GESTIONE PRATICA
     * -------------------------------------
     */

    this.recuperaPratica = function() {
      // Se esiste la pratica recupero il dettaglio, altrimenti la creo subito
      if (self.idPratica) {
        self.traslocoTelepassSrvc
          .promiseDettaglioPraticaTrasloco(self.idPratica, self.ndg)
          .then(
            function(response) {
              if (self.messaggiFctr.processaResponse(response)) {
                return;
              }

              self.datiPratica = self.traslocoTelepassSrvc.datiPratica =
                response.data.result;

              self.traslocoTelepassSrvc.generaTabs();
            },
            function(reason) {
              self.messaggiFctr.processaResponse(reason);
              self.spinner.showSpinner = false;
            }
          );
      } else {
        var req = self.creaRequestCreaPratica();

        self.traslocoTelepassSrvc.promiseCreaPratica(req).then(
          function(response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }
            self.$stateParams.idPratica = self.idPratica =
              response.data.result.idPratica;

            self.datiPratica = self.traslocoTelepassSrvc.datiPratica =
              response.data.result;

            self.$state.go('.', { ndg: self.ndg, idPratica: self.idPratica });
            // self.traslocoTelepassSrvc.generaTabs();
          },
          function(reason) {
            self.messaggiFctr.processaResponse(reason);
            self.spinner.showSpinner = false;
          }
        );
      }
    };

    this.creaRequestCreaPratica = function() {
      return {
        class: 'PraticaTelepassDto',
        intestatario: {
          ndg: self.ndg
        },
        workflow: 'TRASLOCO_BRIO',
        settore: 'TELEPASS'
      };
    };

    /*
     * -------------------------------------
     *           METODI INIT
     * -------------------------------------
     */

    this.init = function() {
      self.traslocoTelepassSrvc.datiPratica = self.datiPratica = undefined;
      self.traslocoTelepassSrvc.datiCliente = self.datiCliente = undefined;
      self.traslocoTelepassSrvc.datiPratica = self.datiProdotto = undefined;

      // Se sono presenti resetto i dati relativi alle proposte allestite precedentemente
      if (self.propostaSrvc) {
        self.propostaSrvc.datiPratica = undefined;
        self.propostaSrvc.datiCliente = undefined;
        self.propostaSrvc.datiPratica = undefined;
      }

      // Forzatura per lo spegnimento dello spinner generale dell'applicazione per poter gestire
      // correttamente quello locale.

      var overlay = document.getElementById('overlay');
      if (!!overlay) {
        overlay.setAttribute('style', 'display:none;');
      }

      self.spinner.showSpinner = true;

      self.ndg = self.$stateParams.ndg;
      self.idPratica = self.$stateParams.idPratica;

      self.postVenditaSrvc
        .promiseRecuperaAnagrafica(self.ndg)
        .then(function(response) {
          self.datiCliente = self.traslocoTelepassSrvc.datiCliente =
            response.data.result;

          self.recuperaPratica();
        });
    };

    /*
     * -------------------------------------
     *           INIZIALIZZAZIONE
     * -------------------------------------
     */

    self.init();
  };

  TlpsTraslocoTelepassCtrl.$inject = [
    '$scope',
    '$stateParams',
    'TLPS_CONSTANTS',
    'TlpsLabelSrvc',
    'TlpsMessaggiFctr',
    '$state',
    '$uibModal',
    'TlpsPostVenditaSrvc',
    'TlpsTraslocoTelepassSrvc',
    'TlpsPropostaSrvc'
  ];

  var TemplateUrl = function(CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'tlpsPostVendita/tlpsTraslocoTelepass/tlpsTraslocoTelepass.html'
    );
  };

  TemplateUrl.$inject = ['TLPS_CONSTANTS'];

  var TlpsTraslocoTelepassCtrl = {
    bindings: {},
    controller: TlpsTraslocoTelepassCtrl,
    controllerAs: 'traslocoTelepassCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.telepass.wa')
    .component('tlpsTraslocoTelepass', TlpsTraslocoTelepassCtrl);
})();


/***/ }),
/* 26 */
/***/ (function(module, exports) {

/**
 * @ngdoc service
 * @name cbl.telepass.wa.directive:tlpsProposta
 * @restrict E
 * @scope
 * @description Servizio che gestisce il processo di creazione nuova pratica e
 *              visualizzazione pratica esistente
 */
(function () {
  angular.module('cbl.telepass.wa').service('TlpsTraslocoTelepassSrvc', [
    '$http',
    'TlpsMessaggiFctr',
    'TLPS_CONSTANTS',
    'TlpsLabelSrvc',
    '$state',
    '$stateParams',
    'TlpsPostVenditaSrvc',
    function (
      $http,
      messaggiFctr,
      CONSTANTS,
      labelSrvc,
      $state,
      $stateParams,
      postVenditaSrvc
    ) {
      this.$http = $http;
      this.messaggiFctr = messaggiFctr;
      this.labelSrvc = labelSrvc;
      this.$state = $state;
      this.$stateParams = $stateParams;

      // Variabili generali pratica
      this.datiCliente = null;
      this.datiPratica = null;

      // Spinner
      this.spinner = postVenditaSrvc.spinner;

      var self = this;

      /**
       * Flag che indica se tutti i documenti sono stati firmati
       */
      this.documentiFirmati = false;


      /*
       * -------------------------------------
       *           PROMISE SERVIZI REST
       * -------------------------------------
       */
      /**
       * @ngdoc method
       * @name promiseRecuperaContiCorrenti
       * @methodOf cbl.telepass.wa.directive:TlpsPropostaSrvc
       * @description Effettua una chiamata http per recuperare i conti correnti dell'ndg
       * @return {Promise} - Ritorna una promise contenente la lista dei conti correnti
       */
      this.promiseRecuperaContiCorrenti = function (ndg) {
        return this.$http({
          method: 'GET',
          url:
            CONSTANTS.REST_ROOT +
            CONSTANTS.REST.CONTOCORRENTE.RICERCA_CONTICORRENTE,
          params: { ndg: ndg }
        });
      };

      /**
       * @ngdoc method
       * @name promiseDettaglioPratica
       * @methodOf cbl.telepass.wa.directive:TlpsPropostaSrvc
       * @description Effettua una chiamata http per recuperare i dettagli della pratica
       * @return {Promise} - Ritorna una promise contenente i dettagli della pratica
       */
      this.promiseDettaglioPraticaTrasloco = function (idPratica) {
        return this.$http({
          method: 'GET',
          url:
            CONSTANTS.REST_ROOT +
            CONSTANTS.REST.PRATICA.DETTAGLIO_PRATICA +
            'pratica/' +
            idPratica
        });
      };

      /**
       * @ngdoc method
       * @name promiseCreaPratica
       * @methodOf cbl.telepass.wa.directive:TlpsPropostaSrvc
       * @description Effettua una chiamata http per creare la pratica
       * @return {Promise} - Ritorna una promise contenente l'id della pratica appena creata
       */
      this.promiseCreaPratica = function (request) {
        return this.$http({
          method: 'POST',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.CREA_PRATICA,
          data: request
        });
      };

      /**
       * @ngdoc method
       * @name promiseAggiornaPratica
       * @methodOf cbl.telepass.wa:TlpsPropostaSrvc
       * @description Effettua una chiamata http per aggiornare la pratica che si sta allestendo
       * @return {Promise} - Ritorna una promise contenente il dettaglio della pratica
       */
      this.promiseAggiornaPraticaAvanti = function (datiPratica) {
        return this.$http({
          method: 'PUT',
          url:
            CONSTANTS.REST_ROOT +
            CONSTANTS.REST.PRATICA.DETTAGLIO_PRATICA +
            'pratica/' +
            datiPratica.idPratica +
            '/avanti',
          data: datiPratica
        });
      };

      /**
       * @ngdoc method
       * @name promiseAggiornaPratica
       * @methodOf cbl.telepass.wa:TlpsPropostaSrvc
       * @description Effettua una chiamata http per aggiornare la pratica che si sta allestendo
       * @return {Promise} - Ritorna una promise contenente il dettaglio della pratica
       */
      this.promiseAggiornaPraticaIndietro = function (datiPratica) {
        return this.$http({
          method: 'PUT',
          url:
            CONSTANTS.REST_ROOT +
            CONSTANTS.REST.PRATICA.DETTAGLIO_PRATICA +
            'pratica/' +
            datiPratica.idPratica +
            '/indietro',
          data: datiPratica
        });
      };

      /**
       * @ngdoc method
       * @name promiseAggiornaPratica
       * @methodOf cbl.telepass.wa:TlpsPropostaSrvc
       * @description Effettua una chiamata http per aggiornare la pratica che si sta allestendo
       * @return {Promise} - Ritorna una promise contenente il dettaglio della pratica
       */
      this.promiseAggiornaPraticaSalva = function (datiPratica) {
        return this.$http({
          method: 'PUT',
          url:
            CONSTANTS.REST_ROOT +
            CONSTANTS.REST.PRATICA.DETTAGLIO_PRATICA +
            'pratica/' +
            datiPratica.idPratica,
          data: datiPratica
        });
      };

      /**
       * @ngdoc method
       * @name promiseAnnullaPratica
       * @methodOf cbl.telepass.wa:TlpsPropostaSrvc
       * @description Effettua una chiamata http per annullare e cancellare la pratica che si sta allestendo
       * @return {Promise} - Ritorna una promise contenente un booleano con la risposta alla cancellazione
       */
      this.promiseAnnullaPratica = function (pratica) {
        return this.$http({
          method: 'PUT',
          url:
            CONSTANTS.REST_ROOT +
            CONSTANTS.REST.PRATICA.ANNULLA_PRATICA.replace(
              '{idPratica}',
              pratica.idPratica
            ),
          data: pratica
        });
      };

      /**
       * @ngdoc method
       * @name promiseRifiutaPratica
       * @methodOf cbl.telepass.wa:TlpsPropostaSrvc
       * @description Effettua una chiamata http per rifiutare la pratica che si sta allestendo
       * @return {Promise} - Ritorna una promise contenente un booleano con la risposta alla cancellazione
       */
      this.promiseRifiutaPratica = function (pratica) {
        return this.$http({
          method: 'PUT',
          url:
            CONSTANTS.REST_ROOT +
            CONSTANTS.REST.PRATICA.RIFIUTA_PRATICA.replace(
              '{idPratica}',
              pratica.idPratica
            ),
          data: pratica
        });
      };

      /**
       * @ngdoc method
       * @name promiseRisottomettiPratica
       * @methodOf cbl.telepass.wa:TlpsPropostaSrvc
       * @description Effettua una chiamata http per rifiutare la pratica che si sta allestendo
       * @return {Promise} - Ritorna una promise contenente un booleano con la risposta alla cancellazione
       */
      this.promiseRisottomettiPratica = function (pratica) {
        return this.$http({
          method: 'PUT',
          url:
            CONSTANTS.REST_ROOT +
            CONSTANTS.REST.PRATICA.RISOTTOMETTI_PRATICA.replace(
              '{idPratica}',
              pratica.idPratica
            ),
          data: pratica
        });
      };

      /**
       * @ngdoc method
       * @name promiseCompletaProposta
       * @methodOf cbl.telepass.wa:TlpsPropostaSrvc
       * @description Effettua una chiamata http per completare la pratica che si sta allestendo
       * @return {Promise} - Ritorna una promise contenente un booleano con l'esito del completamento
       */
      this.promiseCompletaProposta = function (idPratica, ndg) {
        var qryParams = {
          idPratica: idPratica,
          ndg: ndg
        };

        return this.$http({
          method: 'PUT',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.COMPLETA_PRATICA,
          data: {},
          params: qryParams
        });
      };

      /**
       * @ngdoc method
       * @name goToSchedaCliente
       * @methodOf cbl.telepass.wa.directive:tlpsProposta
       * @description Ridireziona verso la scheda del cliente
       */
      this.goToSchedaCliente = function () {
        self.datiPratica = null;
        self.datiCliente = null;
        self.datiProdotto = null;

        self.$state.go('schedaCliente', { ndg: self.$stateParams.ndg });
      };

      /**
       * Funzione implementata per poter utilizzare il controller delle modali alla stessa maniera
       * sia nella parte di proposta che in quella di post vendita. In quella di Post Vendita Trasloco
       * non occorre eliminare nessun campo quindi la funzione non fa niente.
       */
      this.pulisciDati = function (dati) {
        return;
      };

      this.indietro = function () {
        self.messaggiFctr.resetMessages();

        var pratica = self.buildRequestObject();

        self.pulisciDati(pratica);

        self.spinner.showSpinner = true;

        self
          .promiseAggiornaPraticaIndietro(pratica)
          .then(
            function (response) {
              if (self.messaggiFctr.processaResponse(response)) {
                self.spinner.showSpinner = false;
                return;
              }
              if (response.data.result) {
                // Sostituisco i dati della pratica con quelli aggiornati che mi ritornano i servizi
                self.datiPratica = response.data.result;
                self.$stateParams.idPratica = self.idPratica =
                  response.data.result.idPratica;

                self.generaTabs();
              }
            },
            function (error) {
              if (self.messaggiFctr.processaResponse(error)) {
                self.spinner.showSpinner = false;
                return;
              }
            }
          )
          .finally(function () {
            self.spinner.showSpinner = false;
          });
      };

      /**
       * @ngdoc method
       * @name save
       * @methodOf cbl.telepass.wa:CcpropostaTelepassSrvc
       * @description Esegue le chiamate per salvare la pratica se già esiste altrimenti quella per crearla.
       */
      this.salva = function () {
        self.messaggiFctr.resetMessages();

        if (!self.datiValidi()) {
          return;
        }

        var pratica = self.buildRequestObject();

        self.spinner.showSpinner = true;

        self
          .promiseAggiornaPraticaSalva(pratica)
          .then(
            function (response) {
              if (self.messaggiFctr.processaResponse(response)) {
                self.spinner.showSpinner = false;
                return;
              }
              if (response.data.result) {
                // Sostituisco i dati della pratica con quelli aggiornati che mi ritornano i servizi
                self.datiPratica = response.data.result;
                self.$stateParams.idPratica = self.idPratica =
                  response.data.result.idPratica;

                // Aggiorno i parametri nella URL per poterli mettere a disposizione anche degli altri componenti
                self.$state.go('.', self.idPratica);
                self.generaTabs();
              }
            },
            function (error) {
              if (self.messaggiFctr.processaResponse(error)) {
                self.spinner.showSpinner = false;
                return;
              }
            }
          )
          .finally(function () {
            self.spinner.showSpinner = false;
          });
      };

      this.salvaAvanza = function () {
        var pratica = self.buildRequestObject();

        self.spinner.showSpinner = true;

        self
          .promiseAggiornaPraticaAvanti(pratica)
          .then(
            function (response) {
              if (self.messaggiFctr.processaResponse(response)) {
                self.spinner.showSpinner = false;
                return;
              }

              if (response.data.result) {
                // Sostituisco i dati della pratica con quelli aggiornati che mi ritornano i servizi
                self.datiPratica = response.data.result;
                self.$stateParams.idPratica = self.idPratica =
                  response.data.result.idPratica;

                // Aggiorno i parametri nella URL per poterli mettere a disposizione anche degli altri componenti
                if (
                  self.datiPratica.stato !== CONSTANTS.STATO_PRATICA.IN_CORSO &&
                  self.datiPratica.stato !== CONSTANTS.STATO_PRATICA.CONSOLIDATA
                ) {
                  var message = {};
                  message.type = 'I';
                  message.message = self.datiPratica.stato === CONSTANTS.STATO_PRATICA.PRESENTATA ? 'Pratica presentata' :
                    'Pratica completata con successo. La pratica è in stato di valutazione in attesa di esito da parte di Telepass';
                  messaggiFctr.addMessage(message);
                  self.goToSchedaCliente();
                } else {
                  self.$state.go('.', self.idPratica);
                  self.generaTabs();
                }
              }
            },
            function (error) {
              if (self.messaggiFctr.processaResponse(error)) {
                self.spinner.showSpinner = false;
                return;
              }
            }
          )
          .finally(function () {
            self.spinner.showSpinner = false;
          });
      };

      this.avanza = function () {
        self.messaggiFctr.resetMessages();

        if (self.datiValidi()) {
          self.salvaAvanza();
        }
      };

      this.buildRequestObject = function () {
        if (self.datiPratica.settore === 'TELEPASS') {
          self.datiPratica.class = 'PraticaTelepassDto';
        } else if (self.datiPratica.settore === 'VIACARD') {
          self.datiPratica.class = 'PraticaViacardDto';
        }
        return {
          idPratica: self.datiPratica.idPratica,
          class: self.datiPratica.class,
          intestatario: {
            ndg: self.datiCliente.ndg
          },
          stato: self.datiPratica.stato,
          inserimento: self.datiPratica.inserimento,
          step: self.datiPratica.step,
          workflow: 'TRASLOCO_BRIO',
          settore: self.datiPratica.settore,
          numeroRapporto: self.datiPratica.numeroRapporto,
          questionarioPraticaList: self.datiPratica.questionarioPraticaList,
          codiceApparato: self.datiPratica.codiceApparato,
          codiceContrattoTrasloco: self.datiPratica.codiceContrattoTrasloco
        };
      };
      /*
       * -------------------------------------
       *        GESTIONE NAVIGAZIONE
       * -------------------------------------
       */

      /**
       * @ngdoc method
       * @name isPraticaNavigabile
       * @methodOf cbl.telepass.wa.directive:tlpsProposta
       * @description Verifica se la pratica non è in stato INCORSO o CONSOLIDATA, e quindi navigabile
       * @return {Boolean} - True se la pratica è navigabile, false in caso contrario
       */
      this.isPraticaNavigabile = function () {
        if (!self.datiPratica) {
          return false;
        }
        return (
          self.datiPratica &&
          self.datiPratica.stato &&
          self.datiPratica.stato !== CONSTANTS.STATO_PRATICA.IN_CORSO &&
          self.datiPratica.stato !== CONSTANTS.STATO_PRATICA.CONSOLIDATA &&
          self.datiPratica.stato !== CONSTANTS.STATO_PRATICA.DAREVISIONARE
        );
        // return true;
      };

      this.isCompletaAbilitato = function() {
        return self.getIsStatoCorretto() && self.documentiFirmati;
      };

      this.getIsStatoCorretto = function() {
        return (
            self.datiPratica &&
            ((self.datiPratica.stato === CONSTANTS.STATO_PRATICA.CONSOLIDATA && self.datiPratica.step === 3) ||
                (self.datiPratica.stato === CONSTANTS.STATO_PRATICA.CONSOLIDATA && self.datiPratica.step === 6) ||
                (self.datiPratica.stato === CONSTANTS.STATO_PRATICA.PRESENTATA && self.datiPratica.step === 1) ||
                (self.datiPratica.stato === CONSTANTS.STATO_PRATICA.PRESENTATA && self.datiPratica.step === 2) ||
                (self.datiPratica.stato === CONSTANTS.STATO_PRATICA.PRESENTATA && self.datiPratica.step === 3))
        );
      };


      this.getProsegui = function () {
        if (!self.datiPratica) {
          return false;
        }
        return self.datiPratica.stato === CONSTANTS.STATO_PRATICA.IN_CORSO
            || self.datiPratica.stato === CONSTANTS.STATO_PRATICA.DAREVISIONARE;
      };

      /**
       * @ngdoc method
       * @name formattazioneData
       * @methodOf cbl.telepass.wa:CcpropostaTelepassSrvc
       * @description Formatta la data per visualizzarla
       */
      this.formattazioneData = function (data) {
        if (!data) {
          return '';
        }

        var giorno = data.dayOfMonth;
        var mese = data.monthValue;
        var anno = data.year;

        return giorno + '/' + mese + '/' + anno;
      };
    }
  ]);
})();


/***/ }),
/* 27 */
/***/ (function(module, exports) {

/**
 * @ngdoc directive
 * @name cbl.telepass.wa.directive:tlpsDefinizioneProdotto
 * @restrict E
 * @description Componente che gestisce il primo step "Stato Affidamento" del
 *              dettaglio pratica
 */
(function () {
  'use strict';
  var tlpsDatiAggiuntiviCtrl = function (
    $scope,
    $stateParams,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    propostaTelepassSrvc,
    userSrvc,
    $state,
    domainSrvc,
    $q,
    definizioneSrvc
  ) {
    this.$stateParams = $stateParams;
    this.messaggiFctr = messaggiFctr;
    this.CONSTANTS = CONSTANTS;
    this.userSrvc = userSrvc;
    $scope.msg = labelSrvc.getLabel;
    this.propostaTelepassSrvc = propostaTelepassSrvc;
    this.$state = $state;
    this.domainSrvc = domainSrvc;
    this.$q = $q;
    this.definizioneSrvc = definizioneSrvc;

    this.emailDisabled = true;
    this.telefonoDisabled = true;

    this.disableIndirizzoDiversoResidenza = true;

    this.modalitaRitiroList = [];
    this.comuni = [];
    this.province = [];
    this.localita = [];
    this.capFiltrati = [];

    // Spinner
    this.spinner = this.propostaTelepassSrvc.spinner;

    this.idPratica;
    this.idProdotto;

    this.ndgRappresentanteDaMostrare = null;

    var self = this;

    /*
     * -------------------------------------
     *          GESTIONE INTERFACCIA
     * -------------------------------------
     */

    /**
     * @ngdoc method
     * @name controllaTelefono
     * @methodOf cbl.telepass.wa:propostaTelepassSrvc
     * @description Verifica se la email e il telefono sono valorizzati, se lo sono, disabilita il campo input.
     */
    this.controllaTelefono = function () {
      if (!self.propostaTelepassSrvc.datiCliente.recapito.telefono) {
        self.telefonoDisabled = false;
      }
    };

    /**
     * @ngdoc method
     * @name controllaEmail
     * @methodOf cbl.telepass.wa:propostaTelepassSrvc
     * @description Verifica se la email e il telefono sono valorizzati, se lo sono, disabilita il campo input.
     */
    this.controllaEmail = function () {
      if (!self.propostaTelepassSrvc.datiCliente.recapito.email) {
        self.emailDisabled = false;
      }
    };

    this.propostaTelepassSrvc.datiValidi = function () {
      var errori = false;

      if (!self.propostaTelepassSrvc.datiCliente.email) {
        var message = {};
        message.type = 'E';
        message.message = 'Email obbligatoria';
        messaggiFctr.addMessage(message);
        errori = true;
      }

      if (!self.propostaTelepassSrvc.datiCliente.telefono) {
        var message = {};
        message.type = 'E';
        message.message = 'Numero di telefono obbligatorio';
        messaggiFctr.addMessage(message);
        errori = true;
      }

      //Controlla se la pratica è Telepass, sia stata selezionata la modalità di ritiro
      if (!self.propostaTelepassSrvc.datiPratica.modalitaRitiro) {
        var message = {};
        message.type = 'E';
        message.message = 'Si deve selezionare la modalità di ritiro';
        messaggiFctr.addMessage(message);
        errori = true;
      }

      //Controlla se la pratica è Telepass, e si abbia scelto la modalità di ritiro 'filiale', sia valorizzato il codice apparato
      if (
        self.propostaTelepassSrvc.datiProdotto.settoreProdotto === '30' &&
        self.propostaTelepassSrvc.datiPratica.modalitaRitiro &&
        self.propostaTelepassSrvc.datiPratica.modalitaRitiro.codice === 'F' &&
        !self.propostaTelepassSrvc.datiPratica.codiceApparato
      ) {
        var message = {};
        message.type = 'E';
        message.message = 'Si deve valorizzare il codice apparato';
        messaggiFctr.addMessage(message);
        errori = true;
      }

      //Controlla se la pratica è Telepass, e si abbia scelto la modalità di ritiro 'filiale' e il apparato aggiuntivo, sia valorizzato il codice apparato aggiuntivo
      if (
        self.propostaTelepassSrvc.datiProdotto.settoreProdotto === '30' &&
        self.propostaTelepassSrvc.datiPratica.modalitaRitiro &&
        self.propostaTelepassSrvc.datiPratica.modalitaRitiro.codice === 'F' &&
        self.propostaTelepassSrvc.datiPratica.twin &&
        !self.propostaTelepassSrvc.datiPratica.codiceApparatoTwin
      ) {
        var message = {};
        message.type = 'E';
        message.message = 'Si deve valorizzare il codice apparato twin';
        messaggiFctr.addMessage(message);
        errori = true;
      }

      //Controlla se la pratica è Telepass, siano valorizzate la nazione e il numero di targa
      if (
        self.propostaTelepassSrvc.datiProdotto.settoreProdotto === '30' &&
        (!self.propostaTelepassSrvc.datiPratica.nazioneTarga || !self.propostaTelepassSrvc.datiPratica.targa)
      ) {
        var message = {};
        message.type = 'E';
        message.message = 'Si devono valorizzare la nazione e la targa';
        messaggiFctr.addMessage(message);
        errori = true;
      }

      //Controlla se la pratica è Telepass, e si abbia scelto il apparato aggiuntivo, siano valorizzate la nazione e il numero di targa twin
      if (
        self.propostaTelepassSrvc.datiProdotto.settoreProdotto === '30' &&
        self.propostaTelepassSrvc.datiPratica.twin &&
        (!self.propostaTelepassSrvc.datiPratica.nazioneTargaTwin || !self.propostaTelepassSrvc.datiPratica.targaTwin)
      ) {
        var message = {};
        message.type = 'E';
        message.message = 'Si devono valorizzare la nazione e la targa dell`apparato aggiuntivo';
        messaggiFctr.addMessage(message);
        errori = true;
      }

      //Controlla se la pratica è Telepass, e si abbia scelto il apparato aggiuntivo, la targa e la targa twin siano diverse
      if (
        self.propostaTelepassSrvc.datiProdotto.settoreProdotto === '30' &&
        self.propostaTelepassSrvc.datiPratica.twin &&
        self.propostaTelepassSrvc.datiPratica.targa &&
        self.propostaTelepassSrvc.datiPratica.targaTwin &&
        self.propostaTelepassSrvc.datiPratica.targa === self.propostaTelepassSrvc.datiPratica.targaTwin
      ) {
        var message = {};
        message.type = 'E';
        message.message = 'La targa e la targa twin devono essere diverse';
        messaggiFctr.addMessage(message);
        errori = true;
      }

      if (
        self.propostaTelepassSrvc.datiPratica.modalitaRitiro &&
        self.propostaTelepassSrvc.datiPratica.modalitaRitiro.codice === 'S'
      ) {
        if (!self.propostaTelepassSrvc.datiPratica.datiSpedizione.nazione) {
          var message = {};
          message.type = 'E';
          message.message = 'Nazione non valorizzata in indirizzo spedizione';
          messaggiFctr.addMessage(message);
          errori = true;
        }

        if (!self.propostaTelepassSrvc.datiPratica.datiSpedizione.provincia) {
          var message = {};
          message.type = 'E';
          message.message = 'Provincia non valorizzata in indirizzo spedizione';
          messaggiFctr.addMessage(message);
          errori = true;
        }
        if (!self.propostaTelepassSrvc.datiPratica.datiSpedizione.citta) {
          var message = {};
          message.type = 'E';
          message.message = 'Comune non valorizzato in indirizzo spedizione';
          messaggiFctr.addMessage(message);
          errori = true;
        }
        if (!self.propostaTelepassSrvc.datiPratica.datiSpedizione.cap) {
          var message = {};
          message.type = 'E';
          message.message = 'CAP non valorizzato in indirizzo spedizione';
          messaggiFctr.addMessage(message);
          errori = true;
        }
        if (!self.propostaTelepassSrvc.datiPratica.datiSpedizione.via) {
          var message = {};
          message.type = 'E';
          message.message = 'Indirizzo non valorizzato in indirizzo spedizione';
          messaggiFctr.addMessage(message);
          errori = true;
        }
        if (!self.propostaTelepassSrvc.datiPratica.datiSpedizione.localita) {
          var message = {};
          message.type = 'E';
          message.message = 'Località non valorizzata in indirizzo spedizione';
          messaggiFctr.addMessage(message);
          errori = true;
        }
      }

      //Controlli dati residenza e documento d'identità

      if (self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti !== null) {
        //verifica dati anagrafici documenti aziendali

        if (
          !self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti[0].recapito.paese ||
          !self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti[0].recapito.paese.codice
        ) {
          var message = {};
          message.type = 'E';
          message.message = 'Nazione residenza obbligatoria';
          messaggiFctr.addMessage(message);
          errori = true;
        }

        if (
          !self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti[0].recapito.provincia ||
          !self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti[0].recapito.provincia.codice
        ) {
          var message = {};
          message.type = 'E';
          message.message = 'Provincia residenza obbligatoria';
          messaggiFctr.addMessage(message);
          errori = true;
        }

        if (
          !self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti[0].recapito.comune ||
          !self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti[0].recapito.comune.codice
        ) {
          var message = {};
          message.type = 'E';
          message.message = 'Comune residenza obbligatorio';
          messaggiFctr.addMessage(message);
          errori = true;
        }

        if (!self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti[0].recapito.cap) {
          var message = {};
          message.type = 'E';
          message.message = 'CAP residenza obbligatorio';
          messaggiFctr.addMessage(message);
          errori = true;
        }

        if (!self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti[0].recapito.localita) {
          var message = {};
          message.type = 'E';
          message.message = 'Località residenza obbligatoria';
          messaggiFctr.addMessage(message);
          errori = true;
        }

        if (!self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti[0].recapito.via) {
          var message = {};
          message.type = 'E';
          message.message = 'Via residenza obbligatoria';
          messaggiFctr.addMessage(message);
          errori = true;
        }

        if (!self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti[0].documentoIdentita.tipoDocumento) {
          var message = {};
          message.type = 'E';
          message.message = 'Tipo Documento obbligatorio';
          messaggiFctr.addMessage(message);
          errori = true;
        }

        if (!self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti[0].documentoIdentita.numeroDocumento) {
          var message = {};
          message.type = 'E';
          message.message = 'Numero Documento obbligatorio';
          messaggiFctr.addMessage(message);
          errori = true;
        }

        if (
          !self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti[0].documentoIdentita
            .localitaAutoritaRilascioDocumento
        ) {
          var message = {};
          message.type = 'E';
          message.message = 'Comune rilascio Documento obbligatorio';
          messaggiFctr.addMessage(message);
          errori = true;
        }

        if (
          !self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti[0].documentoIdentita.dataRilascioDocumento
        ) {
          var message = {};
          message.type = 'E';
          message.message = 'Data rilascio Documento obbligatoria';
          messaggiFctr.addMessage(message);
          errori = true;
        }

        if (
          !self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti[0].documentoIdentita.dataScadenzaDocumento
        ) {
          var message = {};
          message.type = 'E';
          message.message = 'Data scadenza Documento obbligatoria';
          messaggiFctr.addMessage(message);
          errori = true;
        }

        if (!self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti[0].documentoIdentita.nazione) {
          var message = {};
          message.type = 'E';
          message.message = 'Nazione Documento obbligatoria';
          messaggiFctr.addMessage(message);
          errori = true;
        }
      }
      if (self.propostaTelepassSrvc.datiCliente.documentoIdentita !== null) {
        //verifica dati anagrafici persona fisica

        if (
          !self.propostaTelepassSrvc.datiCliente.recapito.paese ||
          !self.propostaTelepassSrvc.datiCliente.recapito.paese.codice
        ) {
          var message = {};
          message.type = 'E';
          message.message = 'Nazione residenza obbligatoria';
          messaggiFctr.addMessage(message);
          errori = true;
        }

        if (
          !self.propostaTelepassSrvc.datiCliente.recapito.provincia ||
          !self.propostaTelepassSrvc.datiCliente.recapito.provincia.codice
        ) {
          var message = {};
          message.type = 'E';
          message.message = 'Provincia residenza obbligatoria';
          messaggiFctr.addMessage(message);
          errori = true;
        }

        if (
          !self.propostaTelepassSrvc.datiCliente.recapito.comune ||
          !self.propostaTelepassSrvc.datiCliente.recapito.comune.codice
        ) {
          var message = {};
          message.type = 'E';
          message.message = 'Comune residenza obbligatorio';
          messaggiFctr.addMessage(message);
          errori = true;
        }

        if (!self.propostaTelepassSrvc.datiCliente.recapito.cap) {
          var message = {};
          message.type = 'E';
          message.message = 'CAP residenza obbligatorio';
          messaggiFctr.addMessage(message);
          errori = true;
        }

        if (!self.propostaTelepassSrvc.datiCliente.recapito.localita) {
          var message = {};
          message.type = 'E';
          message.message = 'Località residenza obbligatoria';
          messaggiFctr.addMessage(message);
          errori = true;
        }

        if (!self.propostaTelepassSrvc.datiCliente.recapito.via) {
          var message = {};
          message.type = 'E';
          message.message = 'Via residenza obbligatoria';
          messaggiFctr.addMessage(message);
          errori = true;
        }

        if (!self.propostaTelepassSrvc.datiCliente.documentoIdentita.tipoDocumento) {
          var message = {};
          message.type = 'E';
          message.message = 'Tipo Documento obbligatorio';
          messaggiFctr.addMessage(message);
          errori = true;
        }

        if (!self.propostaTelepassSrvc.datiCliente.documentoIdentita.numeroDocumento) {
          var message = {};
          message.type = 'E';
          message.message = 'Numero Documento obbligatorio';
          messaggiFctr.addMessage(message);
          errori = true;
        }

        if (!self.propostaTelepassSrvc.datiCliente.documentoIdentita.rilasciatoDa) {
          var message = {};
          message.type = 'E';
          message.message = 'Comune rilascio Documento obbligatorio';
          messaggiFctr.addMessage(message);
          errori = true;
        }

        if (!self.propostaTelepassSrvc.datiCliente.documentoIdentita.dataRilascio) {
          var message = {};
          message.type = 'E';
          message.message = 'Data rilascio Documento obbligatoria';
          messaggiFctr.addMessage(message);
          errori = true;
        }

        if (!self.propostaTelepassSrvc.datiCliente.documentoIdentita.dataScadenza) {
          var message = {};
          message.type = 'E';
          message.message = 'Data scadenza Documento obbligatoria';
          messaggiFctr.addMessage(message);
          errori = true;
        }

        if (!self.propostaTelepassSrvc.datiCliente.documentoIdentita.nazione) {
          var message = {};
          message.type = 'E';
          message.message = 'Nazione Documento obbligatoria';
          messaggiFctr.addMessage(message);
          errori = true;
        }
      }

      if (errori) {
        return false;
      }

      return true;
    };

    this.findCodiceProvincia = function (descrizioneProvincia) {
      var provincia = self.province.find(function (item) {
        return item.descrizione === descrizioneProvincia;
      });

      return provincia ? provincia.codice : '';
    };

    // this.findCodiceCitta = function(descrizioneCitta) {
    //   var citta = self.comuni.find(function(item) {
    //     return item.descrizione === descrizioneCitta;
    //   });

    //   if (!citta) {
    //     self.spinner.showSpinner = true;

    //     self.domainSrvc
    //       .promiseDomain(
    //         'COMUNE',
    //         self.propostaTelepassSrvc.datiPratica.datiSpedizione.provincia
    //       )
    //       .then(function(domain) {
    //         self.comuni = domain;

    //         var c = self.comuni.find(function(item) {
    //           return item.descrizione === descrizioneCitta;
    //         });

    //         self.propostaTelepassSrvc.datiPratica.datiSpedizione.citta = c
    //           ? c.codice
    //           : '';
    //       })
    //       .finally(function() {
    //         self.spinner.showSpinner = false;
    //       });
    //   }

    //   return citta ? citta.codice : '';
    // };

    this.selezionaTipoIndirizzo = function () {
      if (self.propostaTelepassSrvc.datiPratica.datiSpedizione.flIndirizzoSpedizione) {
        // self.propostaTelepassSrvc.datiPratica.datiSpedizione.nazione = '086';

        self.propostaTelepassSrvc.datiPratica.datiSpedizione.nazione =
          self.propostaTelepassSrvc.datiCliente.recapito.paese.codice;

        self.propostaTelepassSrvc.datiPratica.datiSpedizione.provincia =
          self.propostaTelepassSrvc.datiCliente.recapito.provincia.codice;

        self.propostaTelepassSrvc.datiPratica.datiSpedizione.citta =
          self.propostaTelepassSrvc.datiCliente.recapito.comune.codice;

        self.propostaTelepassSrvc.datiPratica.datiSpedizione.cap = self.propostaTelepassSrvc.datiCliente.recapito.cap;
        self.propostaTelepassSrvc.datiPratica.datiSpedizione.via = self.propostaTelepassSrvc.datiCliente.recapito.via;

        self.propostaTelepassSrvc.datiPratica.datiSpedizione.nome = self.propostaTelepassSrvc.datiCliente.recapito.nome;

        self.propostaTelepassSrvc.datiPratica.datiSpedizione.cognome =
          self.propostaTelepassSrvc.datiCliente.recapito.cognome;

        self.propostaTelepassSrvc.datiPratica.datiSpedizione.localita =
          self.propostaTelepassSrvc.datiCliente.recapito.localita;
      } else {
        self.propostaTelepassSrvc.datiPratica.datiSpedizione.nazione = null;
        self.propostaTelepassSrvc.datiPratica.datiSpedizione.provincia = null;
        self.propostaTelepassSrvc.datiPratica.datiSpedizione.citta = null;
        self.propostaTelepassSrvc.datiPratica.datiSpedizione.cap = null;
        self.propostaTelepassSrvc.datiPratica.datiSpedizione.localita = null;
        self.propostaTelepassSrvc.datiPratica.datiSpedizione.via = null;
      }
    };

    this.selezionaModalitaRitiro = function () {
      if (!self.propostaTelepassSrvc.datiPratica.modalitaRitiro) {
        return;
      }

      // Se la modalità di ritiro è diversa da spedizione non passo i dati di spedizione
      if (self.propostaTelepassSrvc.datiPratica.modalitaRitiro.codice !== 'S') {
        self.propostaTelepassSrvc.datiPratica.datiSpedizione.nazione = null;
        self.propostaTelepassSrvc.datiPratica.datiSpedizione.provincia = null;
        self.propostaTelepassSrvc.datiPratica.datiSpedizione.citta = null;
        self.propostaTelepassSrvc.datiPratica.datiSpedizione.cap = null;
        self.propostaTelepassSrvc.datiPratica.datiSpedizione.localita = null;
        self.propostaTelepassSrvc.datiPratica.datiSpedizione.via = null;
        self.propostaTelepassSrvc.datiPratica.datiSpedizione.flIndirizzoSpedizione = null;
      }

      if (self.propostaTelepassSrvc.datiPratica.modalitaRitiro.codice !== 'F') {
        self.propostaTelepassSrvc.datiPratica.codiceApparato = null;
        self.propostaTelepassSrvc.datiPratica.codiceApparatoTwin = null;
      }

      if (
        self.propostaTelepassSrvc.datiPratica.modalitaRitiro.codice === 'S' &&
        (self.propostaTelepassSrvc.datiPratica.datiSpedizione.flIndirizzoSpedizione === null ||
          self.propostaTelepassSrvc.datiPratica.datiSpedizione.flIndirizzoSpedizione === undefined)
      ) {
        self.propostaTelepassSrvc.datiPratica.datiSpedizione.flIndirizzoSpedizione = true;
        self.selezionaTipoIndirizzo();
      }
    };

    this.onChangeProvincia = function () {
      self.propostaTelepassSrvc.datiPratica.datiSpedizione.citta = null;
      self.propostaTelepassSrvc.datiPratica.datiSpedizione.cap = null;
      self.propostaTelepassSrvc.datiPratica.datiSpedizione.localita = null;
      self.recuperaComuni();
    };

    this.onChangeComune = function () {
      self.propostaTelepassSrvc.datiPratica.datiSpedizione.cap = null;
      self.propostaTelepassSrvc.datiPratica.datiSpedizione.localita = null;
      self.recuperaCAP();
    };

    this.onChangeCap = function () {
      self.propostaTelepassSrvc.datiPratica.datiSpedizione.localita = null;
      self.recuperaLocalita();
    };

    /**
     * @ngdoc method
     * @name recuperaComuni
     * @methodOf cbl.telepass.wa:propostaTelepassSrvc
     * @description Recupera i comuni per la spedizione.
     */
    this.recuperaComuni = function () {
      self.spinner.showSpinner = true;
      self.comuni = [];
      var provincia =
        self.propostaTelepassSrvc.datiPratica.datiSpedizione.provincia ||
        self.findCodiceProvincia(self.propostaTelepassSrvc.datiCliente.recapito.provincia);

      if (!provincia) {
        self.spinner.showSpinner = false;
        return;
      }

      self.domainSrvc
        .promiseDomain('COMUNE', provincia)
        .then(function (domain) {
          self.comuni = domain;

          if (
            self.propostaTelepassSrvc.datiPratica.settore === 'VIACARD' &&
            (self.propostaTelepassSrvc.datiPratica.datiSpedizione.flIndirizzoSpedizione === null ||
              self.propostaTelepassSrvc.datiPratica.datiSpedizione.flIndirizzoSpedizione === undefined)
          ) {
            self.propostaTelepassSrvc.datiPratica.datiSpedizione.flIndirizzoSpedizione = true;
            self.selezionaTipoIndirizzo();
          }
        })
        .finally(function () {
          self.spinner.showSpinner = false;
        });
    };

    /**
     * @ngdoc method
     * @name recuperaCAP
     * @methodOf cbl.telepass.wa:propostaTelepassSrvc
     * @description Recupera i CAP per la spedizione.
     */
    this.recuperaCAP = function () {
      self.spinner.showSpinner = true;
      self.capFiltrati = [];
      var comune = self.propostaTelepassSrvc.datiPratica.datiSpedizione.citta;

      if (!comune) {
        self.spinner.showSpinner = false;
        return;
      }

      self.domainSrvc
        .promiseDomain('CAP', null, comune)
        .then(function (domain) {
          self.capFiltrati = domain;
        })
        .finally(function () {
          self.spinner.showSpinner = false;
        });
    };

    /**
     * @ngdoc method
     * @name recuperaLocalita
     * @methodOf cbl.telepass.wa:propostaTelepassSrvc
     * @description Recupera le Localita per la spedizione.
     */
    this.recuperaLocalita = function () {
      self.spinner.showSpinner = true;
      var cap = self.propostaTelepassSrvc.datiPratica.datiSpedizione.cap;
      var comune = self.propostaTelepassSrvc.datiPratica.datiSpedizione.citta;

      self.domainSrvc
        .promiseDomain('LOCALITA', cap, comune)
        .then(function (domain) {
          self.localita = domain;
          if (!self.localita.length) {
            self.localita.push({ codice: comune, descrizione: comune });
          }
        })
        .finally(function () {
          self.spinner.showSpinner = false;
        });
    };

    /**
     * @ngdoc method
     * @name recuperaDomini
     * @methodOf cbl.telepass.wa:propostaTelepassSrvc
     * @description Recupera i domini per la spedizione.
     */
    this.recuperaDomini = function () {
      self.comuni = [];
      self.capFiltrati = [];
      self.localita = [];

      var provincia =
        self.propostaTelepassSrvc.datiPratica.datiSpedizione.provincia ||
        self.findCodiceProvincia(self.propostaTelepassSrvc.datiCliente.recapito.provincia);

      var comune = self.propostaTelepassSrvc.datiPratica.datiSpedizione.citta;
      var cap = self.propostaTelepassSrvc.datiPratica.datiSpedizione.cap;

      // Array di chiamate creato dinamicamente se ci sono i correspondenti dati
      var chiamateDominio = [self.domainSrvc.promiseDomain('NAZIONE'), self.domainSrvc.promiseDomain('PROVINCIA')];

      if (provincia) {
        chiamateDominio.push(self.domainSrvc.promiseDomain('COMUNE', provincia));
      }

      if (comune) {
        chiamateDominio.push(self.domainSrvc.promiseDomain('CAP', null, comune));
      }

      if (cap && comune) {
        chiamateDominio.push(self.domainSrvc.promiseDomain('LOCALITA', cap, comune));
      }

      //chiamata ai domain services in contemporanea
      self.spinner.showSpinner = true;
      $q.all(chiamateDominio)
        .then(function (responses) {
          self.paesi = responses[0];

          // Rimuovo la provincia 'STATO ESTERO'
          self.province = responses[1].filter(function (item) {
            return item.codice !== '**';
          });

          self.comuni = responses[2];
          if (
            self.propostaTelepassSrvc.datiPratica.settore === 'VIACARD' &&
            (self.propostaTelepassSrvc.datiPratica.datiSpedizione.flIndirizzoSpedizione === null ||
              self.propostaTelepassSrvc.datiPratica.datiSpedizione.flIndirizzoSpedizione === undefined)
          ) {
            self.propostaTelepassSrvc.datiPratica.datiSpedizione.flIndirizzoSpedizione = true;
            self.selezionaTipoIndirizzo();
          }

          self.capFiltrati = responses[3];

          self.localita = responses[4];
          if (self.localita) {
            if (!self.localita.length) {
              self.localita.push({
                codice: comune.codice,
                descrizione: comune.descrizione
              });
            }
          }
        })
        .finally(function () {
          self.spinner.showSpinner = false;
        });
    };

    this.recuperaModalitaRitiro = function () {
      self.definizioneSrvc
        .promiseRecuperaModalitaRitiro(
          self.propostaTelepassSrvc.datiProdotto.codiceProdottoCPT,
          self.propostaTelepassSrvc.datiPratica.settore
        )
        .then(function (response) {
          if (self.messaggiFctr.processaResponse(response)) {
            self.spinner.showSpinner = false;
            return;
          }

          self.modalitaRitiroList = response.data.result.map(function (item) {
            return item.codice;
          });
        });
    };

    this.isClienteEstero = function () {
      return self.propostaTelepassSrvc.datiCliente.recapito.provincia.codice === '**';
    };

    /*
     * -------------------------------------
     * METODI INIZIALIZZAZIONE
     * -------------------------------------
     */

    this.init = function () {
      self.ndg = self.$stateParams.ndg;
      self.idProdotto = self.$stateParams.idProdotto;
      self.idPratica = self.$stateParams.idPratica;

      if (!self.propostaTelepassSrvc.datiPratica.datiSpedizione) {
        self.propostaTelepassSrvc.datiPratica.datiSpedizione = {};
      }

      if (self.propostaTelepassSrvc.datiCliente.documentoIdentita) {
        self.dataRilascioDocumento = self.propostaTelepassSrvc.formattazioneData(
          self.propostaTelepassSrvc.datiCliente.documentoIdentita.dataRilascio
        );

        self.dataScadenzaDocumento = self.propostaTelepassSrvc.formattazioneData(
          self.propostaTelepassSrvc.datiCliente.documentoIdentita.dataScadenza
        );
      }

      console.log(self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti);
      if (
        self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti &&
        self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti.length
      ) {
        for (var index in self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti) {
          self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti[
            index
          ].documentoIdentita.dataRilascioDocumento = self.propostaTelepassSrvc.formattazioneData(
            self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti[index].documentoIdentita
              .dataRilascioDocumento
          );

          self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti[
            index
          ].documentoIdentita.dataScadenzaDocumento = self.propostaTelepassSrvc.formattazioneData(
            self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti[index].documentoIdentita
              .dataScadenzaDocumento
          );

          if (
            self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti[index].recapito.provincia.codice === '**'
          ) {
            self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti[index].recapito.comune = {
              codice: '**',
              descrizione: 'STATO ESTERO'
            };
          }
        }

        if (!self.propostaTelepassSrvc.datiPratica.ndgReferente) {
          self.propostaTelepassSrvc.datiPratica.ndgReferente =
            self.propostaTelepassSrvc.datiCliente.datiLegaliRappresentanti[0].ndg;
        }
      }
      self.recuperaModalitaRitiro();

      self.recuperaDomini();

      // Fix 21-04-2021
      if (self.isClienteEstero()) {
        self.propostaTelepassSrvc.datiCliente.recapito.comune.codice = '**';
        self.propostaTelepassSrvc.datiCliente.recapito.comune.descrizione = 'STATO ESTERO';
        // Reset dati spedizione
        self.propostaTelepassSrvc.datiPratica.datiSpedizione = {
          cap: '',
          citta: '',
          civico: null,
          cognome: self.propostaTelepassSrvc.datiPratica.datiSpedizione.cognome,
          flIndirizzoSpedizione: false,
          localita: '',
          nazione: '',
          nome: self.propostaTelepassSrvc.datiPratica.datiSpedizione.nome,
          provincia: '',
          via: ''
        };
      }
    };

    /*
     * -------------------------------------
     *        INIZIALIZZAZIONE
     * -------------------------------------
     */
    self.init();
  };

  tlpsDatiAggiuntiviCtrl.$inject = [
    '$scope',
    '$stateParams',
    'TLPS_CONSTANTS',
    'TlpsLabelSrvc',
    'TlpsMessaggiFctr',
    'TlpsPropostaSrvc',
    'TlpsUserSrvc',
    '$state',
    'TlpsDomainSrvc',
    '$q',
    'TlpsDefinizioneSrvc'
  ];

  var TemplateUrl = function (CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'tlpsProposta/tlpsDefinizione/tlpsDatiAggiuntivi/tlpsDatiAggiuntivi.html'
    );
  };

  TemplateUrl.$inject = ['TLPS_CONSTANTS'];

  var tlpsDatiAggiuntiviComponent = {
    bindings: {},
    controller: tlpsDatiAggiuntiviCtrl,
    controllerAs: 'datiAggiuntiviCtrl',
    templateUrl: TemplateUrl
  };

  angular.module('cbl.telepass.wa').component('tlpsDatiAggiuntivi', tlpsDatiAggiuntiviComponent);
})();


/***/ }),
/* 28 */
/***/ (function(module, exports) {

/**
 * @ngdoc directive
 * @name cbl.telepass.wa.directive:tlpsDefinizioneProdotto
 * @restrict E
 * @description Componente che gestisce il primo step "Stato Affidamento" del
 *              dettaglio pratica
 */
(function() {
  'use strict';
  var tlpsDefinizioneCtrl = function(
    $scope,
    $stateParams,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    propostaTelepassSrvc,
    userSrvc
    // propostaDefinizioneSrvc
  ) {
    this.$stateParams = $stateParams;
    this.messaggiFctr = messaggiFctr;
    this.CONSTANTS = CONSTANTS;
    this.userSrvc = userSrvc;
    $scope.msg = labelSrvc.getLabel;

    this.propostaTelepassSrvc = propostaTelepassSrvc;
    // this.propostaDefinizioneSrvc = propostaDefinizioneSrvc;

    // Spinner
    this.spinner = this.propostaTelepassSrvc.spinner;

    this.idPratica;
    this.idProdotto;

    var self = this;

    /*
     * -------------------------------------
     *          GESTIONE INTERFACCIA
     * -------------------------------------
     */

    /**
     * @ngdoc method
     * @name getStyleTabMicro
     * @methodOf cbl.cartacredito.mf.directive:ccQuestionari
     * @description Imposta lo stile di visualizzazione per gli indicatori dei micro step
     * @param {string} currentStep - Il macro step correntemente visualizzato
     * @param {number} currentTabIndex - L'indice della tab cui applicare lo stile
     * @return {string} - Restituisce lo stile da applicare all'indicatore del micro step
     */
    this.getStyleTabMicro = function(currentTabIndex) {
      if (self.propostaTelepassSrvc.isPraticaNavigabile()) {
        if (self.currentStep && currentTabIndex === self.currentStep.index) {
          return 'ab-step-tabs cliccabile active-read';
        }

        return 'ab-step-tabs cliccabile ab-last-read';
      }

      // Pratica non navigabile
      if (self.currentStep && currentTabIndex < self.currentStep.index) {
        return 'ab-step-tabs';
      }

      if (self.currentStep && currentTabIndex === self.currentStep.index) {
        return 'ab-step-tabs active';
      }

      return 'ab-step-tabs ab-last';
    };

    /**
     * @ngdoc method
     * @name getStyleStepMicro
     * @methodOf cbl.cartacredito.mf.directive:ccQuestionari
     * @description Imposta lo stile di visualizzazione per la barra dell'indicatore del micro step
     * @param {string} currentStep - Il macro step correntemente visualizzato
     * @param {number} currentTabIndex - L'indice della tab cui applicare lo stile
     * @return {string} - Restituisce lo stile da applicare alla barra dell'indicatore del micro step
     */
    this.getStyleStepMicro = function(currentTabIndex) {
      if (self.propostaTelepassSrvc.isPraticaNavigabile()) {
        return 'step read';
      }

      if (self.currentStep && currentTabIndex < self.currentStep.index) {
        return 'step success';
      }

      return 'step';
    };

    /**
     * @ngdoc method
     * @name microTabClicked
     * @methodOf cbl.cartacredito.mf.directive:ccQuestionari
     * @description Apre il micro-tab selezionato solo se tutte le domande sono state compilate
     * @param {Object} tab - il micro-tab selezionato
     */
    this.microTabClicked = function(tab) {
      if (self.propostaTelepassSrvc.isPraticaNavigabile()) {
        self.currentStep = tab;
      }
    };

    /*
     * -------------------------------------
     * METODI INIZIALIZZAZIONE
     * -------------------------------------
     */

    this.init = function() {
      self.ndg = self.$stateParams.ndg;
      self.idProdotto = self.$stateParams.idProdotto;
      self.idPratica = self.$stateParams.idPratica;
    };

    /*
     * -------------------------------------
     *        INIZIALIZZAZIONE
     * -------------------------------------
     */
    self.init();
  };

  tlpsDefinizioneCtrl.$inject = [
    '$scope',
    '$stateParams',
    'TLPS_CONSTANTS',
    'TlpsLabelSrvc',
    'TlpsMessaggiFctr',
    'TlpsPropostaSrvc',
    'TlpsUserSrvc'
    // 'TlpsDefinizioneSrvc'
  ];

  var TemplateUrl = function(CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'tlpsProposta/tlpsDefinizione/tlpsDefinizione.html'
    );
  };

  TemplateUrl.$inject = ['TLPS_CONSTANTS'];

  var tlpsDefinizioneComponent = {
    bindings: {
      steps: '<',
      currentStep: '<'
    },
    controller: tlpsDefinizioneCtrl,
    controllerAs: 'definizioneProdCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.telepass.wa')
    .component('tlpsDefinizione', tlpsDefinizioneComponent);
})();


/***/ }),
/* 29 */
/***/ (function(module, exports) {

/**
 * @ngdoc service
 * @name cbl.telepass.wa.directive:tlpsProposta
 * @restrict E
 * @scope
 * @description Servizio che gestisce il processo di creazione nuova pratica e
 *              visualizzazione pratica esistente
 */
(function() {
  angular.module('cbl.telepass.wa').service('TlpsDefinizioneSrvc', [
    '$http',
    'TlpsMessaggiFctr',
    'TLPS_CONSTANTS',
    'TlpsLabelSrvc',
    function($http, messaggiFctr, CONSTANTS, labelSrvc) {
      this.$http = $http;
      this.messaggiFctr = messaggiFctr;
      this.labelSrvc = labelSrvc;

      var self = this;

      /*
       * -------------------------------------
       *           PROMISE SERVIZI REST
       * -------------------------------------
       */

      /**
       * @ngdoc method
       * @name promiseRecuperaContiCorrenti
       * @methodOf cbl.telepass.wa.directive:TlpsPropostaSrvc
       * @description Effettua una chiamata http per recuperare i conti correnti dell'ndg
       * @return {Promise} - Ritorna una promise contenente la lista dei conti correnti
       */
      this.promiseRecuperaContiCorrenti = function(ndg) {
        return this.$http({
          method: 'GET',
          url:
            CONSTANTS.REST_ROOT +
            CONSTANTS.REST.CONTOCORRENTE.RICERCA_CONTICORRENTE,
          params: ndg
        });
      };

      this.promiseRecuperaModalitaRitiro = function(codProdotto, settore) {
        var qryParams = {
          settore: settore,
          canale: 'BRIO_FILIALE',
          prodotto: codProdotto
        };

        return this.$http({
          method: 'GET',
          url:
            CONSTANTS.REST_ROOT +
            CONSTANTS.REST.CONFIGURAZIONI.RECUPERA_MODALITA_RITIRO,
          data: {},
          params: qryParams
        });
      };
    }
  ]);
})();


/***/ }),
/* 30 */
/***/ (function(module, exports) {

/**
 * @ngdoc directive
 * @name cbl.telepass.wa.directive:tlpsDefinizioneProdotto
 * @restrict E
 * @description Componente che gestisce il primo step "Stato Affidamento" del
 *              dettaglio pratica
 */
(function() {
  'use strict';
  var TlpsDefinizioneProdottoCtrl = function(
    $scope,
    $stateParams,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    propostaTelepassSrvc,
    uiGridConstants,
    userSrvc
    // propostaDefinizioneSrvc
  ) {
    this.$stateParams = $stateParams;
    this.messaggiFctr = messaggiFctr;
    this.CONSTANTS = CONSTANTS;
    this.uiGridConstants = uiGridConstants;
    this.gridApi = null;
    this.userSrvc = userSrvc;
    $scope.msg = labelSrvc.getLabel;

    this.propostaTelepassSrvc = propostaTelepassSrvc;

    // Spinner
    this.spinner = this.propostaTelepassSrvc.spinner;

    this.idPratica;
    this.idProdotto;
    // Conto selezionato dall'utente per proseguire la pratica
    this.contoSelezionato = undefined;

    // Opzioni della tabella dei conti
    this.gridOptions = {};
    this.tableHeight = 0;
    this.contiCorrenti;

    this.opzioniTelepassLista = [];

    this.datepicker = {
      isOpen: false,
      dateOptions: {
        formatDay: 'dd',
        formatMonth: 'MM',
        formatYear: 'yyyy',
        startingDay: 1
      }
    };

    var self = this;

    /*
     * -------------------------------------
     *          GESTIONE INTERFACCIA
     * -------------------------------------
     */

    /**
     * @ngdoc method
     * @name cambiaApparatoAggiuntivo
     * @methodOf cbl.telepass.wa:tlpsDefinizioneProdotto
     * @description Aggiorna la selezione del apparato aggiuntivo secondo la opzione telepass selezionata
     */
    // this.cambiaApparatoAggiuntivo = function() {
    //   if (
    //     !self.propostaTelepassSrvc.datiPratica.opzione ||
    //     self.propostaTelepassSrvc.datiPratica.opzione.codice !== 'PR'
    //   ) {
    //     self.propostaTelepassSrvc.datiPratica.twin = false;
    //   } else {
    //     self.propostaTelepassSrvc.datiPratica.twin = null;
    //   }
    // };

    /**
     * @ngdoc method
     * @name svuotaCodicePromozione
     * @methodOf cbl.telepass.wa:tlpsDefinizioneProdotto
     * @description Svuota il codice promozione se viene selezionato 'no'
     */
    this.svuotaCodicePromozione = function() {
      self.propostaTelepassSrvc.datiPratica.codicePromozione = null;
    };

    this.eliminaDatiApparatoAggiuntivo = function() {
      if (self.propostaTelepassSrvc.datiPratica.nazioneTargaTwin) {
        self.propostaTelepassSrvc.datiPratica.nazioneTargaTwin = null;
      }

      if (self.propostaTelepassSrvc.datiPratica.targaTwin) {
        self.propostaTelepassSrvc.datiPratica.targaTwin = null;
      }
    };

    /**
     * @ngdoc method
     * @name selezionaConto
     * @methodOf cbl.telepass.wa:tlpsDefinizioneProdotto
     * @description Seleziona o deseleziona il conto corrente su cui aprire la pratica
     */
    this.selezionaConto = function(conto) {
      if (
        self.propostaTelepassSrvc.datiPratica.numeroRapporto !==
        conto.entity.numeroRapporto
      ) {
        self.propostaTelepassSrvc.datiPratica.numeroRapporto =
          conto.entity.numeroRapporto;
      } else {
        self.propostaTelepassSrvc.datiPratica.numeroRapporto = null;
      }
    };

    /*
     * -------------------------------------
     *          GESTIONE BOTTONI
     * -------------------------------------
     */

    /**
     * @ngdoc method
     * @name datiValidi
     * @methodOf cbl.telepass.wa:tlpsDefinizioneProdotto
     * @description Verifica che i campi obbligatori siano valorizzati correttamente.
     */
    this.propostaTelepassSrvc.datiValidi = function() {
      var errori = false;

      //Controlla che un conto sia stato selezionato
      if (!self.propostaTelepassSrvc.datiPratica.numeroRapporto) {
        var message = {};
        message.type = 'E';
        message.message = 'Si deve selezionare un conto'; //chiedere messaggio corretto
        messaggiFctr.addMessage(message);
        errori = true;
      }

      //Controlla se la pratica è Viacard, abbia il numero di carte
      if (
        self.propostaTelepassSrvc.datiProdotto.settoreProdotto === '31' &&
        !self.propostaTelepassSrvc.datiPratica.numeroCarte
      ) {
        var message = {};
        message.type = 'E';
        message.message = 'Si deve indicare il numero di carte'; //chiedere messaggio corretto
        messaggiFctr.addMessage(message);
        errori = true;
      }

      //Controlla se la pratica è Telepass, sia stata selezionata la opzione
      // if (
      //   self.propostaTelepassSrvc.datiProdotto.settoreProdotto === '30' &&
      //   !self.propostaTelepassSrvc.datiPratica.opzione
      // ) {
      //   var message = {};
      //   message.type = 'E';
      //   message.message = 'Si deve selezionare la opzione Telepass'; //chiedere messaggio corretto
      //   messaggiFctr.addMessage(message);
      //   errori = true;
      // }

      //Controlla se la pratica è Telepass, e si abbia scelto la opzione 'posesso codice promozionale', questa sia valorizzata
      if (
        self.propostaTelepassSrvc.datiProdotto.settoreProdotto === '30' &&
        self.posessoCodicePromozionale === 'si' &&
        !self.propostaTelepassSrvc.datiPratica.codicePromozione
      ) {
        var message = {};
        message.type = 'E';
        message.message = 'Si deve valorizzare il codice promozione'; //chiedere messaggio corretto
        messaggiFctr.addMessage(message);
        errori = true;
      }

      //Controlla se la pratica è Telepass, sia valorizzata la opzione 'Apparato Aggiuntivo'
      if (
        self.propostaTelepassSrvc.datiProdotto.settoreProdotto === '30' &&
        self.propostaTelepassSrvc.datiPratica.twin === null &&
        (!self.propostaTelepassSrvc.datiPratica.opzione ||
          self.propostaTelepassSrvc.datiPratica.opzione.codice !== 'PR')
      ) {
        self.propostaTelepassSrvc.datiPratica.twin = false;
      } else if (
        self.propostaTelepassSrvc.datiProdotto.settoreProdotto === '30' &&
        self.propostaTelepassSrvc.datiPratica.twin === null &&
        self.propostaTelepassSrvc.datiPratica.opzione.codice === 'PR'
      ) {
        var message = {};
        message.type = 'E';
        message.message =
          'Si deve selezionare l`Apparato Aggiuntivo (Telepass Twin)';
        messaggiFctr.addMessage(message);
        errori = true;
      }

      //Controlla se la pratica è Telepass, se non viene valorizzato il campo data sottoscrizione contratto, viene aggiunto un messaggio.
      if (
        self.propostaTelepassSrvc.datiProdotto.settoreProdotto === '30' &&
        !self.propostaTelepassSrvc.datiPratica.dataSottoscrizioneContratto
      ) {
        var message = {};
        message.type = 'I';
        message.message =
          'La data di sottoscrizione del contratto coinciderà con la data di completamento della pratica';
        messaggiFctr.addMessage(message);
      }

      if (errori) {
        return false;
      }

      return true;
    };

    this.aggiornaOpzionePerTwin = function() {
      var opzione = document.getElementById('opzioneTelepass');
      if (self.propostaTelepassSrvc.datiPratica.twin === true) {
        self.propostaTelepassSrvc.datiPratica.opzione = {
          codice: 'PR',
          descrizione: 'PREMIUM',
          canale: 'BRIO_FILIALE',
          prodotto: 'TEL01'
        };
      }
    };

    /**
     * @ngdoc method
     * @name datiValidi
     * @methodOf cbl.telepass.wa:tlpsDefinizioneProdotto
     * @description Setta a null la opzione telepass se questa non viene valorizzata
     */
    this.controllaOpzioniTelepassVuoto = function() {
      if (self.propostaTelepassSrvc.datiPratica.opzione === '') {
        self.propostaTelepassSrvc.datiPratica.opzione = null;
      }
    };

    /*
     * -------------------------------------
     * METODI INIZIALIZZAZIONE
     * -------------------------------------
     */
    this.init = function() {
      self.ndg = self.$stateParams.ndg;
      self.idProdotto = self.$stateParams.idProdotto;
      self.idPratica = self.$stateParams.idPratica;
      // messaggiFctr.resetMessages();

      if (self.propostaTelepassSrvc.datiPratica.codicePromozione) {
        self.posessoCodicePromozionale = 'si';
      } else {
        self.posessoCodicePromozionale = 'no';
      }

      self.codicePromozione = '';
      self.apparatoAggiuntivo = 'no';

      self.spinner.showSpinner = true;

      self.propostaTelepassSrvc
        .promiseRecuperaContiCorrenti(self.ndg)
        .then(function(response) {
          self.contiCorrenti = response.data.result;
          self.tableHeight = response.data.result.length * 30 + 40;

          for (var i in self.contiCorrenti) {
            self.contiCorrenti[
              i
            ].dataApertura = self.propostaTelepassSrvc.formattazioneData(
              self.contiCorrenti[i].dataApertura
            );
          }
          // // Configurazione tabella
          self.gridOptions = {
            enableSorting: true,
            enableColumnMenus: false,
            enableGrouping: false,
            multiSelect: false,
            showHeader: true,
            enableRowHeaderSelection: false,
            enableRowSelection: !self.propostaTelepassSrvc.isPraticaNavigabile(),
            showGridFooter: false,
            enableVerticalScrollbar: self.uiGridConstants.scrollbars.NEVER,
            enableHorizontalScrollbar: self.uiGridConstants.scrollbars.NEVER,
            enableColumnResizing: true,
            columnDefs: [
              {
                displayName: 'Numero Rapporto',
                field: 'numeroRapporto',
                width: '10%',
                name: 'numeroRapporto'
              },
              {
                displayName: 'Iban',
                field: 'iban',
                width: '25%',
                name: 'iban'
              },
              {
                displayName: 'Descrizione',
                field: 'descrizione',
                width: '15%',
                name: 'descrizione'
              },
              {
                displayName: 'Saldo Contabile',
                cellFilter: 'number : 2',
                cellClass: 'right',
                field: 'saldoContabile',
                width: '10%',
                name: 'saldoContabile'
              },
              {
                displayName: 'Intestatario',
                cellClass: 'right',
                field: 'intestazione',
                width: '20%',
                name: 'intestazione'
              },
              {
                displayName: 'Stato',
                field: 'stato',
                width: '10%',
                name: 'stato'
              },
              {
                displayName: 'Data Apertura',
                field: 'dataApertura',
                cellFilter: 'date: "dd/MM/yyyy"',
                width: '10%',
                name: 'dataApertura'
              }
            ],
            data: self.contiCorrenti,
            onRegisterApi: function(gridApi) {
              self.gridApi = gridApi;
              self.gridApi.grid.modifyRows(self.gridOptions.data);

              // Se era già stato salvato il conto corrente lo recupero e lo seleziono
              if (
                self.propostaTelepassSrvc.datiPratica &&
                self.propostaTelepassSrvc.datiPratica.numeroRapporto
              ) {
                angular.forEach(self.contiCorrenti, function(conto, index) {
                  if (
                    conto.numeroRapporto ===
                    self.propostaTelepassSrvc.datiPratica.numeroRapporto
                  ) {
                    self.gridApi.selection.selectRow(self.contiCorrenti[index]);
                    self.contoSelezionato = self.contiCorrenti[index];
                  }
                });
              }

              gridApi.selection.on.rowSelectionChanged($scope, function(row) {
                self.selezionaConto(row);
              });
            }
          };

          self.propostaTelepassSrvc
            .promiseRecuperaOpzioniTelepass(
              self.propostaTelepassSrvc.datiProdotto.codiceProdottoCPT
            )
            .then(function(response) {
              self.opzioniTelepassLista = response.data.result;
              self.spinner.showSpinner = false;
            });
        });
    };

    /*
     * -------------------------------------
     *        INIZIALIZZAZIONE
     * -------------------------------------
     */
    self.init();
  };

  TlpsDefinizioneProdottoCtrl.$inject = [
    '$scope',
    '$stateParams',
    'TLPS_CONSTANTS',
    'TlpsLabelSrvc',
    'TlpsMessaggiFctr',
    'TlpsPropostaSrvc',
    'uiGridConstants',
    'TlpsUserSrvc'
  ];

  var TemplateUrl = function(CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'tlpsProposta/tlpsDefinizione/tlpsDettaglioProdotto/tlpsDettaglioProdotto.html'
    );
  };

  TemplateUrl.$inject = ['TLPS_CONSTANTS'];

  var tlpsDefinizioneProdottoComponent = {
    bindings: {},
    controller: TlpsDefinizioneProdottoCtrl,
    controllerAs: 'definizioneCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.telepass.wa')
    .component('tlpsDefinizioneProdotto', tlpsDefinizioneProdottoComponent);
})();


/***/ }),
/* 31 */
/***/ (function(module, exports) {

/**
 * @ngdoc directive
 * @name cbl.telepass.mf.directive:tlpsDocumenti
 * @restrict E
 * @description Componente per la gestione della parte documentale della pratica
 */
(function() {
  'use strict';
  var TlpsDocumentiCtrl = function(
    $http,
    $scope,
    $stateParams,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    propostaTelepassSrvc,
    traslocoTelepassSrvc
  ) {
    this.$http = $http;
    this.$stateParams = $stateParams;
    this.messaggiFctr = messaggiFctr;
    this.propostaTelepassSrvc = propostaTelepassSrvc;
    this.traslocoTelepassSrvc = traslocoTelepassSrvc;
    this.CONSTANTS = CONSTANTS;
    $scope.msg = labelSrvc.getLabel;

    this.ndg;
    this.idProdotto;
    this.idPratica;

    // Questo componente viene usato sia nella parte di proposta che in quella di trasloco nel post vendita,
    // per poter utilizzare lo stesso componente con metodi e con dati differenti si va a contorllare in quale dei
    // due service sono presenti i dati.
    this.mainSrvc;

    this.fieldConfiguration = null;

    // Gestione Widget
    this.showSecondLevelKeyFl = false;
    this.onlyCurrent = false;
    this.readonlyVariazione = true;
    this.hideMenu = false;

    var self = this;

    /*
     * -------------------------------------
     *           PROMISE SERVIZI REST
     * -------------------------------------
     */

    this.datiValidi = function() {
      return true;
    };

    this.selectCurrentService = function() {
      if (!!self.propostaTelepassSrvc.datiPratica) {
        return self.propostaTelepassSrvc;
      }

      if (!!self.traslocoTelepassSrvc.datiPratica) {
        return self.traslocoTelepassSrvc;
      }

      return null;
    };

    /*
     * -------------------------------------
     *           METODI INIZIALIZZAZIONE
     * -------------------------------------
     */

    this.init = function() {
      self.ndg = self.$stateParams.ndg;
      self.idProdotto = self.$stateParams.idProdotto;
      self.idPratica = self.$stateParams.idPratica;

      self.mainSrvc = self.selectCurrentService();

      self.mainSrvc.datiValidi = self.datiValidi;

      self.mainSrvc.spinner.showSpinner = false;

      self.intestatario = angular.copy(self.mainSrvc.datiCliente);
    };

    /**
     * Resta in ascolto del cambiamento sulla listaStatiDocumenti che contiene i documenti firmati
     */
    $scope.$watch(
        'listaStatiDocumenti',
        function(newValue, oldValue, $scope) {
          if (angular.isArray(newValue)) {
            if (newValue.length === 0) {
              self.propostaTelepassSrvc.documentiFirmati = true;
              self.traslocoTelepassSrvc.documentiFirmati = true;
            } else {
              self.propostaTelepassSrvc.documentiFirmati = !newValue.find(function(value) {
                return !value.stateValid;
              });
              self.traslocoTelepassSrvc.documentiFirmati = !newValue.find(function(value) {
                return !value.stateValid;
              });
            }
          }
        },
        true
    );

    self.init();
  };

  TlpsDocumentiCtrl.$inject = [
    '$http',
    '$scope',
    '$stateParams',
    'TLPS_CONSTANTS',
    'TlpsLabelSrvc',
    'TlpsMessaggiFctr',
    'TlpsPropostaSrvc',
    'TlpsTraslocoTelepassSrvc'
  ];

  var TemplateUrl = function(CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'tlpsProposta/tlpsDocumenti/tlpsDocumenti.html'
    );
  };

  TemplateUrl.$inject = ['TLPS_CONSTANTS'];

  var TlpsDocumentiComponent = {
    bindings: {
      steps: '<',
      currentStep: '<'
    },
    controller: TlpsDocumentiCtrl,
    controllerAs: 'documentiCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.telepass.wa')
    .component('tlpsDocumenti', TlpsDocumentiComponent);
})();


/***/ }),
/* 32 */
/***/ (function(module, exports) {

(function () {
  'use strict';
  var TlpsModalController = function (
    $scope,
    $state,
    $uibModalInstance,
    labelSrvc,
    propostaTelepassSrvc,
    traslocoTelepassSrvc,
    postVenditaTelepassSrvc,
    messaggiFctr,
    CONSTANTS
  ) {
    $scope.msg = labelSrvc.getLabel;

    this.$scope = $scope;
    this.$state = $state;
    this.$uibModalInstance = $uibModalInstance;
    this.propostaTelepassSrvc = propostaTelepassSrvc;
    this.traslocoTelepassSrvc = traslocoTelepassSrvc;
    this.postVenditaTelepassSrvc = postVenditaTelepassSrvc;

    this.CONSTANTS = CONSTANTS;

    this.mainSrvc;

    this.messaggiFctr = messaggiFctr;
    var self = this;

    this.chiudiModale = function () {
      self.$uibModalInstance.dismiss();
    };

    this.annullaIsDisabled = function () {
      if (self.mainSrvc.datiPratica && (self.mainSrvc.datiPratica.nota == '' || !self.mainSrvc.datiPratica.nota)) {
        return true;
      }
      return false;
    };

    this.annulla = function () {
      self.mainSrvc.spinner.showSpinner = true;

      if (self.mainSrvc.datiPratica.settore === 'TELEPASS') {
        self.mainSrvc.datiPratica.class = 'PraticaTelepassDto';
      } else if (self.mainSrvc.datiPratica.settore === 'VIACARD') {
        self.mainSrvc.datiPratica.class = 'PraticaViacardDto';
      }

      self.mainSrvc.pulisciDati(self.mainSrvc.datiPratica);

      // Richiamo il servizio per annullare la pratica
      self.mainSrvc
        .promiseAnnullaPratica(self.mainSrvc.datiPratica)
        .then(function (response) {
          if (self.messaggiFctr.processaResponse(response)) {
            return;
          }

          self.mainSrvc.goToSchedaCliente();
        })
        .finally(function () {
          self.mainSrvc.spinner.showSpinner = false;

          self.$uibModalInstance.dismiss();
        });
    };

    this.rifiuta = function () {
      self.mainSrvc.spinner.showSpinner = true;

      if (self.mainSrvc.datiPratica.settore === 'TELEPASS') {
        self.mainSrvc.datiPratica.class = 'PraticaTelepassDto';
      } else if (self.mainSrvc.datiPratica.settore === 'VIACARD') {
        self.mainSrvc.datiPratica.class = 'PraticaViacardDto';
      }

      self.mainSrvc.pulisciDati(self.mainSrvc.datiPratica);

      // Richiamo il servizio per annullare la pratica
      self.mainSrvc
        .promiseRifiutaPratica(self.mainSrvc.datiPratica)
        .then(function (response) {
          if (self.messaggiFctr.processaResponse(response)) {
            return;
          }

          var message = {};
          message.type = 'I';
          message.message = 'Richiesta effettuata con successo';
          self.messaggiFctr.addMessage(message);

          self.mainSrvc.goToSchedaCliente();
        })
        .finally(function () {
          self.mainSrvc.spinner.showSpinner = false;
          self.$uibModalInstance.dismiss();
        });
    };

    this.revisiona = function () {
      self.mainSrvc.spinner.showSpinner = true;

      if (self.mainSrvc.datiPratica.settore === 'TELEPASS') {
        self.mainSrvc.datiPratica.class = 'PraticaTelepassDto';
      } else if (self.mainSrvc.datiPratica.settore === 'VIACARD') {
        self.mainSrvc.datiPratica.class = 'PraticaViacardDto';
      }

      // Richiamo il servizio per annullare la pratica
      self.mainSrvc
        .promiseRevisionaPratica(self.mainSrvc.datiPratica)
        .then(function (response) {
          if (self.messaggiFctr.processaResponse(response)) {
            return;
          }
          self.mainSrvc.goToSchedaCliente();
        })
        .finally(function () {
          self.mainSrvc.spinner.showSpinner = false;

          self.$uibModalInstance.dismiss();
        });
    };

    this.risottometti = function () {
      self.mainSrvc.spinner.showSpinner = true;

      if (self.mainSrvc.datiPratica.settore === 'TELEPASS') {
        self.mainSrvc.datiPratica.class = 'PraticaTelepassDto';
      } else if (self.mainSrvc.datiPratica.settore === 'VIACARD') {
        self.mainSrvc.datiPratica.class = 'PraticaViacardDto';
      }

      if (
        self.mainSrvc.datiPratica.specializzazione === self.CONSTANTS.SPECIALIZZAZIONE_PRATICA.TRASLOCO_TELEPASS ||
        self.mainSrvc.datiPratica.specializzazione === self.CONSTANTS.SPECIALIZZAZIONE_PRATICA.ALLESTIMENTO_VIACARD ||
        self.mainSrvc.datiPratica.specializzazione === self.CONSTANTS.SPECIALIZZAZIONE_PRATICA.ALLESTIMENTO_TELEPASS
      ) {
        self.mainSrvc.pulisciDati(self.mainSrvc.datiPratica);
        var dataSottoscrizioneContratto = new Date(self.mainSrvc.datiPratica.dataSottoscrizioneContratto);
        var year = dataSottoscrizioneContratto.getFullYear();
        var month = dataSottoscrizioneContratto.getMonth() + 1;
        var day = dataSottoscrizioneContratto.getDate();
        self.mainSrvc.datiPratica.dataSottoscrizioneContratto = day + '/' + month + '/' + year;
      }

      // Richiamo il servizio per annullare la pratica
      self.mainSrvc
        .promiseRisottomettiPratica(self.mainSrvc.datiPratica)
        .then(function (response) {
          if (self.messaggiFctr.processaResponse(response)) {
            return;
          }

          var message = {};
          message.type = 'I';
          message.message = 'Richiesta effettuata con successo';
          self.messaggiFctr.addMessage(message);

          self.mainSrvc.goToSchedaCliente();
        })
        .finally(function () {
          self.mainSrvc.spinner.showSpinner = false;
          self.$uibModalInstance.dismiss();
        });
    };

    this.revocaContratto = function () {
      self.messaggiFctr.resetMessages();
      self.mainSrvc.spinner.showSpinner = true;

      self.mainSrvc
        .promiseRevocaTelepass(self.mainSrvc.ndgContrattoDaRevocare, self.mainSrvc.contrattoDaRevocare)
        .then(function (response) {
          if (self.messaggiFctr.processaResponse(response)) {
            self.mainSrvc.spinner.showSpinner = false;
            return;
          }
          messaggiFctr.addMessage({
            type: 'I',
            message: 'Richiesta effettuata correttamente'
          });
          self.mainSrvc.recuperaContratti();
          self.$uibModalInstance.dismiss();
        })
        .finally(function () {
          self.mainSrvc.spinner.showSpinner = false;
        });
    };

    this.selectCurrentService = function () {
      if (!!self.propostaTelepassSrvc.datiPratica) {
        return self.propostaTelepassSrvc;
      }

      if (!!self.traslocoTelepassSrvc.datiPratica) {
        return self.traslocoTelepassSrvc;
      }

      if (!!self.postVenditaTelepassSrvc.datiPratica) {
        return self.postVenditaTelepassSrvc;
      }

      if (!!self.postVenditaTelepassSrvc.contrattoDaRevocare) {
        return self.postVenditaTelepassSrvc;
      }
      return null;
    };

    this.init = function () {
      self.mainSrvc = self.selectCurrentService();

      if (self.mainSrvc.datiPratica && self.mainSrvc.datiPratica.nota) {
        self.mainSrvc.datiPratica.nota = '';
      }
    };

    this.init();
  };
  TlpsModalController.$inject = [
    '$scope',
    '$state',
    '$uibModalInstance',
    'TlpsLabelSrvc',
    'TlpsPropostaSrvc',
    'TlpsTraslocoTelepassSrvc',
    'TlpsPostVenditaSrvc',
    'TlpsMessaggiFctr',
    'TLPS_CONSTANTS'
  ];
  angular.module('cbl.telepass.wa').controller('TlpsModalController', TlpsModalController);
})();


/***/ }),
/* 33 */
/***/ (function(module, exports) {

/**
 * @ngdoc directive
 * @name cbl.telepass.wa.directive:tlpsProposta
 * @restrict E
 * @description Componente per la visualizzazione di una pratica di telepass
 */
(function () {
  'use strict';
  var tlpsPropostaCtrl = function (
    $scope,
    $state,
    $stateParams,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    propostaTelepassSrvc,
    $uibModal,
    traslocoTelepassSrvc
  ) {
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.messaggiFctr = messaggiFctr;
    this.propostaTelepassSrvc = propostaTelepassSrvc;
    this.traslocoTelepassSrvc = traslocoTelepassSrvc;
    this.CONSTANTS = CONSTANTS;
    this.$uibModal = $uibModal;
    $scope.msg = labelSrvc.getLabel;

    // Variabili della pagina
    this.ndg;
    this.idProdotto;
    this.idPratica;
    this.labelSenzaErrori = false;

    // Dati Cliente
    this.datiCliente;
    // Dati Prodotto
    this.datiProdotto;
    // Dati Pratica
    this.datiPratica = this.propostaTelepassSrvc.datiPratica = {};

    var req = {};

    // Spinner
    this.spinner = this.propostaTelepassSrvc.spinner;

    // Configurazione Tab principali
    this.TAB_LIST_MACRO = [];

    // Configurazioni sotto-step
    this.TAB_LIST_MICRO = {};

    // Tab attualmente attive
    this.currentTabMacro = {};
    this.currentTabMicro = {};

    var self = this;

    /*
     * -------------------------------------
     *         GESTIONE NAVIGAZIONE
     * -------------------------------------
     */

    /**
     * @ngdoc method
     * @name generaTabs
     * @methodOf cbl.telepass.wa.directive:tlpsProposta
     * @description Genera le tab necessarie al processo sulla base del cliente
     *              e della pratica ricevuti
     */

    this.propostaTelepassSrvc.generaTabs = function () {
      // Svuoto le tab
      self.TAB_LIST_MACRO = [];
      self.TAB_LIST_MICRO = {};

      self.tabs = [
        {
          step: 'DEFINIZIONE',
          label: 'label.tab.definizione',
          posizione: '1',
          statoPratica: 'INCORSO',
          stepPratica: null,
          sottoStep: [
            {
              step: 'DETTAGLIO_PRODOTTO',
              label: 'label.tab.dettaglio.prodotto',
              posizione: '1.1',
              statoPratica: 'INCORSO',
              stepPratica: 1,
              sottoStep: null,
            },
            {
              step: 'DATI_AGGIUNTIVI',
              label: 'label.tab.dati.aggiuntivi',
              posizione: '1.2',
              statoPratica: 'INCORSO',
              stepPratica: 2,
              sottoStep: null,
            },
          ],
        },
        // {
        //   step: 'GESTIONE_CONDIZIONI',
        //   label: 'label.tab.gestione.condizioni',
        //   posizione: '2',
        //   statoPratica: 'INCORSO',
        //   stepPratica: 3,
        //   sottoStep: null
        // },
        {
          step: 'QUESTIONARI',
          label: 'label.tab.questionari',
          posizione: '2',
          statoPratica: 'INCORSO',
          stepPratica: null,
          sottoStep: [
            {
              step: 'QUESTIONARIO_PRIVACY',
              label: 'label.tab.questionario.privacy',
              posizione: '2.1',
              statoPratica: 'INCORSO',
              stepPratica: 4,
              sottoStep: null,
            },
          ],
        },
        {
          step: 'DOCUMENTI',
          label: 'label.tab.documenti',
          posizione: '3',
          statoPratica: 'CONSOLIDATA',
          stepPratica: 1,
          sottoStep: null,
        },
      ];

      // Ciclo sulle macroTabs
      for (var i in self.tabs) {
        var macroStepIndex = Number(i);

        self.TAB_LIST_MACRO.push({
          index: macroStepIndex,
          title:
            self.tabs[macroStepIndex].posizione +
            ' ' +
            $scope.msg(self.tabs[macroStepIndex].label),
          url: self.getMacroStepUrl(self.tabs[macroStepIndex].step),
        });

        // Per ogni macro tab compongo l'oggetto microTab con i sottoStep
        self.TAB_LIST_MICRO[self.tabs[macroStepIndex].step] = [];

        for (var j in self.tabs[macroStepIndex].sottoStep) {
          var microStepIndex = Number(j);

          self.TAB_LIST_MICRO[self.tabs[macroStepIndex].step].push({
            index: microStepIndex,
            title:
              self.tabs[macroStepIndex].sottoStep[microStepIndex].posizione +
              ' ' +
              $scope.msg(
                self.tabs[macroStepIndex].sottoStep[microStepIndex].label
              ),
            url: self.getMicroStepUrl(
              self.tabs[macroStepIndex].sottoStep[microStepIndex].step
            ),
          });
        }
      }

      // Imposto i tab attivi
      var tabMacroIndex;
      var microStepIndex;

      // // Se la pratica è già stata creato imposto lo step corretto
      if (self.propostaTelepassSrvc.datiPratica) {
        tabMacroIndex = self.getMacroStepIndex(
          self.propostaTelepassSrvc.datiPratica.stato,
          self.propostaTelepassSrvc.datiPratica.step
        );
        microStepIndex = self.getMicroStepIndex(
          self.propostaTelepassSrvc.datiPratica.stato,
          self.propostaTelepassSrvc.datiPratica.step
        );
      } else {
        // Altrimenti assegno il primo step
        tabMacroIndex = 0;
        microStepIndex = 0;
      }

      self.currentTabMacro = self.TAB_LIST_MACRO[tabMacroIndex];

      self.currentTabMicro = {};

      for (var k in self.tabs) {
        self.currentTabMicro[self.tabs[Number(k)].step] =
          self.TAB_LIST_MICRO[self.tabs[Number(k)].step][microStepIndex];
      }
    };

    /**
     * @ngdoc method
     * @name getMacroStepUrl
     * @methodOf cbl.cartadebito.wa.directive:tlpsProposta
     * @description Ritorna il corretto id del template html a seconda del nome del macroStep
     */
    this.getMacroStepUrl = function (step) {
      switch (step) {
        case 'DEFINIZIONE':
          return 'definizione.tmpl.html';
        case 'GESTIONE_CONDIZIONI':
          return 'gestioneCondizioni.tmpl.html';
        case 'QUESTIONARI':
          return 'questionari.tmpl.html';
        case 'DOCUMENTI':
          return 'documenti.tmpl.html';
        default:
          return '';
      }
    };

    /**
     * @ngdoc method
     * @name getMicroStepUrl
     * @methodOf cbl.cartadebito.wa.directive:tlpsProposta
     * @description Ritorna il corretto id del template html a seconda del nome del microStep
     */
    this.getMicroStepUrl = function (step) {
      switch (step) {
        case 'DETTAGLIO_PRODOTTO':
          return 'dettaglioProdotto.tmpl.html';
        case 'DATI_AGGIUNTIVI':
          return 'datiAggiuntivi.tmpl.html';
        case 'GESTIONE_CONDIZIONI':
          return 'gestioneCondizioni.tmpl.html';
        case 'QUESTIONARIO_PRIVACY':
          return 'questionarioPrivacy.tmpl.html';
        case 'DOCUMENTI':
          return 'documenti.tmpl.html';
        default:
          return '';
      }
    };

    /**
     * @ngdoc method
     * @name getMacroStepIndex
     * @methodOf cbl.cartadebito.wa:tlpsProposta
     * @description Ritorna l'indice della macrotab a seconda dello stato e step
     * della pratica. 0 - Definizione , 1 - Questionari , 2 - Carta e Pin , 3 - Documenti
     */
    this.getMacroStepIndex = function (stato, step) {
      if (stato === CONSTANTS.STATO_PRATICA.IN_CORSO) {
        switch (step) {
          // Definizione
          case 1:
          case 2:
            return 0;
          // Questionari
          case 4:
            return 1;
          default:
            return 0;
        }
      } else if (stato === CONSTANTS.STATO_PRATICA.CONSOLIDATA) {
        // Documenti
        return 2;
      } else {
        return 0;
      }
    };

    /**
     * @ngdoc method
     * @name getMicroStepIndex
     * @methodOf cbl.cartadebito.wa:tlpsProposta
     * @description Ritorna l'indice della microtab a seconda dello stato e step
     * della pratica. I tab con index 0 sono i primi del macro index quindi i tab
     * 1 - Definizione Prodotto, 5 - Questionario Privacy , 6 - Associazione Pin , 8 - Gestione Firmatari
     * hanno come microIndex 0 ecc..
     */
    this.getMicroStepIndex = function (stato, step) {
      if (stato === CONSTANTS.STATO_PRATICA.IN_CORSO) {
        switch (step) {
          // Dettaglio Profotto
          case 1:
          // Condizioni
          case 3:
          // Questionari
          case 4:
            return 0;
          // Dati Aggiuntivi
          case 2:
            return 1;
          default:
            return 0;
        }
      } else if (stato === CONSTANTS.STATO_PRATICA.CONSOLIDATA) {
        // Documenti
        return 0;
      } else {
        return 0;
      }
    };

    /**
     * @ngdoc method
     * @name macroTabClicked
     * @methodOf cbl.cartadebito.wa.directive:tlpsProposta
     * @description Gestisce il click sulle macro tab
     * @param {Object} tab: l'oggetto tab selezionato
     */
    this.macroTabClicked = function (tab) {
      if (!self.propostaTelepassSrvc.isPraticaNavigabile()) {
        return;
      }

      self.currentTabMacro = tab;

      // Riporto ogni step al primo sottoStep
      for (var k in self.tabs) {
        self.currentTabMicro[self.tabs[Number(k)].step] =
          self.TAB_LIST_MICRO[self.tabs[Number(k)].step][0];
      }
    };

    /**
     * @ngdoc method
     * @name getStyleTabMacro
     * @methodOf cbl.telepass.wa.directive:tlpsProposta
     * @description Imposta lo stile di visualizzazione per gli indicatori dei macro step
     * @param {number} currentTabIndex - L'indice della tab cui applicare lo stile
     * @return {string} - Restituisce lo stile da applicare all'indicatore del macro step
     */
    this.getStyleTabMacro = function (currentTabIndex) {
      // Pratica non navigabile
      if (currentTabIndex < this.currentTabMacro.index) {
        return 'progress-pass';
      }

      if (currentTabIndex === this.currentTabMacro.index) {
        return 'progress-current';
      }

      return 'progress-next';
    };

    /**
     * @ngdoc method
     * @name getStyleTabMacroReadOnly
     * @methodOf cbl.telepass.wa.directive:tlpsProposta
     * @description Imposta lo stile di visualizzazione per gli indicatori dei macro step in modalità sola lettura
     * @param {number} currentTabIndex - L'indice della tab cui applicare lo stile
     * @return {string} - Restituisce lo stile da applicare all'indicatore del macro step
     */
    this.getStyleTabMacroReadOnly = function (currentTabIndex) {
      if (currentTabIndex < this.currentTabMacro.index) {
        return 'progress-next-read';
      }

      if (currentTabIndex === this.currentTabMacro.index) {
        return 'progress-current-read';
      }

      return 'progress-next-read';
    };

    /*
     * -------------------------------------
     *         GESTIONE PRATICA
     * -------------------------------------
     */

    this.recuperaPratica = function () {
      // Se esiste la pratica recupero il dettaglio, altrimenti la creo subito
      if (self.idPratica) {
        self.propostaTelepassSrvc
          .promiseDettaglioPratica(self.idPratica, self.ndg)
          .then(function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }

            self.datiPratica = self.propostaTelepassSrvc.datiPratica =
              response.data.result;

            self.$stateParams.idPratica = self.idPratica =
              response.data.result.idPratica;

            if (self.propostaTelepassSrvc.datiPratica.settore === 'VIACARD') {
              self.propostaTelepassSrvc.datiPratica.modalitaRitiro = {
                codice: 'S',
              };
            }
            self.propostaTelepassSrvc
              .promiseDettaglioProdotto(self.datiPratica.prodotto.idProdottoCPT)
              .then(function (resp) {
                self.datiProdotto = self.propostaTelepassSrvc.datiProdotto =
                  resp.data.result;

                self.propostaTelepassSrvc.generaTabs();
              });
          });
      } else if (self.idProdotto) {
        self.propostaTelepassSrvc
          .promiseDettaglioProdotto(self.idProdotto)
          .then(function (resp) {
            self.datiProdotto = self.propostaTelepassSrvc.datiProdotto =
              resp.data.result;

            // Prodotto Telepass
            if (self.datiProdotto.settoreProdotto === '30') {
              self.creaPratica();
              return;
            }

            // Se il prodotto è di tipo viacard controllo che non ci siano altre pratiche Viacard presenti per l'ndg
            self.propostaTelepassSrvc
              .promiseRecuperaContrattiCliente(self.ndg)
              .then(function (respon) {
                // Se ci sono contratti presenti mostro un messaggio di errore altrimenti procedo con la creazione
                // della pratica
                for (var i in respon.data.result) {
                  if (
                    respon.data.result[i] &&
                    respon.data.result[i].settore === 'VIACARD'
                  ) {
                    var message = {};
                    message.type = 'E';
                    message.message =
                      'È già presente un contratto di tipo VIACARD per l`ndg corrente';
                    self.messaggiFctr.addMessage(message);
                    self.spinner.showSpinner = false;
                    self.propostaTelepassSrvc.goToSchedaCliente();
                    return;
                  }
                }

                self.creaPratica();
              });
          });
      }
    };

    this.creaPratica = function () {
      var req = self.creaRequestCreaPratica();

      self.propostaTelepassSrvc.promiseCreaPratica(req).then(
        function (response) {
          self.datiPratica = self.propostaTelepassSrvc.datiPratica =
            response.data.result;

          self.$stateParams.idPratica = self.idPratica =
            response.data.result.idPratica;

          // Aggiorno i parametri nella URL per poterli mettere a disposizione anche degli altri componenti
          self.$state.go('.', { idPratica: self.idPratica });
        },
        function (reason) {
          self.messaggiFctr.processaResponse(reason);
          self.spinner.showSpinner = false;
        }
      );
    };

    this.creaRequestCreaPratica = function () {
      var req = {};
      // Settore prodotto telepass = 30
      if (self.datiProdotto.settoreProdotto === '30') {
        req = {
          class: 'PraticaTelepassDto',
          intestatario: {
            ndg: self.ndg,
          },
          prodotto: {
            idProdotto: self.idProdotto,
          },
          workflow: 'ACQUISTO_BRIO',
          settore: 'TELEPASS',
        };
        // Settore prodotto viacard = 31
      } else if (self.datiProdotto.settoreProdotto === '31') {
        req = {
          class: 'PraticaViacardDto',
          intestatario: {
            ndg: self.ndg,
          },
          prodotto: {
            idProdotto: self.idProdotto,
          },
          workflow: 'ACQUISTO_BRIO',
          settore: 'VIACARD',
        };
      }
      return req;
    };

    this.annullaPratica = function () {
      // Se siamo nella prima pagina non occorre aprire la modale per
      // inserire la nota.
      if (
        self.propostaTelepassSrvc.datiPratica.stato ===
          self.CONSTANTS.STATO_PRATICA.IN_CORSO &&
        self.propostaTelepassSrvc.datiPratica.step === 1
      ) {
        // Richiamo il servizio per annullare la pratica

        self.spinner.showSpinner = true;

        if (self.propostaTelepassSrvc.datiPratica.settore === 'TELEPASS') {
          self.propostaTelepassSrvc.datiPratica.class = 'PraticaTelepassDto';
        } else if (
          self.propostaTelepassSrvc.datiPratica.settore === 'VIACARD'
        ) {
          self.propostaTelepassSrvc.datiPratica.class = 'PraticaViacardDto';
        }

        self.propostaTelepassSrvc.pulisciDati(
          self.propostaTelepassSrvc.datiPratica
        );

        self.propostaTelepassSrvc
          .promiseAnnullaPratica(self.propostaTelepassSrvc.datiPratica)
          .then(function (response) {
            self.propostaTelepassSrvc.goToSchedaCliente();
          })
          .finally(function () {
            self.spinner.showSpinner = false;
          });
      } else {
        self.$uibModal
          .open({
            animation: true,
            templateUrl:
              CONSTANTS.BASE_ROOT +
              'components/tlpsProposta/tlpsModale/tlpsAnnulla.html',
            controller: 'TlpsModalController',
            controllerAs: 'modalCtrl',
            keyboard: false,
            backdrop: 'static',
            size: 'modal-lg',
          })
          .result.then(function (res) {});
      }
    };

    this.rifiutaPratica = function () {
      self.$uibModal
        .open({
          animation: true,
          templateUrl:
            CONSTANTS.BASE_ROOT +
            'components/tlpsProposta/tlpsModale/tlpsRifiuta.html',
          controller: 'TlpsModalController',
          controllerAs: 'modalCtrl',
          keyboard: false,
          backdrop: 'static',
          size: 'modal-lg',
        })
        .result.then(function (res) {});
    };

    this.revisionaPratica = function () {
      self.$uibModal
        .open({
          animation: true,
          templateUrl:
            CONSTANTS.BASE_ROOT +
            'components/tlpsProposta/tlpsModale/tlpsRevisiona.html',
          controller: 'TlpsModalController',
          controllerAs: 'modalCtrl',
          keyboard: false,
          backdrop: 'static',
          size: 'modal-lg',
        })
        .result.then(function (res) {});
    };

    this.risottomettiPratica = function () {
      self.$uibModal
        .open({
          animation: true,
          templateUrl:
            CONSTANTS.BASE_ROOT +
            'components/tlpsProposta/tlpsModale/tlpsRisottometti.html',
          controller: 'TlpsModalController',
          controllerAs: 'modalCtrl',
          keyboard: false,
          backdrop: 'static',
          size: 'modal-lg',
        })
        .result.then(function (res) {});
    };

    /*
     * -------------------------------------
     *         METODI INIZIALIZZAZIONE
     * -------------------------------------
     */

    this.init = function () {
      self.propostaTelepassSrvc.datiPratica = self.datiPratica = undefined;
      self.propostaTelepassSrvc.datiProdotto = self.datiProdotto = undefined;
      self.propostaTelepassSrvc.datiCliente = self.datiCliente = undefined;

      // Resetto i dati di eventuali pratiche allestite precedentemente.
      if (self.traslocoTelepassSrvc) {
        self.traslocoTelepassSrvc.datiPratica = undefined;
        self.traslocoTelepassSrvc.datiProdotto = undefined;
        self.traslocoTelepassSrvc.datiCliente = undefined;
      }

      // Forzatura per lo spegnimento dello spinner generale dell'applicazione per poter gestire
      // correttamente quello locale.
      var overlay = document.getElementById('overlay');
      if (!!overlay) {
        overlay.setAttribute('style', 'display:none;');
      }

      self.spinner.showSpinner = true;

      labelSrvc.labelsPronte.then(
        function () {
          self.labelSenzaErrori = true;
          //Verifica se ci sono codici promozione disponibili, se non ci sono setta a false la visualizzazione del input Codice Promozione
          self.propostaTelepassSrvc
            .promiseVerificaPromozioni()
            .then(function (response) {
              self.propostaTelepassSrvc.flCodicePromozione =
                response.data.result;
            });

          self.ndg = self.$stateParams.ndg;
          self.idProdotto = self.$stateParams.idProdotto;
          self.propostaTelepassSrvc.idPratica = self.idPratica =
            self.$stateParams.idPratica;

          self.propostaTelepassSrvc.promiseRecuperaAnagrafica(self.ndg).then(
            function (response) {
              if (self.messaggiFctr.processaResponse(response)) {
                self.spinner.showSpinner = false;
                return;
              }
              self.datiCliente = self.propostaTelepassSrvc.datiCliente =
                response.data.result;

              self.recuperaPratica();
            },
            function (error) {
              self.messaggiFctr.processaResponse(error);
              self.spinner.showSpinner = false;
              return;
            }
          );
        },
        function (error) {
          if (self.messaggiFctr.processaResponse(error)) {
            self.spinner.showSpinner = false;
            return;
          }
        }
      );
    };

    // INIZIALIZZAZIONE

    self.init();
  };

  tlpsPropostaCtrl.$inject = [
    '$scope',
    '$state',
    '$stateParams',
    'TLPS_CONSTANTS',
    'TlpsLabelSrvc',
    'TlpsMessaggiFctr',
    'TlpsPropostaSrvc',
    '$uibModal',
    'TlpsTraslocoTelepassSrvc',
  ];

  var TemplateUrl = function (CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'tlpsProposta/tlpsProposta.html'
    );
  };

  TemplateUrl.$inject = ['TLPS_CONSTANTS'];

  var tlpsPropostaComponent = {
    controller: tlpsPropostaCtrl,
    controllerAs: 'tlpsPropostaCtrl',
    templateUrl: TemplateUrl,
  };

  angular
    .module('cbl.telepass.wa')
    .component('tlpsProposta', tlpsPropostaComponent);
})();


/***/ }),
/* 34 */
/***/ (function(module, exports) {

/**
 * @ngdoc service
 * @name cbl.telepass.wa.directive:tlpsProposta
 * @restrict E
 * @scope
 * @description Servizio che gestisce il processo di creazione nuova pratica e
 *              visualizzazione pratica esistente
 */
(function () {
  angular.module('cbl.telepass.wa').service('TlpsPropostaSrvc', [
    '$http',
    'TlpsMessaggiFctr',
    'TLPS_CONSTANTS',
    'TlpsLabelSrvc',
    '$state',
    '$stateParams',
    function ($http, messaggiFctr, CONSTANTS, labelSrvc, $state, $stateParams, $scope) {
      this.$http = $http;
      this.messaggiFctr = messaggiFctr;
      this.labelSrvc = labelSrvc;
      this.$state = $state;
      this.$stateParams = $stateParams;

      // Variabili generali pratica
      this.datiCliente = null;
      this.idPratica = null;
      this.datiPratica = undefined;
      this.datiProdotto = null;

      this.isCancelEnabled = null;
      this.isSaveEnabled = null;
      this.isPrevEnabled = null;
      this.isNextEnabled = null;
      this.isCompleteEnabled = null;
      this.datiValidi = null;
      this.apparatoAggiuntivo = false;

      // Spinner
      this.spinner = { showSpinner: false };

      var self = this;

      /**
       * Flag che indica se tutti i documenti sono stati firmati
       */
      this.documentiFirmati = false;


      /*
       * -------------------------------------
       *           PROMISE SERVIZI REST
       * -------------------------------------
       */

      /**
       * @ngdoc method
       * @name promiseCreaPratica
       * @methodOf cbl.telepass.wa.directive:TlpsPropostaSrvc
       * @description Effettua una chiamata http per creare la pratica
       * @return {Promise} - Ritorna una promise contenente l'id della pratica appena creata
       */
      this.promiseCreaPratica = function (request) {
        return this.$http({
          method: 'POST',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.CREA_PRATICA,
          data: request
        });
      };

      /**
       * @ngdoc method
       * @name promiseAggiornaPratica
       * @methodOf cbl.telepass.wa:TlpsPropostaSrvc
       * @description Effettua una chiamata http per aggiornare la pratica che si sta allestendo
       * @return {Promise} - Ritorna una promise contenente il dettaglio della pratica
       */
      this.promiseAggiornaPraticaAvanti = function (idPratica, datiPratica) {
        return this.$http({
          method: 'PUT',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.DETTAGLIO_PRATICA + 'pratica/' + idPratica + '/avanti',
          data: datiPratica
        });
      };

      /**
       * @ngdoc method
       * @name promiseAggiornaPratica
       * @methodOf cbl.telepass.wa:TlpsPropostaSrvc
       * @description Effettua una chiamata http per aggiornare la pratica che si sta allestendo
       * @return {Promise} - Ritorna una promise contenente il dettaglio della pratica
       */
      this.promiseAggiornaPraticaIndietro = function (idPratica, datiPratica) {
        return this.$http({
          method: 'PUT',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.DETTAGLIO_PRATICA + 'pratica/' + idPratica + '/indietro',
          data: datiPratica
        });
      };

      /**
       * @ngdoc method
       * @name promiseAggiornaPratica
       * @methodOf cbl.telepass.wa:TlpsPropostaSrvc
       * @description Effettua una chiamata http per aggiornare la pratica che si sta allestendo
       * @return {Promise} - Ritorna una promise contenente il dettaglio della pratica
       */
      this.promiseAggiornaPraticaSalva = function (idPratica, datiPratica) {
        return this.$http({
          method: 'PUT',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.DETTAGLIO_PRATICA + 'pratica/' + idPratica,
          data: datiPratica
        });
      };

      /**
       * @ngdoc method
       * @name promiseAnnullaPratica
       * @methodOf cbl.telepass.wa:TlpsPropostaSrvc
       * @description Effettua una chiamata http per annullare e cancellare la pratica che si sta allestendo
       * @return {Promise} - Ritorna una promise contenente un booleano con la risposta alla cancellazione
       */
      this.promiseAnnullaPratica = function (pratica) {
        return this.$http({
          method: 'PUT',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.ANNULLA_PRATICA.replace('{idPratica}', pratica.idPratica),
          data: pratica
        });
      };

      /**
       * @ngdoc method
       * @name promiseRifiutaPratica
       * @methodOf cbl.telepass.wa:TlpsPropostaSrvc
       * @description Effettua una chiamata http per rifiutare la pratica che si sta allestendo
       * @return {Promise} - Ritorna una promise contenente un booleano con la risposta alla cancellazione
       */
      this.promiseRifiutaPratica = function (pratica) {
        return this.$http({
          method: 'PUT',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.RIFIUTA_PRATICA.replace('{idPratica}', pratica.idPratica),
          data: pratica
        });
      };

      /**
       * @ngdoc method
       * @name promiseRisottomettiPratica
       * @methodOf cbl.telepass.wa:TlpsPropostaSrvc
       * @description Effettua una chiamata http per rifiutare la pratica che si sta allestendo
       * @return {Promise} - Ritorna una promise contenente un booleano con la risposta alla cancellazione
       */
      this.promiseRisottomettiPratica = function (pratica) {
        return this.$http({
          method: 'PUT',
          url:
            CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.RISOTTOMETTI_PRATICA.replace('{idPratica}', pratica.idPratica),
          data: pratica
        });
      };

      /**
       * @ngdoc method
       * @name promiseCompletaProposta
       * @methodOf cbl.telepass.wa:TlpsPropostaSrvc
       * @description Effettua una chiamata http per completare la pratica che si sta allestendo
       * @return {Promise} - Ritorna una promise contenente un booleano con l'esito del completamento
       */
      this.promiseCompletaProposta = function (idPratica, ndg) {
        var qryParams = {
          idPratica: idPratica,
          ndg: ndg
        };

        return this.$http({
          method: 'PUT',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.COMPLETA_PRATICA,
          data: {},
          params: qryParams
        });
      };

      /**
       * @ngdoc method
       * @name promiseRecuperaAnagrafica
       * @methodOf cbl.telepass.wa.directive:TlpsPropostaSrvc
       * @description Effettua una chiamata http per recuperare i dettagli dell'anagrafica
       * @return {Promise} - Ritorna una promise contenente l'anagrafica
       */
      this.promiseRecuperaAnagrafica = function (ndg) {
        // this.spinner.pratica = true;
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.ANAGRAFICA.RECUPERA,
          params: { ndg: ndg }
        });
      };

      this.promiseRecuperaContrattiCliente = function (ndg) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.POST_VENDITA.RECUPERA_CONTRATTI_CLIENTE + ndg
        });
      };

      /**
       * @ngdoc method
       * @name promiseRecuperaOpzioniTelepass
       * @methodOf cbl.telepass.wa.directive:TlpsPropostaSrvc
       * @description Effettua una chiamata http per recuperare gli opzioni telepass
       * @return {Promise} - Ritorna una promise contenente le opzione di telepass
       */
      this.promiseRecuperaOpzioniTelepass = function (codProdotto) {
        var qryParams = {
          canale: 'BRIO_FILIALE',
          prodotto: codProdotto
        };
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.CONFIGURAZIONI.RECUPERA_OPZIONI_TELEPASS,
          data: {},
          params: qryParams
        });
      };

      /**
       * @ngdoc method
       * @name promiseVerificaPromozioni
       * @methodOf cbl.telepass.wa.directive:TlpsPropostaSrvc
       * @description Effettua una chiamata http per verificare se ci sono codicie promozione disponibili
       * @return {Promise} - Ritorna una promise se ci sono codici promozione
       */
      this.promiseVerificaPromozioni = function () {
        // this.spinner.pratica = true;
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.CONFIGURAZIONI.VERIFICA_PROMOZIONI
        });
      };

      /**
       * @ngdoc method
       * @name promiseDettaglioProdotto
       * @methodOf cbl.telepass.wa.directive:TlpsPropostaSrvc
       * @description Effettua una chiamata http per recuperare i dettagli del prodotto
       * @return {Promise} - Ritorna una promise contenente i dettagli del prodotto
       */
      this.promiseDettaglioProdotto = function (idProdotto) {
        // this.spinner.pratica = true;
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRODOTTO.DETTAGLIO_PRODOTTO + idProdotto
        });
      };

      /**
       * @ngdoc method
       * @name promiseDettaglioPratica
       * @methodOf cbl.telepass.wa.directive:TlpsPropostaSrvc
       * @description Effettua una chiamata http per recuperare i dettagli della pratica
       * @return {Promise} - Ritorna una promise contenente i dettagli della pratica
       */
      this.promiseDettaglioPratica = function (idPratica, ndg) {
        // this.spinner.pratica = true;
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.DETTAGLIO_PRATICA + 'pratica/' + idPratica
        });
      };

      /**
       * @ngdoc method
       * @name goToSchedaCliente
       * @methodOf cbl.telepass.wa.directive:tlpsProposta
       * @description Ridireziona verso la scheda del cliente
       */
      this.goToSchedaCliente = function () {
        self.datiProdotto = null;
        self.datiPratica = null;
        self.datiCliente = null;
        self.$state.go('schedaCliente', { ndg: self.$stateParams.ndg });
      };

      /*
       * -------------------------------------
       *        GESTIONE NAVIGAZIONE
       * -------------------------------------
       */

      /**
       * @ngdoc method
       * @name isPraticaNavigabile
       * @methodOf cbl.telepass.wa.directive:tlpsProposta
       * @description Verifica se la pratica non è in stato INCORSO o CONSOLIDATA, e quindi navigabile
       * @return {Boolean} - True se la pratica è navigabile, false in caso contrario
       */
      this.isPraticaNavigabile = function () {
        if (!self.datiPratica) {
          return false;
        }
        return (
          self.datiPratica &&
          self.datiPratica.stato &&
          self.datiPratica.stato !== CONSTANTS.STATO_PRATICA.IN_CORSO &&
          self.datiPratica.stato !== CONSTANTS.STATO_PRATICA.CONSOLIDATA &&
          self.datiPratica.stato !== CONSTANTS.STATO_PRATICA.DAREVISIONARE
        );
        // return true;
      };

      /**
       * @ngdoc method
       * @name isProseguiVisible
       * @methodOf cbl.telepass.wa.directive:TlpsPropostaSrvc
       * @description Verifica se il tasto prosegui è visibile
       * @return {Boolean} - True se il tasto è visibile, false in caso contrario
       */
      this.isProseguiVisible = function () {
        if (!self.datiPratica) {
          return true;
        }

        // Il tasto prosegui è visibile solo se siamo in stato INCORSO o CONSOLIDATA 3
        return (
          self.datiPratica.pratica &&
          self.datiPratica.pratica.stato &&
          (self.datiPratica.pratica.stato === CONSTANTS.STATO_PRATICA.IN_CORSO ||
            (self.datiPratica.pratica.stato === CONSTANTS.STATO_PRATICA.CONSOLIDATA &&
              self.datiPratica.pratica.step !== 3))
        );
      };

      this.isCompletaAbilitato = function() {
        return self.getIsStatoCorretto() && self.documentiFirmati;
      };

      this.getIsStatoCorretto = function() {
        return (
            self.datiPratica &&
            ((self.datiPratica.stato === CONSTANTS.STATO_PRATICA.CONSOLIDATA && self.datiPratica.step === 3) ||
                (self.datiPratica.stato === CONSTANTS.STATO_PRATICA.CONSOLIDATA && self.datiPratica.step === 6) ||
                (self.datiPratica.stato === CONSTANTS.STATO_PRATICA.PRESENTATA && self.datiPratica.step === 1) ||
                (self.datiPratica.stato === CONSTANTS.STATO_PRATICA.PRESENTATA && self.datiPratica.step === 2) ||
                (self.datiPratica.stato === CONSTANTS.STATO_PRATICA.PRESENTATA && self.datiPratica.step === 3))
        );
      };


      /**CAMBIARE A DefinizioneSrvc
       * @ngdoc method
       * @name promiseRecuperaContiCorrenti
       * @methodOf cbl.telepass.wa.directive:TlpsPropostaSrvc
       * @description Effettua una chiamata http per recuperare i conti correnti dell'ndg
       * @return {Promise} - Ritorna una promise contenente la lista dei conti correnti
       */
      this.promiseRecuperaContiCorrenti = function (ndg) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.CONTOCORRENTE.RICERCA_CONTICORRENTE,
          params: { ndg: ndg }
        });
      };

      this.indietro = function () {
        self.messaggiFctr.resetMessages();

        var pratica = self.buildRequestObject();

        self.pulisciDati(pratica);

        self.spinner.showSpinner = true;

        self
          .promiseAggiornaPraticaIndietro(pratica.idPratica, pratica)
          .then(
            function (response) {
              if (response.data.result) {
                // Sostituisco i dati della pratica con quelli aggiornati che mi ritornano i servizi
                self.datiPratica = response.data.result;
                self.$stateParams.idPratica = self.idPratica = response.data.result.idPratica;

                if (self.datiPratica.settore === 'VIACARD') {
                  self.datiPratica.modalitaRitiro = {
                    codice: 'S'
                  };
                }
                self.generaTabs();
              }
            },
            function (error) {
              if (self.messaggiFctr.processaResponse(error)) {
                self.spinner.showSpinner = false;
                return;
              }
            }
          )
          .finally(function () {
            self.spinner.showSpinner = false;
          });
      };

      this.pulisciDati = function (pratica) {
        // Se il prodotto è viacard elimino i dati non necessari
        if (pratica.settore === 'VIACARD') {
          delete pratica.modalitaRitiro;
          delete pratica.opzione;
          delete pratica.codicePromozione;
          delete pratica.twin;
          delete pratica.targa;
          delete pratica.nazioneTarga;
          delete pratica.targaTwin;
          delete pratica.nazioneTargaTwin;
          delete pratica.codiceApparatoTwin;
        }

        if (pratica.settore === 'TELEPASS') {
          delete pratica.numeroCarte;
        }
      };

      /**
       * @ngdoc method
       * @name save
       * @methodOf cbl.telepass.wa:CcpropostaTelepassSrvc
       * @description Esegue le chiamate per salvare la pratica se già esiste altrimenti quella per crearla.
       */
      this.salva = function () {
        self.messaggiFctr.resetMessages();
        if (!self.datiValidi()) {
          return;
        }
        var pratica = self.buildRequestObject();

        self.pulisciDati(pratica);

        self.spinner.showSpinner = true;

        self
          .promiseAggiornaPraticaSalva(self.idPratica, pratica)
          .then(
            function (response) {
              if (self.messaggiFctr.processaResponse(response)) {
                self.spinner.showSpinner = false;
                return;
              }
              if (response.data.result) {
                // Sostituisco i dati della pratica con quelli aggiornati che mi ritornano i servizi
                self.datiPratica = response.data.result;
                self.$stateParams.idPratica = self.idPratica = response.data.result.idPratica;

                if (self.datiPratica.settore === 'VIACARD') {
                  self.datiPratica.modalitaRitiro = {
                    codice: 'S'
                  };
                }
                // Aggiorno i parametri nella URL per poterli mettere a disposizione anche degli altri componenti
                self.$state.go('.', self.idPratica);
                self.generaTabs();
              }
            },
            function (error) {
              if (self.messaggiFctr.processaResponse(error)) {
                self.spinner.showSpinner = false;
                return;
              }
            }
          )
          .finally(function () {
            self.spinner.showSpinner = false;
          });
      };

      this.salvaAvanza = function () {
        var pratica = self.buildRequestObject();

        self.pulisciDati(pratica);

        self.spinner.showSpinner = true;

        self
          .promiseAggiornaPraticaAvanti(pratica.idPratica, pratica)
          .then(
            function (response) {
              if (response.data.result) {
                // Sostituisco i dati della pratica con quelli aggiornati che mi ritornano i servizi
                self.datiPratica = response.data.result;
                self.$stateParams.idPratica = self.idPratica = response.data.result.idPratica;

                if (self.datiPratica.settore === 'VIACARD') {
                  self.datiPratica.modalitaRitiro = {
                    codice: 'S'
                  };
                }

                if (
                  self.datiPratica.stato !== CONSTANTS.STATO_PRATICA.IN_CORSO &&
                  self.datiPratica.stato !== CONSTANTS.STATO_PRATICA.CONSOLIDATA
                ) {
                  var message = {};
                  message.type = 'I';
                  message.message = self.datiPratica.stato === CONSTANTS.STATO_PRATICA.PRESENTATA ? 'Pratica presentata' :
                      'Pratica completata con successo. La pratica è in stato di valutazione in attesa di esito da parte di Telepass';
                  messaggiFctr.addMessage(message);
                  self.goToSchedaCliente();
                } else {
                  self.$state.go('.', self.idPratica);
                  self.generaTabs();
                }
              }
            },
            function (error) {
              if (self.messaggiFctr.processaResponse(error)) {
                self.spinner.showSpinner = false;
                return;
              }
            }
          )
          .finally(function () {
            self.spinner.showSpinner = false;
          });
      };

      this.avanza = function () {
        self.messaggiFctr.resetMessages();
        if (self.datiValidi()) {
          self.salvaAvanza();
        }
      };

      this.buildRequestObject = function () {
        if (self.datiPratica.settore === 'TELEPASS') {
          self.datiPratica.class = 'PraticaTelepassDto';
          self.datiPratica.opzione = JSON.parse(self.datiPratica.opzione);
        } else if (self.datiPratica.settore === 'VIACARD') {
          self.datiPratica.class = 'PraticaViacardDto';
        }
        if (self.datiPratica.dataSottoscrizioneContratto) {
          self.datiPratica.dataSottoscrizioneContratto = new Date(
            self.datiPratica.dataSottoscrizioneContratto
          ).toLocaleDateString();
        }
        return {
          idPratica: self.datiPratica.idPratica,
          class: self.datiPratica.class,
          specializzazione: self.datiPratica.specializzazione,
          numeroCarte: self.datiPratica.numeroCarte,
          intestatario: {
            ndg: self.datiCliente.ndg
          },
          ndgReferente: self.datiPratica.ndgReferente,
          stato: self.datiPratica.stato,
          inserimento: self.datiPratica.inserimento,
          step: self.datiPratica.step,
          prodotto: self.datiProdotto,
          workflow: 'ACQUISTO_BRIO',
          settore: self.datiPratica.settore,
          numeroRapporto: self.datiPratica.numeroRapporto,
          opzione: self.datiPratica.opzione,
          codicePromozione: self.datiPratica.codicePromozione,
          twin: self.datiPratica.twin,
          modalitaRitiro: self.datiPratica.modalitaRitiro,
          datiSpedizione: self.datiPratica.datiSpedizione,
          targa: self.datiPratica.targa,
          nazioneTarga: self.datiPratica.nazioneTarga,
          targaTwin: self.datiPratica.targaTwin,
          nazioneTargaTwin: self.datiPratica.nazioneTargaTwin,
          questionarioPraticaList: self.datiPratica.questionarioPraticaList,
          codiceApparato: self.datiPratica.codiceApparato,
          codiceApparatoTwin: self.datiPratica.codiceApparatoTwin,
          dataSottoscrizioneContratto: self.datiPratica.dataSottoscrizioneContratto
        };
      };

      /**
       * @ngdoc method
       * @name formattazioneData
       * @methodOf cbl.telepass.wa:CcpropostaTelepassSrvc
       * @description Formatta la data per visualizzarla
       */
      this.formattazioneData = function (data) {
        if (!data) {
          return '';
        }

        var giorno = data.dayOfMonth;
        var mese = data.monthValue;
        var anno = data.year;

        return giorno + '/' + mese + '/' + anno;
      };
    }
  ]);
})();


/***/ }),
/* 35 */
/***/ (function(module, exports) {

/**
 * @ngdoc directive
 * @name cbl.telepass.wa.directive:ccQuestionari
 * @restrict E
 * @description Componente che gestisce il terzo step "Valutazione" del dettaglio pratica
 * @param {Object[]} steps - Un array che rappresenta i sotto-step da visualizzare
 * @param {Object} currentStep - Rappresenta il sotto-step attualmente visualizzato
 */
(function() {
  'use strict';
  var TlpsQuestionariCtrl = function(
    $scope,
    $stateParams,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    questionariSrvc,
    propostaTelepassSrvc,
    traslocoTelepassSrvc,
    $state
  ) {
    this.$stateParams = $stateParams;
    this.messaggiFctr = messaggiFctr;
    this.$state = $state;
    this.CONSTANTS = CONSTANTS;

    // Questo componente viene usato sia nella parte di proposta che in quella di trasloco nel post vendita,
    // per poter utilizzare lo stesso componente con metodi e con dati differenti si va a contorllare in quale dei
    // due service sono presenti i dati.
    this.mainSrvc;
    this.propostaTelepassSrvc = propostaTelepassSrvc;
    this.traslocoTelepassSrvc = traslocoTelepassSrvc;
    this.questionariSrvc = questionariSrvc;
    $scope.msg = labelSrvc.getLabel;

    this.ndg;
    this.idProdotto;
    this.idPratica;

    var self = this;

    /**
     * Oggetto contenente la risposta dei servizi
     */
    // this.questionari = null;
    this.risposteQuestionario = {};
    this.risposteObbligatorie = {};
    this.requestQuestionariList = [];
    this.erroriRisposteObbligatorie = [];
    this.numeroDomandeTotali = 0;

    /*
     * -------------------------------------
     * ------ GESTIONE INTERFACCIA ---------
     * -------------------------------------
     */

    /*
     * -------------------------------------
     * GENERAZIONE QUESTIONARI
     * -------------------------------------
     */

    /**
     * @ngdoc method
     * @name creaOggettoRisposteQuestionario
     * @methodOf cbl.telepass.wa.directive:ccQuestionari
     * @description Crea gli oggetti per salvare le risposte e per indicare la obbligatorietà
     * @param {Object} questionario
     */
    this.creaOggettoRisposteQuestionario = function(questionari) {
      self.risposteQuestionario = {};
      self.risposteObbligatorie = {};
      self.numeroDomandeTotali = 0;
      for (var sezione in questionari) {
        for (var domanda in questionari[sezione].questionarioList) {
          self.numeroDomandeTotali++;

          self.risposteQuestionario[
            questionari[sezione].questionarioList[domanda].codice
          ] = null;

          var risposte =
            questionari[sezione].questionarioList[domanda]
              .rispostaQuestionarioList;

          for (var risposta in risposte) {
            var obbligatorio =
              questionari[sezione].questionarioList[domanda]
                .rispostaQuestionarioList[risposta].obbligatorio;

            if (obbligatorio) {
              var codiceDomanda =
                questionari[sezione].questionarioList[domanda].codice;

              var rispostaObbligatoria =
                questionari[sezione].questionarioList[domanda]
                  .rispostaQuestionarioList[risposta].codice;

              self.risposteObbligatorie[codiceDomanda] = rispostaObbligatoria;
            }
          }
        }
      }
      if (self.mainSrvc.datiPratica.questionarioPraticaList) {
        self.rispostePrecedenti();
      }
    };

    /**
     * @ngdoc method
     * @name rispostePrecedenti
     * @methodOf cbl.telepass.wa.directive:tlpsQuestionari
     * @description Gestisce le risposte precedentemente salvate
     */
    this.rispostePrecedenti = function() {
      for (var i in self.mainSrvc.datiPratica.questionarioPraticaList) {
        for (var j in self.risposteQuestionario) {
          if (
            self.mainSrvc.datiPratica.questionarioPraticaList[i].questionario
              .codice === j
          ) {
            self.risposteQuestionario[j] =
              self.mainSrvc.datiPratica.questionarioPraticaList[
                i
              ].rispostaQuestionario.codice;
          }
        }
      }
    };

    /**
     * @ngdoc method
     * @name controllaRisposteObbligatorie
     * @methodOf cbl.telepass.wa.directive:ccQuestionari
     * @description Controlla le risposte obbligatorie
     */
    this.controllaRisposteObbligatorie = function() {
      self.erroriRisposteObbligatorie = [];
      //Se non ci sono risposte obbligatorie
      if (!Object.keys(self.risposteObbligatorie).length) {
        return true;
      }

      //Confronto tra le risposte selezionate e quelle obbligatorie
      var risposteObbligatorieIncomplete = false;
      for (var i in self.risposteQuestionario) {
        for (var j in self.risposteObbligatorie) {
          if (
            i === j &&
            self.risposteQuestionario[i] !== self.risposteObbligatorie[j]
          ) {
            risposteObbligatorieIncomplete = true;
            self.erroriRisposteObbligatorie.push(self.risposteObbligatorie[j]);
          }
        }
      }
      if (risposteObbligatorieIncomplete) {
        messaggiFctr.addMessage({
          type: 'E',
          message: 'Ci sono risposte obbligatorie non selezionate'
        });
        return false;
      }

      if (
        Object.keys(self.risposteQuestionario).filter(function(item) {
          return !!self.risposteQuestionario[item];
        }).length < self.numeroDomandeTotali
      ) {
        messaggiFctr.addMessage({
          type: 'E',
          message: 'Ci sono risposte non selezionate'
        });
        return false;
      }

      return true;
    };

    this.setRisposta = function(domanda, risposta) {
      // Se la risposta era già stata data precedentemente la cerco e la aggiorno
      var rispostaPrecedente = self.requestQuestionariList.find(function(item) {
        return item.questionario.codice === domanda.codice;
      });

      if (rispostaPrecedente) {
        rispostaPrecedente.rispostaQuestionario = risposta;
        return;
      }

      var reqObj = {
        id: null,
        questionario: domanda,
        rispostaQuestionario: risposta
      };

      self.requestQuestionariList.push(reqObj);

      self.mainSrvc.datiPratica.questionarioPraticaList =
        self.requestQuestionariList;
    };

    this.datiValidi = function() {
      return self.controllaRisposteObbligatorie();
    };

    /*
     * -------------------------------------
     *           GESTIONE STILI
     * -------------------------------------
     */

    /**
     * @ngdoc method
     * @name getStyleTabMicro
     * @methodOf cbl.telepass.wa.directive:ccQuestionari
     * @description Imposta lo stile di visualizzazione per gli indicatori dei micro step
     * @param {string} currentStep - Il macro step correntemente visualizzato
     * @param {number} currentTabIndex - L'indice della tab cui applicare lo stile
     * @return {string} - Restituisce lo stile da applicare all'indicatore del micro step
     */
    this.getStyleTabMicro = function(currentTabIndex) {
      if (
        self.mainSrvc.isPraticaNavigabile() ||
        self.questionariSrvc.allSurveysCompiled
      ) {
        if (self.currentStep && currentTabIndex === self.currentStep.index) {
          return 'ab-step-tabs cliccabile active-read';
        }

        return 'ab-step-tabs cliccabile ab-last-read';
      }

      // Pratica non navigabile
      if (self.currentStep && currentTabIndex < self.currentStep.index) {
        return 'ab-step-tabs';
      }

      if (self.currentStep && currentTabIndex === self.currentStep.index) {
        return 'ab-step-tabs active';
      }

      return 'ab-step-tabs ab-last';
    };

    /**
     * @ngdoc method
     * @name getStyleStepMicro
     * @methodOf cbl.telepass.wa.directive:ccQuestionari
     * @description Imposta lo stile di visualizzazione per la barra dell'indicatore del micro step
     * @param {string} currentStep - Il macro step correntemente visualizzato
     * @param {number} currentTabIndex - L'indice della tab cui applicare lo stile
     * @return {string} - Restituisce lo stile da applicare alla barra dell'indicatore del micro step
     */
    this.getStyleStepMicro = function(currentTabIndex) {
      if (self.mainSrvc.isPraticaNavigabile()) {
        return 'step read';
      }

      if (self.currentStep && currentTabIndex < self.currentStep.index) {
        return 'step success';
      }

      return 'step';
    };

    /*
     * -------------------------------------
     *           METODI INIT
     * -------------------------------------
     */

    this.selectCurrentService = function() {
      if (!!self.propostaTelepassSrvc.datiPratica) {
        return self.propostaTelepassSrvc;
      }

      if (!!self.traslocoTelepassSrvc.datiPratica) {
        return self.traslocoTelepassSrvc;
      }

      return null;
    };

    this.init = function() {
      self.ndg = self.$stateParams.ndg;
      self.idProdotto = self.$stateParams.idProdotto;
      self.idPratica = self.$stateParams.idPratica;
      // messaggiFctr.resetMessages();

      self.mainSrvc = self.selectCurrentService();

      // Assegno la funzione di validazione
      self.mainSrvc.datiValidi = self.datiValidi;

      self.mainSrvc.spinner.showSpinner = true;

      self.requestQuestionariList =
        self.mainSrvc.datiPratica.questionarioPraticaList;

      self.questionariSrvc
        .promiseDettaglioQuestionario('IT', self.mainSrvc.datiPratica.settore)
        .then(
          function(response) {
            if (self.messaggiFctr.processaResponse(response)) {
              self.mainSrvc.spinner.showSpinner = false;
              return;
            }
            self.questionari = response.data.result;
            self.creaOggettoRisposteQuestionario(self.questionari);
          },
          function(reason) {
            if (self.messaggiFctr.processaResponse(reason)) {
              self.mainSrvc.spinner.showSpinner = false;

              return;
            }
          }
        )
        .finally(function() {
          self.mainSrvc.spinner.showSpinner = false;
        });
    };

    /*
     * -------------------------------------
     *           INIZIALIZZAZIONE
     * -------------------------------------
     */

    self.init();
  };

  TlpsQuestionariCtrl.$inject = [
    '$scope',
    '$stateParams',
    'TLPS_CONSTANTS',
    'TlpsLabelSrvc',
    'TlpsMessaggiFctr',
    'TlpsQuestionariSrvc',
    'TlpsPropostaSrvc',
    'TlpsTraslocoTelepassSrvc',
    '$state'
  ];

  var TemplateUrl = function(CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'tlpsProposta/tlpsQuestionari/tlpsQuestionari.html'
    );
  };

  TemplateUrl.$inject = ['TLPS_CONSTANTS'];

  var TlpsQuestionariComponent = {
    bindings: {},
    controller: TlpsQuestionariCtrl,
    controllerAs: 'questionariCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.telepass.wa')
    .component('tlpsQuestionari', TlpsQuestionariComponent);
})();


/***/ }),
/* 36 */
/***/ (function(module, exports) {

/**
 * @ngdoc service
 * @name cbl.telepass.wa.directive:ccQuestionariSrvc
 * @restrict E
 * @scope
 * @description Servizio che gestisce il processo di creazione nuova pratica e
 *              visualizzazione pratica esistente
 */
(function() {
  angular.module('cbl.telepass.wa').service('TlpsQuestionariSrvc', [
    '$http',
    'TLPS_CONSTANTS',
    function($http, CONSTANTS) {
      this.$http = $http;

      var self = this;

      /**
       * @ngdoc method
       * @name promiseDettaglioQuestionario
       * @methodOf cbl.telepass.wa.directive:TlpsPropostaSrvc
       * @description Effettua una chiamata http per recuperare i dettagli della pratica
       * @return {Promise} - Ritorna una promise contenente i dettagli della pratica
       */
      this.promiseDettaglioQuestionario = function(lingua, settore) {
        // this.spinner.pratica = true;
        var qryParams = {};
        if (settore && lingua) {
          qryParams.settore = settore;
          qryParams.lingua = lingua;
        }

        return self.$http({
          method: 'GET',
          url:
            CONSTANTS.REST_ROOT +
            CONSTANTS.REST.QUESTIONARI.RECUPERA_QUESTIONARI,
          params: qryParams
        });
      };
    }
  ]);
})();


/***/ }),
/* 37 */
/***/ (function(module, exports) {

/**
 *
 */
(function() {
  'use strict';
  angular.module('cbl.telepass.wa.directives', ['cbl.common']);
})();


/***/ }),
/* 38 */
/***/ (function(module, exports) {

/**
 *
 */
(function() {
  'use strict';
  angular.module('cbl.common').directive('tlpsNumeric', [
    '$parse',
    '$filter',
    function($parse, $filter) {
      return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, elem, attrs, ctrl) {
          var maxValue = attrs.tlpsMax;
          var minValue = attrs.tlpsMin;
          var precision = attrs.tlpsPrecisione
            ? attrs.tlpsPrecisione.split(',')
            : null;
          if (precision) {
            if (
              precision.length < 2 ||
              parseFloat(precision[0]) === NaN ||
              parseFloat(precision[1]) === NaN
            ) {
              precision = null;
            }
          }
          var integerValue = attrs.tlpsInt === '';

          // For DOM -> model validation
          ctrl.$parsers.unshift(function(value) {
            if (!value || value === '') {
              return value;
            }
            value = manipolaNumerico(value);
            // comma to decimal
            value = value
              ? value
                  .toString()
                  .trim()
                  .replace('.', '')
                  .replace(',', '.')
              : null;
            if (maxValue) {
              maxValue = maxValue.replace(',', '.');
              // controllo su valore massimo
              ctrl.$setValidity(
                'tlpsMax',
                !(parseFloat(value) > parseFloat(maxValue))
              );
            }
            if (minValue) {
              minValue = minValue.replace(',', '.');
              // controllo su valore minimo
              ctrl.$setValidity(
                'tlpsMin',
                !(parseFloat(value) < parseFloat(minValue))
              );
            }

            return parseFloat(value);
          });

          // For model -> DOM validation

          ctrl.$formatters.unshift(function(value) {
            if (!value || value === '') {
              return value;
            }
            // decimal to comma
            value = value ? value.toString().replace('.', ',') : null;
            value = manipolaNumerico(value);
            if (maxValue) {
              maxValue = maxValue.replace('.', ',');
              // controllo su valore massimo
              ctrl.$setValidity(
                'tlpsMax',
                !(parseFloat(value) > parseFloat(maxValue))
              );
            }
            if (minValue) {
              minValue = minValue.replace('.', ',');
              // controllo su valore minimo
              ctrl.$setValidity(
                'tlpsMin',
                !(parseFloat(value) < parseFloat(minValue))
              );
            }

            // formatta migliaia
            // var splitedValue = value.split(',');
            // var counter = 0;
            // for (var i = splitedValue[0].length - 1; i >= 1; i--) {
            //     counter++;
            //     if (counter % 3 == 0) {
            //         splitedValue[0] = splitedValue[0].slice(0, i) + '.' + splitedValue[0].slice(i);
            //     }
            // }
            // value = splitedValue[0] + (splitedValue.length === 1 ? '' : (',' + splitedValue[1]));

            return value;
          });

          var manipolaNumerico = function(value) {
            if (!value) {
              return value;
            }
            var validi;
            if (integerValue) {
              validi = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
            } else {
              validi = [
                '0',
                '1',
                '2',
                '3',
                '4',
                '5',
                '6',
                '7',
                '8',
                '9',
                ',',
                '-'
              ];
            }

            var lung = value.length;
            for (var i = lung - 1; i >= 0; i--) {
              var ch = value.charAt(i);
              if (i !== 0 && ch === '-') {
                // rimuovo il segno negativo se non
                // è all'inizio
                value = value.substring(0, i) + value.substring(i + 1);
                continue;
              }
              var valoreValido = false;
              for (var j in validi) {
                if (ch === validi[j]) {
                  valoreValido = true;

                  break;
                }
              }
              if (!valoreValido) {
                value = value.substring(0, i) + value.substring(i + 1);
              }
            }
            if (precision) {
              var splittedValue = value.split(',');
              var decimalsAllowed = precision[1].length;
              if (
                splittedValue[1] &&
                splittedValue[1].length > decimalsAllowed
              ) {
                splittedValue[1] = splittedValue[1].slice(0, decimalsAllowed);

                value = splittedValue.join(',');
              }
            }

            return value;
          };

          elem.on('keyup', function(data) {
            var start = this.selectionStart,
              end = this.selectionEnd;
            var value = this.value;

            this.value = manipolaNumerico(value);
            this.setSelectionRange(start, end);
          });
        }
      };
    }
  ]);
})();


/***/ }),
/* 39 */
/***/ (function(module, exports) {

(function() {
  'use strict';
  angular.module('cbl.telepass.wa.directives').directive('tlpsSpinnerDrct', [
    'TLPS_CONSTANTS',
    function(CONSTANTS) {
      var link = function(scope, elem, attrs, model) {};

      var controller = function($scope) {
        this.getSpinnerUrl = function() {
          var url = null;
          var currentScope = $scope;
          do {
            url = currentScope.srcSpinner;
            currentScope = currentScope.$parent;
          } while (url === undefined && currentScope !== null);
          return url;
          // return 'http://filiale-etica.preproduzione.cabel.net/CBL-BRIO-WA/common/assets/css/style/etica/img/ring-alt.gif';
        };
      };

      controller.$inject = ['$scope'];
      return {
        restrict: 'E',
        scope: {},
        templateUrl:
          CONSTANTS.BASE_ROOT + 'widgets/tlpsSpinner/tlpsSpinner.html',
        controller: controller,
        controllerAs: 'spinner',
        link: link
      };
    }
  ]);
})();


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module
 */
__webpack_require__(1);

/**
 * Constants
 */
__webpack_require__(0);

/**
 * Directives
 */
__webpack_require__(38);
__webpack_require__(37);
__webpack_require__(39);

/**
 * Components
 */
__webpack_require__(33);
__webpack_require__(34);
__webpack_require__(28);
__webpack_require__(29);
__webpack_require__(30);
__webpack_require__(27);
__webpack_require__(35);
__webpack_require__(36);
__webpack_require__(31);
__webpack_require__(32);

__webpack_require__(9);
__webpack_require__(10);
__webpack_require__(11);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(18);
__webpack_require__(12);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(15);

__webpack_require__(21);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(25);
__webpack_require__(26);
__webpack_require__(23);
__webpack_require__(24);
__webpack_require__(22);

/**
 * Services
 */
__webpack_require__(5);
__webpack_require__(7);
__webpack_require__(4);
__webpack_require__(8);
__webpack_require__(6);

/**
 * Run
 */
__webpack_require__(3);

/**
 * Config
 */
__webpack_require__(2);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app.bundle.min.js